import { defineComponent as Ri, computed as Bi, h as Ti } from "vue";
function Ei(e, a) {
  const n = {};
  for (const r of a)
    Object.hasOwn(e, r) && (n[r] = e[r]);
  return n;
}
var i = /* @__PURE__ */ ((e) => (e.AED = "AED", e.AFN = "AFN", e.ALL = "ALL", e.AMD = "AMD", e.ANG = "ANG", e.AOA = "AOA", e.ARS = "ARS", e.AUD = "AUD", e.AWG = "AWG", e.AZN = "AZN", e.BAM = "BAM", e.BBD = "BBD", e.BDT = "BDT", e.BGN = "BGN", e.BHD = "BHD", e.BIF = "BIF", e.BMD = "BMD", e.BND = "BND", e.BOB = "BOB", e.BRL = "BRL", e.BSD = "BSD", e.BTN = "BTN", e.BWP = "BWP", e.BYN = "BYN", e.BYR = "BYR", e.BZD = "BZD", e.CAD = "CAD", e.CDF = "CDF", e.CHF = "CHF", e.CLF = "CLF", e.CLP = "CLP", e.CNY = "CNY", e.COP = "COP", e.CRC = "CRC", e.CUC = "CUC", e.CUP = "CUP", e.CVE = "CVE", e.CZK = "CZK", e.DJF = "DJF", e.DKK = "DKK", e.DOP = "DOP", e.DZD = "DZD", e.EEK = "EEK", e.EGP = "EGP", e.ERN = "ERN", e.ETB = "ETB", e.EUR = "EUR", e.FJD = "FJD", e.FKP = "FKP", e.GBP = "GBP", e.GEL = "GEL", e.GHS = "GHS", e.GIP = "GIP", e.GMD = "GMD", e.GNF = "GNF", e.GTQ = "GTQ", e.GYD = "GYD", e.HKD = "HKD", e.HNL = "HNL", e.HRK = "HRK", e.HTG = "HTG", e.HUF = "HUF", e.IDR = "IDR", e.ILS = "ILS", e.INR = "INR", e.IQD = "IQD", e.IRR = "IRR", e.ISK = "ISK", e.JMD = "JMD", e.JOD = "JOD", e.JPY = "JPY", e.KES = "KES", e.KGS = "KGS", e.KHR = "KHR", e.KMF = "KMF", e.KPW = "KPW", e.KRW = "KRW", e.KWD = "KWD", e.KYD = "KYD", e.KZT = "KZT", e.LAK = "LAK", e.LBP = "LBP", e.LKR = "LKR", e.LRD = "LRD", e.LSL = "LSL", e.LTL = "LTL", e.LVL = "LVL", e.LYD = "LYD", e.MAD = "MAD", e.MDL = "MDL", e.MGA = "MGA", e.MKD = "MKD", e.MMK = "MMK", e.MNT = "MNT", e.MOP = "MOP", e.MRO = "MRO", e.MRU = "MRU", e.MUR = "MUR", e.MVR = "MVR", e.MWK = "MWK", e.MXN = "MXN", e.MYR = "MYR", e.MZN = "MZN", e.NAD = "NAD", e.NGN = "NGN", e.NIO = "NIO", e.NOK = "NOK", e.NPR = "NPR", e.NZD = "NZD", e.OMR = "OMR", e.PAB = "PAB", e.PEN = "PEN", e.PGK = "PGK", e.PHP = "PHP", e.PKR = "PKR", e.PLN = "PLN", e.PYG = "PYG", e.QAR = "QAR", e.RON = "RON", e.RSD = "RSD", e.RUB = "RUB", e.RWF = "RWF", e.SAR = "SAR", e.SBD = "SBD", e.SCR = "SCR", e.SDG = "SDG", e.SEK = "SEK", e.SGD = "SGD", e.SHP = "SHP", e.SLL = "SLL", e.SOS = "SOS", e.SRD = "SRD", e.SSP = "SSP", e.STD = "STD", e.SYP = "SYP", e.SZL = "SZL", e.THB = "THB", e.TJS = "TJS", e.TMT = "TMT", e.TND = "TND", e.TOP = "TOP", e.TRY = "TRY", e.TTD = "TTD", e.TWD = "TWD", e.TZS = "TZS", e.UAH = "UAH", e.UGX = "UGX", e.USD = "USD", e.UYU = "UYU", e.UZS = "UZS", e.VEF = "VEF", e.VES = "VES", e.VND = "VND", e.VUV = "VUV", e.WST = "WST", e.XAF = "XAF", e.XCD = "XCD", e.XOF = "XOF", e.XPF = "XPF", e.YER = "YER", e.ZAR = "ZAR", e.ZMK = "ZMK", e.ZMW = "ZMW", e.ZWL = "ZWL", e))(i || {});
const Wa = {
  AED: {
    code: "AED",
    decimalDigits: 2,
    name: "United Arab Emirates Dirham",
    namePlural: "UAE dirhams",
    rounding: 0,
    symbol: "AED",
    symbolNative: "د.إ.‏",
    zeroDecimal: !1
  },
  AFN: {
    code: "AFN",
    decimalDigits: 0,
    name: "Afghan Afghani",
    namePlural: "Afghan Afghanis",
    rounding: 0,
    symbol: "Af",
    symbolNative: "؋",
    zeroDecimal: !1
  },
  ALL: {
    code: "ALL",
    decimalDigits: 0,
    name: "Albanian Lek",
    namePlural: "Albanian lekë",
    rounding: 0,
    symbol: "ALL",
    symbolNative: "Lek",
    zeroDecimal: !1
  },
  AMD: {
    code: "AMD",
    decimalDigits: 0,
    name: "Armenian Dram",
    namePlural: "Armenian drams",
    rounding: 0,
    symbol: "AMD",
    symbolNative: "դր.",
    zeroDecimal: !1
  },
  ANG: {
    code: "ANG",
    decimalDigits: 2,
    name: "Netherlands Antillean Guilder",
    namePlural: "Netherlands Antillean guilders",
    rounding: 0,
    symbol: "ANG",
    symbolNative: "NAf.",
    zeroDecimal: !1
  },
  AOA: {
    code: "AOA",
    decimalDigits: 2,
    name: "Angolan Kwanza",
    namePlural: "Angolan kwanzas",
    rounding: 0,
    symbol: "AOA",
    symbolNative: "Kz",
    zeroDecimal: !1
  },
  ARS: {
    code: "ARS",
    decimalDigits: 2,
    name: "Argentine Peso",
    namePlural: "Argentine pesos",
    rounding: 0,
    symbol: "AR$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  AUD: {
    code: "AUD",
    decimalDigits: 2,
    name: "Australian Dollar",
    namePlural: "Australian dollars",
    rounding: 0,
    symbol: "AU$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  AWG: {
    code: "AWG",
    decimalDigits: 2,
    name: "Aruban Florin",
    namePlural: "Aruban florin",
    rounding: 0,
    symbol: "AWG",
    symbolNative: "Afl.",
    zeroDecimal: !1
  },
  AZN: {
    code: "AZN",
    decimalDigits: 2,
    name: "Azerbaijani Manat",
    namePlural: "Azerbaijani manats",
    rounding: 0,
    symbol: "man.",
    symbolNative: "ман.",
    zeroDecimal: !1
  },
  BAM: {
    code: "BAM",
    decimalDigits: 2,
    name: "Bosnia-Herzegovina Convertible Mark",
    namePlural: "Bosnia-Herzegovina convertible marks",
    rounding: 0,
    symbol: "KM",
    symbolNative: "KM",
    zeroDecimal: !1
  },
  BBD: {
    code: "BBD",
    decimalDigits: 2,
    name: "Barbadian Dollar",
    namePlural: "Barbadian dollars",
    rounding: 0,
    symbol: "BBD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BDT: {
    code: "BDT",
    decimalDigits: 2,
    name: "Bangladeshi Taka",
    namePlural: "Bangladeshi takas",
    rounding: 0,
    symbol: "Tk",
    symbolNative: "৳",
    zeroDecimal: !1
  },
  BGN: {
    code: "BGN",
    decimalDigits: 2,
    name: "Bulgarian Lev",
    namePlural: "Bulgarian leva",
    rounding: 0,
    symbol: "BGN",
    symbolNative: "лв.",
    zeroDecimal: !1
  },
  BHD: {
    code: "BHD",
    decimalDigits: 3,
    name: "Bahraini Dinar",
    namePlural: "Bahraini dinars",
    rounding: 0,
    symbol: "BD",
    symbolNative: "د.ب.‏",
    zeroDecimal: !1
  },
  BIF: {
    code: "BIF",
    decimalDigits: 0,
    name: "Burundian Franc",
    namePlural: "Burundian francs",
    rounding: 0,
    symbol: "FBu",
    symbolNative: "FBu",
    zeroDecimal: !0
  },
  BMD: {
    code: "BMD",
    decimalDigits: 2,
    name: "Bermudan Dollar",
    namePlural: "Bermudan dollars",
    rounding: 0,
    symbol: "BMD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BND: {
    code: "BND",
    decimalDigits: 2,
    name: "Brunei Dollar",
    namePlural: "Brunei dollars",
    rounding: 0,
    symbol: "BN$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BOB: {
    code: "BOB",
    decimalDigits: 2,
    name: "Bolivian Boliviano",
    namePlural: "Bolivian bolivianos",
    rounding: 0,
    symbol: "Bs",
    symbolNative: "Bs",
    zeroDecimal: !1
  },
  BRL: {
    code: "BRL",
    decimalDigits: 2,
    name: "Brazilian Real",
    namePlural: "Brazilian reals",
    rounding: 0,
    symbol: "R$",
    symbolNative: "R$",
    zeroDecimal: !1
  },
  BSD: {
    code: "BSD",
    decimalDigits: 2,
    name: "Bahamian Dollar",
    namePlural: "Bahamian dollars",
    rounding: 0,
    symbol: "BSD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BTN: {
    code: "BTN",
    decimalDigits: 2,
    name: "Bhutanese Ngultrum",
    namePlural: "Bhutanese ngultrums",
    rounding: 0,
    symbol: "BTN",
    symbolNative: "Nu.",
    zeroDecimal: !1
  },
  BWP: {
    code: "BWP",
    decimalDigits: 2,
    name: "Botswanan Pula",
    namePlural: "Botswanan pulas",
    rounding: 0,
    symbol: "BWP",
    symbolNative: "P",
    zeroDecimal: !1
  },
  BYN: {
    code: "BYN",
    decimalDigits: 2,
    name: "Belarusian Ruble",
    namePlural: "Belarusian rubles",
    rounding: 0,
    symbol: "Br",
    symbolNative: "руб.",
    zeroDecimal: !1
  },
  BYR: {
    code: "BYR",
    decimalDigits: 0,
    deprecated: !0,
    name: "Belarusian Ruble",
    namePlural: "Belarusian rubles",
    rounding: 0,
    symbol: "BYR",
    symbolNative: "BYR",
    zeroDecimal: !1
  },
  BZD: {
    code: "BZD",
    decimalDigits: 2,
    name: "Belize Dollar",
    namePlural: "Belize dollars",
    rounding: 0,
    symbol: "BZ$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CAD: {
    code: "CAD",
    decimalDigits: 2,
    name: "Canadian Dollar",
    namePlural: "Canadian dollars",
    rounding: 0,
    symbol: "CA$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CDF: {
    code: "CDF",
    decimalDigits: 2,
    name: "Congolese Franc",
    namePlural: "Congolese francs",
    rounding: 0,
    symbol: "CDF",
    symbolNative: "FrCD",
    zeroDecimal: !1
  },
  CHF: {
    code: "CHF",
    decimalDigits: 2,
    name: "Swiss Franc",
    namePlural: "Swiss francs",
    rounding: 0.05,
    symbol: "CHF",
    symbolNative: "CHF",
    zeroDecimal: !1
  },
  CLF: {
    code: "CLF",
    decimalDigits: 4,
    deprecated: !0,
    name: "Chilean Unit of Account (UF)",
    namePlural: "Chilean units of account (UF)",
    rounding: 0,
    symbol: "CLF",
    symbolNative: "CLF",
    zeroDecimal: !1
  },
  CLP: {
    code: "CLP",
    decimalDigits: 0,
    name: "Chilean Peso",
    namePlural: "Chilean pesos",
    rounding: 0,
    symbol: "CL$",
    symbolNative: "$",
    zeroDecimal: !0
  },
  CNY: {
    code: "CNY",
    decimalDigits: 2,
    name: "Chinese Yuan",
    namePlural: "Chinese yuan",
    rounding: 0,
    symbol: "CN¥",
    symbolNative: "CN¥",
    zeroDecimal: !1
  },
  COP: {
    code: "COP",
    decimalDigits: 0,
    name: "Colombian Peso",
    namePlural: "Colombian pesos",
    rounding: 0,
    symbol: "CO$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CRC: {
    code: "CRC",
    decimalDigits: 0,
    name: "Costa Rican Colón",
    namePlural: "Costa Rican colóns",
    rounding: 0,
    symbol: "₡",
    symbolNative: "₡",
    zeroDecimal: !1
  },
  CUC: {
    code: "CUC",
    decimalDigits: 2,
    name: "Cuban Convertible Peso",
    namePlural: "Cuban convertible pesos",
    rounding: 0,
    symbol: "CUC",
    symbolNative: "CUC",
    zeroDecimal: !1
  },
  CUP: {
    code: "CUP",
    decimalDigits: 2,
    name: "Cuban Peso",
    namePlural: "Cuban pesos",
    rounding: 0,
    symbol: "CUP",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CVE: {
    code: "CVE",
    decimalDigits: 2,
    name: "Cape Verdean Escudo",
    namePlural: "Cape Verdean escudos",
    rounding: 0,
    symbol: "CV$",
    symbolNative: "CV$",
    zeroDecimal: !1
  },
  CZK: {
    code: "CZK",
    decimalDigits: 2,
    name: "Czech Republic Koruna",
    namePlural: "Czech Republic korunas",
    rounding: 0,
    symbol: "Kč",
    symbolNative: "Kč",
    zeroDecimal: !1
  },
  DJF: {
    code: "DJF",
    decimalDigits: 0,
    name: "Djiboutian Franc",
    namePlural: "Djiboutian francs",
    rounding: 0,
    symbol: "Fdj",
    symbolNative: "Fdj",
    zeroDecimal: !0
  },
  DKK: {
    code: "DKK",
    decimalDigits: 2,
    name: "Danish Krone",
    namePlural: "Danish kroner",
    rounding: 0,
    symbol: "Dkr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  DOP: {
    code: "DOP",
    decimalDigits: 2,
    name: "Dominican Peso",
    namePlural: "Dominican pesos",
    rounding: 0,
    symbol: "RD$",
    symbolNative: "RD$",
    zeroDecimal: !1
  },
  DZD: {
    code: "DZD",
    decimalDigits: 2,
    name: "Algerian Dinar",
    namePlural: "Algerian dinars",
    rounding: 0,
    symbol: "DA",
    symbolNative: "د.ج.‏",
    zeroDecimal: !1
  },
  EEK: {
    code: "EEK",
    decimalDigits: 2,
    deprecated: !0,
    name: "Estonian Kroon",
    namePlural: "Estonian kroons",
    rounding: 0,
    symbol: "Ekr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  EGP: {
    code: "EGP",
    decimalDigits: 2,
    name: "Egyptian Pound",
    namePlural: "Egyptian pounds",
    rounding: 0,
    symbol: "EGP",
    symbolNative: "ج.م.‏",
    zeroDecimal: !1
  },
  ERN: {
    code: "ERN",
    decimalDigits: 2,
    name: "Eritrean Nakfa",
    namePlural: "Eritrean nakfas",
    rounding: 0,
    symbol: "Nfk",
    symbolNative: "Nfk",
    zeroDecimal: !1
  },
  ETB: {
    code: "ETB",
    decimalDigits: 2,
    name: "Ethiopian Birr",
    namePlural: "Ethiopian birrs",
    rounding: 0,
    symbol: "Br",
    symbolNative: "Br",
    zeroDecimal: !1
  },
  EUR: {
    code: "EUR",
    decimalDigits: 2,
    name: "Euro",
    namePlural: "euros",
    rounding: 0,
    symbol: "€",
    symbolNative: "€",
    zeroDecimal: !1
  },
  FJD: {
    code: "FJD",
    decimalDigits: 2,
    name: "Fijian Dollar",
    namePlural: "Fijian dollars",
    rounding: 0,
    symbol: "FJD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  FKP: {
    code: "FKP",
    decimalDigits: 2,
    name: "Falkland Islands Pound",
    namePlural: "Falkland Islands pounds",
    rounding: 0,
    symbol: "FKP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GBP: {
    code: "GBP",
    decimalDigits: 2,
    name: "British Pound Sterling",
    namePlural: "British pounds sterling",
    rounding: 0,
    symbol: "£",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GEL: {
    code: "GEL",
    decimalDigits: 2,
    name: "Georgian Lari",
    namePlural: "Georgian laris",
    rounding: 0,
    symbol: "GEL",
    symbolNative: "GEL",
    zeroDecimal: !1
  },
  GHS: {
    code: "GHS",
    decimalDigits: 2,
    name: "Ghanaian Cedi",
    namePlural: "Ghanaian cedis",
    rounding: 0,
    symbol: "GH₵",
    symbolNative: "GH₵",
    zeroDecimal: !1
  },
  GIP: {
    code: "GIP",
    decimalDigits: 2,
    name: "Gibraltar Pound",
    namePlural: "Gibraltar pounds",
    rounding: 0,
    symbol: "GIP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GMD: {
    code: "GMD",
    decimalDigits: 2,
    name: "Gambian Dalasi",
    namePlural: "Gambian dalasis",
    rounding: 0,
    symbol: "GMD",
    symbolNative: "D",
    zeroDecimal: !1
  },
  GNF: {
    code: "GNF",
    decimalDigits: 0,
    name: "Guinean Franc",
    namePlural: "Guinean francs",
    rounding: 0,
    symbol: "FG",
    symbolNative: "FG",
    zeroDecimal: !0
  },
  GTQ: {
    code: "GTQ",
    decimalDigits: 2,
    name: "Guatemalan Quetzal",
    namePlural: "Guatemalan quetzals",
    rounding: 0,
    symbol: "GTQ",
    symbolNative: "Q",
    zeroDecimal: !1
  },
  GYD: {
    code: "GYD",
    decimalDigits: 0,
    name: "Guyanaese Dollar",
    namePlural: "Guyanaese dollars",
    rounding: 0,
    symbol: "GYD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  HKD: {
    code: "HKD",
    decimalDigits: 2,
    name: "Hong Kong Dollar",
    namePlural: "Hong Kong dollars",
    rounding: 0,
    symbol: "HK$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  HNL: {
    code: "HNL",
    decimalDigits: 2,
    name: "Honduran Lempira",
    namePlural: "Honduran lempiras",
    rounding: 0,
    symbol: "HNL",
    symbolNative: "L",
    zeroDecimal: !1
  },
  HRK: {
    code: "HRK",
    decimalDigits: 2,
    deprecated: !0,
    name: "Croatian Kuna",
    namePlural: "Croatian kunas",
    rounding: 0,
    symbol: "kn",
    symbolNative: "kn",
    zeroDecimal: !1
  },
  HTG: {
    code: "HTG",
    decimalDigits: 2,
    name: "Haitian Gourde",
    namePlural: "Haitian gourdes",
    rounding: 0,
    symbol: "HTG",
    symbolNative: "G",
    zeroDecimal: !1
  },
  HUF: {
    code: "HUF",
    decimalDigits: 0,
    name: "Hungarian Forint",
    namePlural: "Hungarian forints",
    rounding: 0,
    symbol: "Ft",
    symbolNative: "Ft",
    zeroDecimal: !1
  },
  IDR: {
    code: "IDR",
    decimalDigits: 0,
    name: "Indonesian Rupiah",
    namePlural: "Indonesian rupiahs",
    rounding: 0,
    symbol: "Rp",
    symbolNative: "Rp",
    zeroDecimal: !1
  },
  ILS: {
    code: "ILS",
    decimalDigits: 2,
    name: "Israeli New Sheqel",
    namePlural: "Israeli new sheqels",
    rounding: 0,
    symbol: "₪",
    symbolNative: "₪",
    zeroDecimal: !1
  },
  INR: {
    code: "INR",
    decimalDigits: 2,
    name: "Indian Rupee",
    namePlural: "Indian rupees",
    rounding: 0,
    symbol: "Rs",
    symbolNative: "টকা",
    zeroDecimal: !1
  },
  IQD: {
    code: "IQD",
    decimalDigits: 0,
    name: "Iraqi Dinar",
    namePlural: "Iraqi dinars",
    rounding: 0,
    symbol: "IQD",
    symbolNative: "د.ع.‏",
    zeroDecimal: !1
  },
  IRR: {
    code: "IRR",
    decimalDigits: 0,
    name: "Iranian Rial",
    namePlural: "Iranian rials",
    rounding: 0,
    symbol: "IRR",
    symbolNative: "﷼",
    zeroDecimal: !0
  },
  ISK: {
    code: "ISK",
    decimalDigits: 0,
    name: "Icelandic Króna",
    namePlural: "Icelandic krónur",
    rounding: 0,
    symbol: "Ikr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  JMD: {
    code: "JMD",
    decimalDigits: 2,
    name: "Jamaican Dollar",
    namePlural: "Jamaican dollars",
    rounding: 0,
    symbol: "J$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  JOD: {
    code: "JOD",
    decimalDigits: 3,
    name: "Jordanian Dinar",
    namePlural: "Jordanian dinars",
    rounding: 0,
    symbol: "JD",
    symbolNative: "د.أ.‏",
    zeroDecimal: !1
  },
  JPY: {
    code: "JPY",
    decimalDigits: 0,
    name: "Japanese Yen",
    namePlural: "Japanese yen",
    rounding: 0,
    symbol: "¥",
    symbolNative: "￥",
    zeroDecimal: !0
  },
  KES: {
    code: "KES",
    decimalDigits: 2,
    name: "Kenyan Shilling",
    namePlural: "Kenyan shillings",
    rounding: 0,
    symbol: "Ksh",
    symbolNative: "Ksh",
    zeroDecimal: !1
  },
  KGS: {
    code: "KGS",
    decimalDigits: 2,
    name: "Kyrgystani Som",
    namePlural: "Kyrgystani soms",
    rounding: 0,
    symbol: "KGS",
    symbolNative: "сом",
    zeroDecimal: !1
  },
  KHR: {
    code: "KHR",
    decimalDigits: 2,
    name: "Cambodian Riel",
    namePlural: "Cambodian riels",
    rounding: 0,
    symbol: "KHR",
    symbolNative: "៛",
    zeroDecimal: !1
  },
  KMF: {
    code: "KMF",
    decimalDigits: 0,
    name: "Comorian Franc",
    namePlural: "Comorian francs",
    rounding: 0,
    symbol: "CF",
    symbolNative: "FC",
    zeroDecimal: !0
  },
  KPW: {
    code: "KPW",
    decimalDigits: 0,
    name: "North Korean Won",
    namePlural: "North Korean won",
    rounding: 0,
    symbol: "KPW",
    symbolNative: "KPW",
    zeroDecimal: !1
  },
  KRW: {
    code: "KRW",
    decimalDigits: 0,
    name: "South Korean Won",
    namePlural: "South Korean won",
    rounding: 0,
    symbol: "₩",
    symbolNative: "₩",
    zeroDecimal: !0
  },
  KWD: {
    code: "KWD",
    decimalDigits: 3,
    name: "Kuwaiti Dinar",
    namePlural: "Kuwaiti dinars",
    rounding: 0,
    symbol: "KD",
    symbolNative: "د.ك.‏",
    zeroDecimal: !1
  },
  KYD: {
    code: "KYD",
    decimalDigits: 2,
    name: "Cayman Islands Dollar",
    namePlural: "Cayman Islands dollars",
    rounding: 0,
    symbol: "KYD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  KZT: {
    code: "KZT",
    decimalDigits: 2,
    name: "Kazakhstani Tenge",
    namePlural: "Kazakhstani tenges",
    rounding: 0,
    symbol: "KZT",
    symbolNative: "тңг.",
    zeroDecimal: !1
  },
  LAK: {
    code: "LAK",
    decimalDigits: 0,
    name: "Laotian Kip",
    namePlural: "Laotian kips",
    rounding: 0,
    symbol: "LAK",
    symbolNative: "₭",
    zeroDecimal: !1
  },
  LBP: {
    code: "LBP",
    decimalDigits: 0,
    name: "Lebanese Pound",
    namePlural: "Lebanese pounds",
    rounding: 0,
    symbol: "LB£",
    symbolNative: "ل.ل.‏",
    zeroDecimal: !1
  },
  LKR: {
    code: "LKR",
    decimalDigits: 2,
    name: "Sri Lankan Rupee",
    namePlural: "Sri Lankan rupees",
    rounding: 0,
    symbol: "SLRs",
    symbolNative: "SL Re",
    zeroDecimal: !1
  },
  LRD: {
    code: "LRD",
    decimalDigits: 2,
    name: "Liberian Dollar",
    namePlural: "Liberian dollars",
    rounding: 0,
    symbol: "LRD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  LSL: {
    code: "LSL",
    decimalDigits: 2,
    name: "Lesotho Loti",
    namePlural: "Lesotho lotis",
    rounding: 0,
    symbol: "LSL",
    symbolNative: "LSL",
    zeroDecimal: !1
  },
  LTL: {
    code: "LTL",
    decimalDigits: 2,
    deprecated: !0,
    name: "Lithuanian Litas",
    namePlural: "Lithuanian litai",
    rounding: 0,
    symbol: "Lt",
    symbolNative: "Lt",
    zeroDecimal: !1
  },
  LVL: {
    code: "LVL",
    decimalDigits: 2,
    deprecated: !0,
    name: "Latvian Lats",
    namePlural: "Latvian lati",
    rounding: 0,
    symbol: "Ls",
    symbolNative: "Ls",
    zeroDecimal: !1
  },
  LYD: {
    code: "LYD",
    decimalDigits: 3,
    name: "Libyan Dinar",
    namePlural: "Libyan dinars",
    rounding: 0,
    symbol: "LD",
    symbolNative: "د.ل.‏",
    zeroDecimal: !1
  },
  MAD: {
    code: "MAD",
    decimalDigits: 2,
    name: "Moroccan Dirham",
    namePlural: "Moroccan dirhams",
    rounding: 0,
    symbol: "MAD",
    symbolNative: "د.م.‏",
    zeroDecimal: !1
  },
  MDL: {
    code: "MDL",
    decimalDigits: 2,
    name: "Moldovan Leu",
    namePlural: "Moldovan lei",
    rounding: 0,
    symbol: "MDL",
    symbolNative: "MDL",
    zeroDecimal: !1
  },
  MGA: {
    code: "MGA",
    decimalDigits: 0,
    name: "Malagasy Ariary",
    namePlural: "Malagasy Ariaries",
    rounding: 0,
    symbol: "MGA",
    symbolNative: "MGA",
    zeroDecimal: !0
  },
  MKD: {
    code: "MKD",
    decimalDigits: 2,
    name: "Macedonian Denar",
    namePlural: "Macedonian denari",
    rounding: 0,
    symbol: "MKD",
    symbolNative: "MKD",
    zeroDecimal: !1
  },
  MMK: {
    code: "MMK",
    decimalDigits: 0,
    name: "Myanma Kyat",
    namePlural: "Myanma kyats",
    rounding: 0,
    symbol: "MMK",
    symbolNative: "K",
    zeroDecimal: !1
  },
  MNT: {
    code: "MNT",
    decimalDigits: 0,
    name: "Mongolian Tugrik",
    namePlural: "Mongolian tugriks",
    rounding: 0,
    symbol: "MNT",
    symbolNative: "₮",
    zeroDecimal: !1
  },
  MOP: {
    code: "MOP",
    decimalDigits: 2,
    name: "Macanese Pataca",
    namePlural: "Macanese patacas",
    rounding: 0,
    symbol: "MOP$",
    symbolNative: "MOP$",
    zeroDecimal: !1
  },
  MRO: {
    code: "MRO",
    decimalDigits: 0,
    deprecated: !0,
    name: "Mauritanian Ouguiya",
    namePlural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "MRO",
    symbolNative: "أ.م.‏",
    zeroDecimal: !1
  },
  MRU: {
    code: "MRU",
    decimalDigits: 0,
    name: "Mauritanian Ouguiya",
    namePlural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "MRU",
    symbolNative: "أ.م.‏",
    zeroDecimal: !1
  },
  MUR: {
    code: "MUR",
    decimalDigits: 0,
    name: "Mauritian Rupee",
    namePlural: "Mauritian rupees",
    rounding: 0,
    symbol: "MURs",
    symbolNative: "MURs",
    zeroDecimal: !1
  },
  MVR: {
    code: "MVR",
    decimalDigits: 0,
    name: "Maldivian rufiyaa",
    namePlural: "Maldivian rufiyaa",
    rounding: 0,
    symbol: "MVR",
    symbolNative: "Rf",
    zeroDecimal: !1
  },
  MWK: {
    code: "MWK",
    decimalDigits: 2,
    name: "Malawian Kwacha",
    namePlural: "Malawian kwachas",
    rounding: 0,
    symbol: "MWK",
    symbolNative: "MK",
    zeroDecimal: !1
  },
  MXN: {
    code: "MXN",
    decimalDigits: 2,
    name: "Mexican Peso",
    namePlural: "Mexican pesos",
    rounding: 0,
    symbol: "MX$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  MYR: {
    code: "MYR",
    decimalDigits: 2,
    name: "Malaysian Ringgit",
    namePlural: "Malaysian ringgits",
    rounding: 0,
    symbol: "RM",
    symbolNative: "RM",
    zeroDecimal: !1
  },
  MZN: {
    code: "MZN",
    decimalDigits: 2,
    name: "Mozambican Metical",
    namePlural: "Mozambican meticals",
    rounding: 0,
    symbol: "MTn",
    symbolNative: "MTn",
    zeroDecimal: !1
  },
  NAD: {
    code: "NAD",
    decimalDigits: 2,
    name: "Namibian Dollar",
    namePlural: "Namibian dollars",
    rounding: 0,
    symbol: "N$",
    symbolNative: "N$",
    zeroDecimal: !1
  },
  NGN: {
    code: "NGN",
    decimalDigits: 2,
    name: "Nigerian Naira",
    namePlural: "Nigerian nairas",
    rounding: 0,
    symbol: "₦",
    symbolNative: "₦",
    zeroDecimal: !1
  },
  NIO: {
    code: "NIO",
    decimalDigits: 2,
    name: "Nicaraguan Córdoba",
    namePlural: "Nicaraguan córdobas",
    rounding: 0,
    symbol: "C$",
    symbolNative: "C$",
    zeroDecimal: !1
  },
  NOK: {
    code: "NOK",
    decimalDigits: 2,
    name: "Norwegian Krone",
    namePlural: "Norwegian kroner",
    rounding: 0,
    symbol: "Nkr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  NPR: {
    code: "NPR",
    decimalDigits: 2,
    name: "Nepalese Rupee",
    namePlural: "Nepalese rupees",
    rounding: 0,
    symbol: "NPRs",
    symbolNative: "नेरू",
    zeroDecimal: !1
  },
  NZD: {
    code: "NZD",
    decimalDigits: 2,
    name: "New Zealand Dollar",
    namePlural: "New Zealand dollars",
    rounding: 0,
    symbol: "NZ$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  OMR: {
    code: "OMR",
    decimalDigits: 3,
    name: "Omani Rial",
    namePlural: "Omani rials",
    rounding: 0,
    symbol: "OMR",
    symbolNative: "ر.ع.‏",
    zeroDecimal: !1
  },
  PAB: {
    code: "PAB",
    decimalDigits: 2,
    name: "Panamanian Balboa",
    namePlural: "Panamanian balboas",
    rounding: 0,
    symbol: "B/.",
    symbolNative: "B/.",
    zeroDecimal: !1
  },
  PEN: {
    code: "PEN",
    decimalDigits: 2,
    name: "Peruvian Nuevo Sol",
    namePlural: "Peruvian nuevos soles",
    rounding: 0,
    symbol: "S/.",
    symbolNative: "S/.",
    zeroDecimal: !1
  },
  PGK: {
    code: "PGK",
    decimalDigits: 2,
    name: "Papua New Guinean Kina",
    namePlural: "Papua New Guinean kina",
    rounding: 0,
    symbol: "PGK",
    symbolNative: "K",
    zeroDecimal: !1
  },
  PHP: {
    code: "PHP",
    decimalDigits: 2,
    name: "Philippine Peso",
    namePlural: "Philippine pesos",
    rounding: 0,
    symbol: "₱",
    symbolNative: "₱",
    zeroDecimal: !1
  },
  PKR: {
    code: "PKR",
    decimalDigits: 0,
    name: "Pakistani Rupee",
    namePlural: "Pakistani rupees",
    rounding: 0,
    symbol: "PKRs",
    symbolNative: "₨",
    zeroDecimal: !1
  },
  PLN: {
    code: "PLN",
    decimalDigits: 2,
    name: "Polish Zloty",
    namePlural: "Polish zlotys",
    rounding: 0,
    symbol: "zł",
    symbolNative: "zł",
    zeroDecimal: !1
  },
  PYG: {
    code: "PYG",
    decimalDigits: 0,
    name: "Paraguayan Guarani",
    namePlural: "Paraguayan guaranis",
    rounding: 0,
    symbol: "₲",
    symbolNative: "₲",
    zeroDecimal: !0
  },
  QAR: {
    code: "QAR",
    decimalDigits: 2,
    name: "Qatari Rial",
    namePlural: "Qatari rials",
    rounding: 0,
    symbol: "QR",
    symbolNative: "ر.ق.‏",
    zeroDecimal: !1
  },
  RON: {
    code: "RON",
    decimalDigits: 2,
    name: "Romanian Leu",
    namePlural: "Romanian lei",
    rounding: 0,
    symbol: "RON",
    symbolNative: "RON",
    zeroDecimal: !1
  },
  RSD: {
    code: "RSD",
    decimalDigits: 0,
    name: "Serbian Dinar",
    namePlural: "Serbian dinars",
    rounding: 0,
    symbol: "din.",
    symbolNative: "дин.",
    zeroDecimal: !1
  },
  RUB: {
    code: "RUB",
    decimalDigits: 2,
    name: "Russian Ruble",
    namePlural: "Russian rubles",
    rounding: 0,
    symbol: "RUB",
    symbolNative: "₽.",
    zeroDecimal: !1
  },
  RWF: {
    code: "RWF",
    decimalDigits: 0,
    name: "Rwandan Franc",
    namePlural: "Rwandan francs",
    rounding: 0,
    symbol: "RWF",
    symbolNative: "FR",
    zeroDecimal: !0
  },
  SAR: {
    code: "SAR",
    decimalDigits: 2,
    name: "Saudi Riyal",
    namePlural: "Saudi riyals",
    rounding: 0,
    symbol: "SR",
    symbolNative: "ر.س.‏",
    zeroDecimal: !1
  },
  SBD: {
    code: "SBD",
    decimalDigits: 2,
    name: "Solomon Islands Dollar",
    namePlural: "Solomon Islands dollars",
    rounding: 0,
    symbol: "SBD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SCR: {
    code: "SCR",
    decimalDigits: 2,
    name: "Seychellois Rupee",
    namePlural: "Seychellois rupees",
    rounding: 0,
    symbol: "SCR",
    symbolNative: "SR",
    zeroDecimal: !1
  },
  SDG: {
    code: "SDG",
    decimalDigits: 2,
    name: "Sudanese Pound",
    namePlural: "Sudanese pounds",
    rounding: 0,
    symbol: "SDG",
    symbolNative: "SDG",
    zeroDecimal: !1
  },
  SEK: {
    code: "SEK",
    decimalDigits: 2,
    name: "Swedish Krona",
    namePlural: "Swedish kronor",
    rounding: 0,
    symbol: "Skr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  SGD: {
    code: "SGD",
    decimalDigits: 2,
    name: "Singapore Dollar",
    namePlural: "Singapore dollars",
    rounding: 0,
    symbol: "S$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SHP: {
    code: "SHP",
    decimalDigits: 2,
    name: "St. Helena Pound",
    namePlural: "St. Helena pounds",
    rounding: 0,
    symbol: "SHP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  SLL: {
    code: "SLL",
    decimalDigits: 0,
    name: "Sierra Leonean Leone",
    namePlural: "Sierra Leonean leones",
    rounding: 0,
    symbol: "SLL",
    symbolNative: "Le",
    zeroDecimal: !1
  },
  SOS: {
    code: "SOS",
    decimalDigits: 0,
    name: "Somali Shilling",
    namePlural: "Somali shillings",
    rounding: 0,
    symbol: "Ssh",
    symbolNative: "Ssh",
    zeroDecimal: !1
  },
  SRD: {
    code: "SRD",
    decimalDigits: 2,
    name: "Surinamese Dollar",
    namePlural: "Surinamese dollars",
    rounding: 0,
    symbol: "SRD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SSP: {
    code: "SSP",
    decimalDigits: 2,
    deprecated: !0,
    name: "South Sudanese Pound",
    namePlural: "South Sudanese pounds",
    rounding: 0,
    symbol: "SSP",
    symbolNative: "SSP",
    zeroDecimal: !1
  },
  STD: {
    code: "STD",
    decimalDigits: 2,
    name: "Dobra",
    namePlural: "Dobras",
    rounding: 0,
    symbol: "Db",
    symbolNative: "Db",
    zeroDecimal: !1
  },
  SYP: {
    code: "SYP",
    decimalDigits: 0,
    name: "Syrian Pound",
    namePlural: "Syrian pounds",
    rounding: 0,
    symbol: "SY£",
    symbolNative: "ل.س.‏",
    zeroDecimal: !1
  },
  SZL: {
    code: "SZL",
    decimalDigits: 2,
    name: "Swazi Lilangeni",
    namePlural: "Swazi emalangeni",
    rounding: 0,
    symbol: "SZL",
    symbolNative: "E",
    zeroDecimal: !1
  },
  THB: {
    code: "THB",
    decimalDigits: 2,
    name: "Thai Baht",
    namePlural: "Thai baht",
    rounding: 0,
    symbol: "฿",
    symbolNative: "฿",
    zeroDecimal: !1
  },
  TJS: {
    code: "TJS",
    decimalDigits: 2,
    name: "Tajikistani Somoni",
    namePlural: "Tajikistani somonis",
    rounding: 0,
    symbol: "TJS",
    symbolNative: "сом.",
    zeroDecimal: !1
  },
  TMT: {
    code: "TMT",
    decimalDigits: 2,
    name: "Turkmenistan Manat",
    namePlural: "Turkmenistan manats",
    rounding: 0,
    symbol: "TMT",
    symbolNative: "TMT",
    zeroDecimal: !1
  },
  TND: {
    code: "TND",
    decimalDigits: 3,
    name: "Tunisian Dinar",
    namePlural: "Tunisian dinars",
    rounding: 0,
    symbol: "DT",
    symbolNative: "د.ت.‏",
    zeroDecimal: !1
  },
  TOP: {
    code: "TOP",
    decimalDigits: 2,
    name: "Tongan Paʻanga",
    namePlural: "Tongan paʻanga",
    rounding: 0,
    symbol: "T$",
    symbolNative: "T$",
    zeroDecimal: !1
  },
  TRY: {
    code: "TRY",
    decimalDigits: 2,
    name: "Turkish Lira",
    namePlural: "Turkish Lira",
    rounding: 0,
    symbol: "TL",
    symbolNative: "TL",
    zeroDecimal: !1
  },
  TTD: {
    code: "TTD",
    decimalDigits: 2,
    name: "Trinidad and Tobago Dollar",
    namePlural: "Trinidad and Tobago dollars",
    rounding: 0,
    symbol: "TT$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  TWD: {
    code: "TWD",
    decimalDigits: 2,
    name: "New Taiwan Dollar",
    namePlural: "New Taiwan dollars",
    rounding: 0,
    symbol: "NT$",
    symbolNative: "NT$",
    zeroDecimal: !1
  },
  TZS: {
    code: "TZS",
    decimalDigits: 0,
    name: "Tanzanian Shilling",
    namePlural: "Tanzanian shillings",
    rounding: 0,
    symbol: "TSh",
    symbolNative: "TSh",
    zeroDecimal: !1
  },
  UAH: {
    code: "UAH",
    decimalDigits: 2,
    name: "Ukrainian Hryvnia",
    namePlural: "Ukrainian hryvnias",
    rounding: 0,
    symbol: "₴",
    symbolNative: "₴",
    zeroDecimal: !1
  },
  UGX: {
    code: "UGX",
    decimalDigits: 0,
    name: "Ugandan Shilling",
    namePlural: "Ugandan shillings",
    rounding: 0,
    symbol: "USh",
    symbolNative: "USh",
    zeroDecimal: !0
  },
  USD: {
    code: "USD",
    decimalDigits: 2,
    name: "US Dollar",
    namePlural: "US dollars",
    rounding: 0,
    symbol: "$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  UYU: {
    code: "UYU",
    decimalDigits: 2,
    name: "Uruguayan Peso",
    namePlural: "Uruguayan pesos",
    rounding: 0,
    symbol: "$U",
    symbolNative: "$",
    zeroDecimal: !1
  },
  UZS: {
    code: "UZS",
    decimalDigits: 0,
    name: "Uzbekistan Som",
    namePlural: "Uzbekistan som",
    rounding: 0,
    symbol: "UZS",
    symbolNative: "UZS",
    zeroDecimal: !1
  },
  VEF: {
    code: "VEF",
    decimalDigits: 2,
    deprecated: !0,
    name: "Venezuelan Bolívar",
    namePlural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbolNative: "Bs.F.",
    zeroDecimal: !1
  },
  VES: {
    code: "VES",
    decimalDigits: 2,
    name: "Venezuelan Bolívar",
    namePlural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbolNative: "Bs.F.",
    zeroDecimal: !1
  },
  VND: {
    code: "VND",
    decimalDigits: 0,
    name: "Vietnamese Dong",
    namePlural: "Vietnamese dong",
    rounding: 0,
    symbol: "₫",
    symbolNative: "₫",
    zeroDecimal: !0
  },
  VUV: {
    code: "VUV",
    decimalDigits: 0,
    name: "Vanuatu Vatu",
    namePlural: "Vanuatu vatus",
    rounding: 0,
    symbol: "VUV",
    symbolNative: "VT",
    zeroDecimal: !0
  },
  WST: {
    code: "WST",
    decimalDigits: 2,
    name: "Samoan Tala",
    namePlural: "Samoan tala",
    rounding: 0,
    symbol: "WST",
    symbolNative: "WS$",
    zeroDecimal: !1
  },
  XAF: {
    code: "XAF",
    decimalDigits: 0,
    name: "CFA Franc BEAC",
    namePlural: "CFA francs BEAC",
    rounding: 0,
    symbol: "FCFA",
    symbolNative: "FCFA",
    zeroDecimal: !0
  },
  XCD: {
    code: "XCD",
    decimalDigits: 2,
    name: "East Caribbean Dollar",
    namePlural: "East Caribbean dollars",
    rounding: 0,
    symbol: "EC$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  XOF: {
    code: "XOF",
    decimalDigits: 0,
    name: "CFA Franc BCEAO",
    namePlural: "CFA francs BCEAO",
    rounding: 0,
    symbol: "CFA",
    symbolNative: "CFA",
    zeroDecimal: !0
  },
  XPF: {
    code: "XPF",
    decimalDigits: 0,
    name: "CFP Franc",
    namePlural: "CFP francs",
    rounding: 0,
    symbol: "CFPF",
    symbolNative: "FCFP",
    zeroDecimal: !0
  },
  YER: {
    code: "YER",
    decimalDigits: 0,
    name: "Yemeni Rial",
    namePlural: "Yemeni rials",
    rounding: 0,
    symbol: "YR",
    symbolNative: "ر.ي.‏",
    zeroDecimal: !1
  },
  ZAR: {
    code: "ZAR",
    decimalDigits: 2,
    name: "South African Rand",
    namePlural: "South African rand",
    rounding: 0,
    symbol: "R",
    symbolNative: "R",
    zeroDecimal: !1
  },
  ZMK: {
    code: "ZMK",
    decimalDigits: 0,
    name: "Zambian Kwacha",
    namePlural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZK",
    symbolNative: "ZK",
    zeroDecimal: !0
  },
  ZMW: {
    code: "ZMW",
    decimalDigits: 2,
    name: "Zambian Kwacha",
    namePlural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZMW",
    symbolNative: "K",
    zeroDecimal: !1
  },
  ZWL: {
    code: "ZWL",
    decimalDigits: 0,
    name: "Zimbabwean Dollar",
    namePlural: "Zimbabwean Dollar",
    rounding: 0,
    symbol: "ZWL$",
    symbolNative: "ZWL$",
    zeroDecimal: !0
  }
}, Li = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BHD",
  "BGN",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BWP",
  "BZD",
  "CAD",
  "CDF",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CRC",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "GBP",
  "GEL",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRU",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SEK",
  "SGD",
  "SHP",
  "SLL",
  "SOS",
  "SRD",
  "STD",
  "SZL",
  "THB",
  "TJS",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "USD",
  "UYU",
  "UZS",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XCD",
  "XOF",
  "XPF",
  "YER",
  "ZAR",
  "ZMW"
  /* ZMW */
];
Object.values(Wa).filter((e) => !e.deprecated).map((e) => e.code);
const Ir = Ei(Wa, Li);
Object.values(Wa).filter(
  (e) => e.zeroDecimal && e.code in Ir
).map((e) => e.code);
const da = {
  AD: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "376",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AD.png",
    iso2: "AD",
    name: "Andorra",
    priority: 0,
    timezone: "Europe/Andorra"
  },
  AE: {
    areaCodes: null,
    currency: i.AED,
    dialCode: "971",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AE.png",
    iso2: "AE",
    name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    priority: 0,
    timezone: "Asia/Dubai"
  },
  AF: {
    areaCodes: null,
    currency: i.AFN,
    dialCode: "93",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AF.png",
    iso2: "AF",
    name: "Afghanistan (‫افغانستان‬‎)",
    priority: 0,
    timezone: "Asia/Kabul"
  },
  AG: {
    areaCodes: null,
    currency: i.XCD,
    dialCode: "1268",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AG.png",
    iso2: "AG",
    name: "Antigua and Barbuda",
    priority: 0,
    timezone: "America/Antigua"
  },
  AI: {
    areaCodes: null,
    currency: i.XCD,
    dialCode: "1264",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AI.png",
    iso2: "AI",
    name: "Anguilla",
    priority: 0,
    timezone: "America/Anguilla"
  },
  AL: {
    areaCodes: null,
    currency: i.ALL,
    dialCode: "355",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AL.png",
    iso2: "AL",
    name: "Albania (Shqipëri)",
    priority: 0,
    timezone: "Europe/Tirane"
  },
  AM: {
    areaCodes: null,
    currency: i.AMD,
    dialCode: "374",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AM.png",
    iso2: "AM",
    name: "Armenia (Հայաստան)",
    priority: 0,
    timezone: "Asia/Yerevan"
  },
  AO: {
    areaCodes: null,
    currency: i.AOA,
    dialCode: "244",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AO.png",
    iso2: "AO",
    name: "Angola",
    priority: 0,
    timezone: "Africa/Luanda"
  },
  AR: {
    areaCodes: null,
    currency: i.ARS,
    dialCode: "54",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AR.png",
    iso2: "AR",
    name: "Argentina",
    priority: 0,
    timezone: "America/Argentina/Cordoba"
  },
  AS: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "1684",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AS.png",
    iso2: "AS",
    name: "American Samoa",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  AT: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "43",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AT.png",
    iso2: "AT",
    name: "Austria (Österreich)",
    priority: 0,
    timezone: "Europe/Vienna"
  },
  AU: {
    areaCodes: null,
    currency: i.AUD,
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AU.png",
    iso2: "AU",
    name: "Australia",
    priority: 0,
    timezone: "Australia/Darwin"
  },
  AW: {
    areaCodes: null,
    currency: i.AWG,
    dialCode: "297",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AW.png",
    iso2: "AW",
    name: "Aruba",
    priority: 0,
    timezone: "America/Aruba"
  },
  AX: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "358",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AX.png",
    iso2: "AX",
    name: "Åland Islands",
    priority: 1,
    timezone: "Europe/Helsinki"
  },
  AZ: {
    areaCodes: null,
    currency: i.AZN,
    dialCode: "994",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AZ.png",
    iso2: "AZ",
    name: "Azerbaijan (Azərbaycan)",
    priority: 0,
    timezone: "Asia/Baku"
  },
  BA: {
    areaCodes: null,
    currency: i.BAM,
    dialCode: "387",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BA.png",
    iso2: "BA",
    name: "Bosnia and Herzegovina (Босна и Херцеговина)",
    priority: 0,
    timezone: "Europe/Sarajevo"
  },
  BB: {
    areaCodes: null,
    currency: i.BBD,
    dialCode: "1246",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BB.png",
    iso2: "BB",
    name: "Barbados",
    priority: 0,
    timezone: "America/Barbados"
  },
  BD: {
    areaCodes: null,
    currency: i.BDT,
    dialCode: "880",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BD.png",
    iso2: "BD",
    name: "Bangladesh (বাংলাদেশ)",
    priority: 0,
    timezone: "Asia/Dhaka"
  },
  BE: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "32",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BE.png",
    iso2: "BE",
    name: "Belgium (België)",
    priority: 0,
    timezone: "Europe/Brussels"
  },
  BF: {
    areaCodes: null,
    currency: i.XOF,
    dialCode: "226",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BF.png",
    iso2: "BF",
    name: "Burkina Faso",
    priority: 0,
    timezone: "Africa/Ouagadougou"
  },
  BG: {
    areaCodes: null,
    currency: i.BGN,
    dialCode: "359",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BG.png",
    iso2: "BG",
    name: "Bulgaria (България)",
    priority: 0,
    timezone: "Europe/Sofia"
  },
  BH: {
    areaCodes: null,
    currency: i.BHD,
    dialCode: "973",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BH.png",
    iso2: "BH",
    name: "Bahrain (‫البحرين‬‎)",
    priority: 0,
    timezone: "Asia/Bahrain"
  },
  BI: {
    areaCodes: null,
    currency: i.BIF,
    dialCode: "257",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BI.png",
    iso2: "BI",
    name: "Burundi (Uburundi)",
    priority: 0,
    timezone: "Africa/Bujumbura"
  },
  BJ: {
    areaCodes: null,
    currency: i.XOF,
    dialCode: "229",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BJ.png",
    iso2: "BJ",
    name: "Benin (Bénin)",
    priority: 0,
    timezone: "Africa/Porto-Novo"
  },
  BL: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BL.png",
    iso2: "BL",
    name: "Saint Barthélemy",
    priority: 1,
    timezone: "America/St_Barthelemy"
  },
  BM: {
    areaCodes: null,
    currency: i.BMD,
    dialCode: "1441",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BM.png",
    iso2: "BM",
    name: "Bermuda",
    priority: 0,
    timezone: "Atlantic/Bermuda"
  },
  BN: {
    areaCodes: null,
    currency: i.BND,
    dialCode: "673",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BN.png",
    iso2: "BN",
    name: "Brunei",
    priority: 0,
    timezone: "Asia/Brunei"
  },
  BO: {
    areaCodes: null,
    currency: i.BOB,
    dialCode: "591",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BO.png",
    iso2: "BO",
    name: "Bolivia",
    priority: 0,
    timezone: "America/La_Paz"
  },
  BQ: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "599",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BQ.png",
    iso2: "BQ",
    name: "Caribbean Netherlands",
    priority: 1,
    timezone: "America/Kralendijk"
  },
  BR: {
    areaCodes: null,
    currency: i.BRL,
    dialCode: "55",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BR.png",
    iso2: "BR",
    name: "Brazil (Brasil)",
    priority: 0,
    timezone: "America/Cuiaba"
  },
  BS: {
    areaCodes: null,
    currency: i.BSD,
    dialCode: "1242",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BS.png",
    iso2: "BS",
    name: "Bahamas",
    priority: 0,
    timezone: "America/Nassau"
  },
  BT: {
    areaCodes: null,
    currency: i.BTN,
    dialCode: "975",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BT.png",
    iso2: "BT",
    name: "Bhutan (འབྲུག)",
    priority: 0,
    timezone: "Asia/Thimphu"
  },
  BW: {
    areaCodes: null,
    currency: i.BWP,
    dialCode: "267",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BW.png",
    iso2: "BW",
    name: "Botswana",
    priority: 0,
    timezone: "Africa/Gaborone"
  },
  BY: {
    areaCodes: null,
    currency: i.BYN,
    dialCode: "375",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BY.png",
    iso2: "BY",
    name: "Belarus (Беларусь)",
    priority: 0,
    timezone: "Europe/Minsk"
  },
  BZ: {
    areaCodes: null,
    currency: i.BZD,
    dialCode: "501",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BZ.png",
    iso2: "BZ",
    name: "Belize",
    priority: 0,
    timezone: "America/Belize"
  },
  CA: {
    areaCodes: [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ],
    currency: i.CAD,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CA.png",
    iso2: "CA",
    name: "Canada",
    priority: 1,
    timezone: "America/Rankin_Inlet"
  },
  CC: {
    areaCodes: null,
    currency: i.AUD,
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CC.png",
    iso2: "CC",
    name: "Cocos (Keeling) Islands",
    priority: 1,
    timezone: "Indian/Cocos"
  },
  CD: {
    areaCodes: null,
    currency: i.CDF,
    dialCode: "243",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CD.png",
    iso2: "CD",
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    priority: 0,
    timezone: "Africa/Lubumbashi"
  },
  CF: {
    areaCodes: null,
    currency: i.XAF,
    dialCode: "236",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CF.png",
    iso2: "CF",
    name: "Central African Republic (République centrafricaine)",
    priority: 0,
    timezone: "Africa/Bangui"
  },
  CG: {
    areaCodes: null,
    currency: i.XAF,
    dialCode: "242",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CG.png",
    iso2: "CG",
    name: "Congo (Republic) (Congo-Brazzaville)",
    priority: 0,
    timezone: "Africa/Brazzaville"
  },
  CH: {
    areaCodes: null,
    currency: i.CHF,
    dialCode: "41",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CH.png",
    iso2: "CH",
    name: "Switzerland (Schweiz)",
    priority: 0,
    timezone: "Europe/Zurich"
  },
  CI: {
    areaCodes: null,
    currency: i.XOF,
    dialCode: "225",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CI.png",
    iso2: "CI",
    name: "Côte d’Ivoire",
    priority: 0,
    timezone: "Africa/Abidjan"
  },
  CK: {
    areaCodes: null,
    currency: i.NZD,
    dialCode: "682",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CK.png",
    iso2: "CK",
    name: "Cook Islands",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  CL: {
    areaCodes: null,
    currency: i.CLP,
    dialCode: "56",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CL.png",
    iso2: "CL",
    name: "Chile",
    priority: 0,
    timezone: "America/Santiago"
  },
  CM: {
    areaCodes: null,
    currency: i.XAF,
    dialCode: "237",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CM.png",
    iso2: "CM",
    name: "Cameroon (Cameroun)",
    priority: 0,
    timezone: "Africa/Douala"
  },
  CN: {
    areaCodes: null,
    currency: i.CNY,
    dialCode: "86",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CN.png",
    iso2: "CN",
    name: "China (中国)",
    priority: 0,
    timezone: "Asia/Shanghai"
  },
  CO: {
    areaCodes: null,
    currency: i.COP,
    dialCode: "57",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CO.png",
    iso2: "CO",
    name: "Colombia",
    priority: 0,
    timezone: "America/Bogota"
  },
  CR: {
    areaCodes: null,
    currency: i.CRC,
    dialCode: "506",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CR.png",
    iso2: "CR",
    name: "Costa Rica",
    priority: 0,
    timezone: "America/Costa_Rica"
  },
  CU: {
    areaCodes: null,
    currency: i.CUP,
    dialCode: "53",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CU.png",
    iso2: "CU",
    name: "Cuba",
    priority: 0,
    timezone: "America/Havana"
  },
  CV: {
    areaCodes: null,
    currency: i.CVE,
    dialCode: "238",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CV.png",
    iso2: "CV",
    name: "Cape Verde (Kabu Verdi)",
    priority: 0,
    timezone: "Atlantic/Cape_Verde"
  },
  CW: {
    areaCodes: null,
    currency: i.ANG,
    dialCode: "599",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CW.png",
    iso2: "CW",
    name: "Curaçao",
    priority: 0,
    timezone: "America/Curacao"
  },
  CX: {
    areaCodes: null,
    currency: i.AUD,
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CX.png",
    iso2: "CX",
    name: "Christmas Island",
    priority: 2,
    timezone: "Indian/Christmas"
  },
  CY: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "357",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CY.png",
    iso2: "CY",
    name: "Cyprus (Κύπρος)",
    priority: 0,
    timezone: "Asia/Nicosia"
  },
  CZ: {
    areaCodes: null,
    currency: i.CZK,
    dialCode: "420",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CZ.png",
    iso2: "CZ",
    name: "Czech Republic (Česká republika)",
    priority: 0,
    timezone: "Europe/Prague"
  },
  DE: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "49",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DE.png",
    iso2: "DE",
    name: "Germany (Deutschland)",
    priority: 0,
    timezone: "Europe/Berlin"
  },
  DJ: {
    areaCodes: null,
    currency: i.DJF,
    dialCode: "253",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DJ.png",
    iso2: "DJ",
    name: "Djibouti",
    priority: 0,
    timezone: "Africa/Djibouti"
  },
  DK: {
    areaCodes: null,
    currency: i.DKK,
    dialCode: "45",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DK.png",
    iso2: "DK",
    name: "Denmark (Danmark)",
    priority: 0,
    timezone: "Europe/Copenhagen"
  },
  DM: {
    areaCodes: null,
    currency: i.XCD,
    dialCode: "1767",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DM.png",
    iso2: "DM",
    name: "Dominica",
    priority: 0,
    timezone: "America/Dominica"
  },
  DO: {
    areaCodes: ["809", "829", "849"],
    currency: i.DOP,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DO.png",
    iso2: "DO",
    name: "Dominican Republic (República Dominicana)",
    priority: 2,
    timezone: "America/Santo_Domingo"
  },
  DZ: {
    areaCodes: null,
    currency: i.DZD,
    dialCode: "213",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DZ.png",
    iso2: "DZ",
    name: "Algeria (‫الجزائر‬‎)",
    priority: 0,
    timezone: "Africa/Algiers"
  },
  EC: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "593",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EC.png",
    iso2: "EC",
    name: "Ecuador",
    priority: 0,
    timezone: "America/Guayaquil"
  },
  EE: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "372",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EE.png",
    iso2: "EE",
    name: "Estonia (Eesti)",
    priority: 0,
    timezone: "Europe/Tallinn"
  },
  EG: {
    areaCodes: null,
    currency: i.EGP,
    dialCode: "20",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EG.png",
    iso2: "EG",
    name: "Egypt (‫مصر‬‎)",
    priority: 0,
    timezone: "Africa/Cairo"
  },
  EH: {
    areaCodes: null,
    currency: i.MAD,
    dialCode: "212",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EH.png",
    iso2: "EH",
    name: "Western Sahara (‫الصحراء الغربية‬‎)",
    priority: 1,
    timezone: "Africa/El_Aaiun"
  },
  ER: {
    areaCodes: null,
    currency: i.ERN,
    dialCode: "291",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ER.png",
    iso2: "ER",
    name: "Eritrea",
    priority: 0,
    timezone: "Africa/Asmara"
  },
  ES: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "34",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ES.png",
    iso2: "ES",
    name: "Spain (España)",
    priority: 0,
    timezone: "Europe/Madrid"
  },
  ET: {
    areaCodes: null,
    currency: i.ETB,
    dialCode: "251",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ET.png",
    iso2: "ET",
    name: "Ethiopia",
    priority: 0,
    timezone: "Africa/Addis_Ababa"
  },
  FI: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "358",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FI.png",
    iso2: "FI",
    name: "Finland (Suomi)",
    priority: 0,
    timezone: "Europe/Helsinki"
  },
  FJ: {
    areaCodes: null,
    currency: i.FJD,
    dialCode: "679",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FJ.png",
    iso2: "FJ",
    name: "Fiji",
    priority: 0,
    timezone: "Pacific/Fiji"
  },
  FK: {
    areaCodes: null,
    currency: i.FKP,
    dialCode: "500",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FK.png",
    iso2: "FK",
    name: "Falkland Islands (Islas Malvinas)",
    priority: 0,
    timezone: "Atlantic/Stanley"
  },
  FM: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "691",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FM.png",
    iso2: "FM",
    name: "Micronesia",
    priority: 0,
    timezone: "Etc/GMT-10"
  },
  FO: {
    areaCodes: null,
    currency: i.DKK,
    dialCode: "298",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FO.png",
    iso2: "FO",
    name: "Faroe Islands (Føroyar)",
    priority: 0,
    timezone: "Atlantic/Faroe"
  },
  FR: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "33",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FR.png",
    iso2: "FR",
    name: "France",
    priority: 0,
    timezone: "Europe/Paris"
  },
  GA: {
    areaCodes: null,
    currency: i.XAF,
    dialCode: "241",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GA.png",
    iso2: "GA",
    name: "Gabon",
    priority: 0,
    timezone: "Africa/Libreville"
  },
  GB: {
    areaCodes: null,
    currency: i.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GB.png",
    iso2: "GB",
    name: "United Kingdom",
    priority: 0,
    timezone: "Etc/GMT"
  },
  GD: {
    areaCodes: null,
    currency: i.XCD,
    dialCode: "1473",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GD.png",
    iso2: "GD",
    name: "Grenada",
    priority: 0,
    timezone: "America/Grenada"
  },
  GE: {
    areaCodes: null,
    currency: i.GEL,
    dialCode: "995",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GE.png",
    iso2: "GE",
    name: "Georgia (საქართველო)",
    priority: 0,
    timezone: "Asia/Tbilisi"
  },
  GF: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "594",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GF.png",
    iso2: "GF",
    name: "French Guiana (Guyane française)",
    priority: 0,
    timezone: "America/Cayenne"
  },
  GG: {
    areaCodes: null,
    currency: i.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GG.png",
    iso2: "GG",
    name: "Guernsey",
    priority: 1,
    timezone: "Europe/Guernsey"
  },
  GH: {
    areaCodes: null,
    currency: i.GHS,
    dialCode: "233",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GH.png",
    iso2: "GH",
    name: "Ghana (Gaana)",
    priority: 0,
    timezone: "Africa/Accra"
  },
  GI: {
    areaCodes: null,
    currency: i.GIP,
    dialCode: "350",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GI.png",
    iso2: "GI",
    name: "Gibraltar",
    priority: 0,
    timezone: "Europe/Gibraltar"
  },
  GL: {
    areaCodes: null,
    currency: i.DKK,
    dialCode: "299",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GL.png",
    iso2: "GL",
    name: "Greenland (Kalaallit Nunaat)",
    priority: 0,
    timezone: "America/Godthab"
  },
  GM: {
    areaCodes: null,
    currency: i.GMD,
    dialCode: "220",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GM.png",
    iso2: "GM",
    name: "Gambia",
    priority: 0,
    timezone: "Africa/Banjul"
  },
  GN: {
    areaCodes: null,
    currency: i.GNF,
    dialCode: "224",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GN.png",
    iso2: "GN",
    name: "Guinea (Guinée)",
    priority: 0,
    timezone: "Africa/Conakry"
  },
  GP: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GP.png",
    iso2: "GP",
    name: "Guadeloupe",
    priority: 0,
    timezone: "America/Guadeloupe"
  },
  GQ: {
    areaCodes: null,
    currency: i.XAF,
    dialCode: "240",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GQ.png",
    iso2: "GQ",
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    priority: 0,
    timezone: "Africa/Malabo"
  },
  GR: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "30",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GR.png",
    iso2: "GR",
    name: "Greece (Ελλάδα)",
    priority: 0,
    timezone: "Europe/Athens"
  },
  GT: {
    areaCodes: null,
    currency: i.GTQ,
    dialCode: "502",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GT.png",
    iso2: "GT",
    name: "Guatemala",
    priority: 0,
    timezone: "America/Guatemala"
  },
  GU: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "1671",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GU.png",
    iso2: "GU",
    name: "Guam",
    priority: 0,
    timezone: "Pacific/Guam"
  },
  GW: {
    areaCodes: null,
    currency: i.XOF,
    dialCode: "245",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GW.png",
    iso2: "GW",
    name: "Guinea-Bissau (Guiné Bissau)",
    priority: 0,
    timezone: "Africa/Bissau"
  },
  GY: {
    areaCodes: null,
    currency: i.GYD,
    dialCode: "592",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GY.png",
    iso2: "GY",
    name: "Guyana",
    priority: 0,
    timezone: "America/Guyana"
  },
  HK: {
    areaCodes: null,
    currency: i.HKD,
    dialCode: "852",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HK.png",
    iso2: "HK",
    name: "Hong Kong (香港)",
    priority: 0,
    timezone: "Asia/Hong_Kong"
  },
  HN: {
    areaCodes: null,
    currency: i.HNL,
    dialCode: "504",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HN.png",
    iso2: "HN",
    name: "Honduras",
    priority: 0,
    timezone: "America/Tegucigalpa"
  },
  HR: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "385",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HR.png",
    iso2: "HR",
    name: "Croatia (Hrvatska)",
    priority: 0,
    timezone: "Europe/Zagreb"
  },
  HT: {
    areaCodes: null,
    currency: i.HTG,
    dialCode: "509",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HT.png",
    iso2: "HT",
    name: "Haiti",
    priority: 0,
    timezone: "America/Port-au-Prince"
  },
  HU: {
    areaCodes: null,
    currency: i.HUF,
    dialCode: "36",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HU.png",
    iso2: "HU",
    name: "Hungary (Magyarország)",
    priority: 0,
    timezone: "Europe/Budapest"
  },
  ID: {
    areaCodes: null,
    currency: i.IDR,
    dialCode: "62",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ID.png",
    iso2: "ID",
    name: "Indonesia",
    priority: 0,
    timezone: "Asia/Makassar"
  },
  IE: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "353",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IE.png",
    iso2: "IE",
    name: "Ireland",
    priority: 0,
    timezone: "Europe/Dublin"
  },
  IL: {
    areaCodes: null,
    currency: i.ILS,
    dialCode: "972",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IL.png",
    iso2: "IL",
    name: "Israel (‫ישראל‬‎)",
    priority: 0,
    timezone: "Asia/Jerusalem"
  },
  IM: {
    areaCodes: null,
    currency: i.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IM.png",
    iso2: "IM",
    name: "Isle of Man",
    priority: 2,
    timezone: "Europe/Isle_of_Man"
  },
  IN: {
    areaCodes: null,
    currency: i.INR,
    dialCode: "91",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IN.png",
    iso2: "IN",
    name: "India (भारत)",
    priority: 0,
    timezone: "Asia/Kolkata"
  },
  IO: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "246",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IO.png",
    iso2: "IO",
    name: "British Indian Ocean Territory",
    priority: 0,
    timezone: "Etc/GMT-5"
  },
  IQ: {
    areaCodes: null,
    currency: i.IQD,
    dialCode: "964",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IQ.png",
    iso2: "IQ",
    name: "Iraq (‫العراق‬‎)",
    priority: 0,
    timezone: "Asia/Baghdad"
  },
  IR: {
    areaCodes: null,
    currency: i.IRR,
    dialCode: "98",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IR.png",
    iso2: "IR",
    name: "Iran (‫ایران‬‎)",
    priority: 0,
    timezone: "Asia/Tehran"
  },
  IS: {
    areaCodes: null,
    currency: i.ISK,
    dialCode: "354",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IS.png",
    iso2: "IS",
    name: "Iceland (Ísland)",
    priority: 0,
    timezone: "Atlantic/Reykjavik"
  },
  IT: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "39",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IT.png",
    iso2: "IT",
    name: "Italy (Italia)",
    priority: 0,
    timezone: "Europe/Rome"
  },
  JE: {
    areaCodes: null,
    currency: i.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JE.png",
    iso2: "JE",
    name: "Jersey",
    priority: 3,
    timezone: "Europe/Jersey"
  },
  JM: {
    areaCodes: null,
    currency: i.JMD,
    dialCode: "1876",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JM.png",
    iso2: "JM",
    name: "Jamaica",
    priority: 0,
    timezone: "America/Jamaica"
  },
  JO: {
    areaCodes: null,
    currency: i.JOD,
    dialCode: "962",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JO.png",
    iso2: "JO",
    name: "Jordan (‫الأردن‬‎)",
    priority: 0,
    timezone: "Asia/Amman"
  },
  JP: {
    areaCodes: null,
    currency: i.JPY,
    dialCode: "81",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JP.png",
    iso2: "JP",
    name: "Japan (日本)",
    priority: 0,
    timezone: "Asia/Tokyo"
  },
  KE: {
    areaCodes: null,
    currency: i.KES,
    dialCode: "254",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KE.png",
    iso2: "KE",
    name: "Kenya",
    priority: 0,
    timezone: "Africa/Nairobi"
  },
  KG: {
    areaCodes: null,
    currency: i.KGS,
    dialCode: "996",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KG.png",
    iso2: "KG",
    name: "Kyrgyzstan (Кыргызстан)",
    priority: 0,
    timezone: "Asia/Bishkek"
  },
  KH: {
    areaCodes: null,
    currency: i.KHR,
    dialCode: "855",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KH.png",
    iso2: "KH",
    name: "Cambodia (កម្ពុជា)",
    priority: 0,
    timezone: "Asia/Phnom_Penh"
  },
  KI: {
    areaCodes: null,
    currency: i.AUD,
    dialCode: "686",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KI.png",
    iso2: "KI",
    name: "Kiribati",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  KM: {
    areaCodes: null,
    currency: i.KMF,
    dialCode: "269",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KM.png",
    iso2: "KM",
    name: "Comoros (‫جزر القمر‬‎)",
    priority: 0,
    timezone: "Indian/Comoro"
  },
  KN: {
    areaCodes: null,
    currency: i.XCD,
    dialCode: "1869",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KN.png",
    iso2: "KN",
    name: "Saint Kitts and Nevis",
    priority: 0,
    timezone: "America/St_Kitts"
  },
  KP: {
    areaCodes: null,
    currency: i.KPW,
    dialCode: "850",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KP.png",
    iso2: "KP",
    name: "North Korea (조선 민주주의 인민 공화국)",
    priority: 0,
    timezone: "Asia/Pyongyang"
  },
  KR: {
    areaCodes: null,
    currency: i.KRW,
    dialCode: "82",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KR.png",
    iso2: "KR",
    name: "South Korea (대한민국)",
    priority: 0,
    timezone: "Asia/Seoul"
  },
  KW: {
    areaCodes: null,
    currency: i.KWD,
    dialCode: "965",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KW.png",
    iso2: "KW",
    name: "Kuwait (‫الكويت‬‎)",
    priority: 0,
    timezone: "Asia/Kuwait"
  },
  KY: {
    areaCodes: null,
    currency: i.KYD,
    dialCode: "1345",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KY.png",
    iso2: "KY",
    name: "Cayman Islands",
    priority: 0,
    timezone: "Etc/GMT+5"
  },
  KZ: {
    areaCodes: null,
    currency: i.KZT,
    dialCode: "7",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KZ.png",
    iso2: "KZ",
    name: "Kazakhstan (Казахстан)",
    priority: 1,
    timezone: "Asia/Almaty"
  },
  LA: {
    areaCodes: null,
    currency: i.LAK,
    dialCode: "856",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LA.png",
    iso2: "LA",
    name: "Laos (ລາວ)",
    priority: 0,
    timezone: "Asia/Vientiane"
  },
  LB: {
    areaCodes: null,
    currency: i.LBP,
    dialCode: "961",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LB.png",
    iso2: "LB",
    name: "Lebanon (‫لبنان‬‎)",
    priority: 0,
    timezone: "Asia/Beirut"
  },
  LC: {
    areaCodes: null,
    currency: i.XCD,
    dialCode: "1758",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LC.png",
    iso2: "LC",
    name: "Saint Lucia",
    priority: 0,
    timezone: "America/St_Lucia"
  },
  LI: {
    areaCodes: null,
    currency: i.CHF,
    dialCode: "423",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LI.png",
    iso2: "LI",
    name: "Liechtenstein",
    priority: 0,
    timezone: "Europe/Vaduz"
  },
  LK: {
    areaCodes: null,
    currency: i.LKR,
    dialCode: "94",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LK.png",
    iso2: "LK",
    name: "Sri Lanka (ශ්‍රී ලංකාව)",
    priority: 0,
    timezone: "Asia/Colombo"
  },
  LR: {
    areaCodes: null,
    currency: i.LRD,
    dialCode: "231",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LR.png",
    iso2: "LR",
    name: "Liberia",
    priority: 0,
    timezone: "Africa/Monrovia"
  },
  LS: {
    areaCodes: null,
    currency: i.LSL,
    dialCode: "266",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LS.png",
    iso2: "LS",
    name: "Lesotho",
    priority: 0,
    timezone: "Africa/Maseru"
  },
  LT: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "370",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LT.png",
    iso2: "LT",
    name: "Lithuania (Lietuva)",
    priority: 0,
    timezone: "Europe/Vilnius"
  },
  LU: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "352",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LU.png",
    iso2: "LU",
    name: "Luxembourg",
    priority: 0,
    timezone: "Europe/Luxembourg"
  },
  LV: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "371",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LV.png",
    iso2: "LV",
    name: "Latvia (Latvija)",
    priority: 0,
    timezone: "Europe/Riga"
  },
  LY: {
    areaCodes: null,
    currency: i.LYD,
    dialCode: "218",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LY.png",
    iso2: "LY",
    name: "Libya (‫ليبيا‬‎)",
    priority: 0,
    timezone: "Africa/Tripoli"
  },
  MA: {
    areaCodes: null,
    currency: i.MAD,
    dialCode: "212",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MA.png",
    iso2: "MA",
    name: "Morocco (‫المغرب‬‎)",
    priority: 0,
    timezone: "Africa/Casablanca"
  },
  MC: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "377",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MC.png",
    iso2: "MC",
    name: "Monaco",
    priority: 0,
    timezone: "Europe/Paris"
  },
  MD: {
    areaCodes: null,
    currency: i.MDL,
    dialCode: "373",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MD.png",
    iso2: "MD",
    name: "Moldova (Republica Moldova)",
    priority: 0,
    timezone: "Europe/Chisinau"
  },
  ME: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "382",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ME.png",
    iso2: "ME",
    name: "Montenegro (Crna Gora)",
    priority: 0,
    timezone: "Europe/Podgorica"
  },
  MF: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MF.png",
    iso2: "MF",
    name: "Saint Martin (Saint-Martin (partie française))",
    priority: 2,
    timezone: "America/Marigot"
  },
  MG: {
    areaCodes: null,
    currency: i.MGA,
    dialCode: "261",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MG.png",
    iso2: "MG",
    name: "Madagascar (Madagasikara)",
    priority: 0,
    timezone: "Indian/Antananarivo"
  },
  MH: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "692",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MH.png",
    iso2: "MH",
    name: "Marshall Islands",
    priority: 0,
    timezone: "Etc/GMT-11"
  },
  MK: {
    areaCodes: null,
    currency: i.MKD,
    dialCode: "389",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MK.png",
    iso2: "MK",
    name: "Macedonia (FYROM) (Македонија)",
    priority: 0,
    timezone: "Europe/Skopje"
  },
  ML: {
    areaCodes: null,
    currency: i.XOF,
    dialCode: "223",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ML.png",
    iso2: "ML",
    name: "Mali",
    priority: 0,
    timezone: "Africa/Bamako"
  },
  MM: {
    areaCodes: null,
    currency: i.MMK,
    dialCode: "95",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MM.png",
    iso2: "MM",
    name: "Myanmar (Burma) (မြန်မာ)",
    priority: 0,
    timezone: "Asia/Yangon"
  },
  MN: {
    areaCodes: null,
    currency: i.MNT,
    dialCode: "976",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MN.png",
    iso2: "MN",
    name: "Mongolia (Монгол)",
    priority: 0,
    timezone: "Asia/Ulaanbaatar"
  },
  MO: {
    areaCodes: null,
    currency: i.MOP,
    dialCode: "853",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MO.png",
    iso2: "MO",
    name: "Macau (澳門)",
    priority: 0,
    timezone: "Asia/Macau"
  },
  MP: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "1670",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MP.png",
    iso2: "MP",
    name: "Northern Mariana Islands",
    priority: 0,
    timezone: "Pacific/Saipan"
  },
  MQ: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "596",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MQ.png",
    iso2: "MQ",
    name: "Martinique",
    priority: 0,
    timezone: "America/Martinique"
  },
  MR: {
    areaCodes: null,
    currency: i.MRU,
    dialCode: "222",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MR.png",
    iso2: "MR",
    name: "Mauritania (‫موريتانيا‬‎)",
    priority: 0,
    timezone: "Africa/Nouakchott"
  },
  MS: {
    areaCodes: null,
    currency: i.XCD,
    dialCode: "1664",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MS.png",
    iso2: "MS",
    name: "Montserrat",
    priority: 0,
    timezone: "America/Montserrat"
  },
  MT: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "356",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MT.png",
    iso2: "MT",
    name: "Malta",
    priority: 0,
    timezone: "Europe/Malta"
  },
  MU: {
    areaCodes: null,
    currency: i.MUR,
    dialCode: "230",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MU.png",
    iso2: "MU",
    name: "Mauritius (Moris)",
    priority: 0,
    timezone: "Indian/Mauritius"
  },
  MV: {
    areaCodes: null,
    currency: i.MVR,
    dialCode: "960",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MV.png",
    iso2: "MV",
    name: "Maldives",
    priority: 0,
    timezone: "Indian/Maldives"
  },
  MW: {
    areaCodes: null,
    currency: i.MWK,
    dialCode: "265",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MW.png",
    iso2: "MW",
    name: "Malawi",
    priority: 0,
    timezone: "Africa/Blantyre"
  },
  MX: {
    areaCodes: null,
    currency: i.MXN,
    dialCode: "52",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MX.png",
    iso2: "MX",
    name: "Mexico (México)",
    priority: 0,
    timezone: "America/Mexico_City"
  },
  MY: {
    areaCodes: null,
    currency: i.MYR,
    dialCode: "60",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MY.png",
    iso2: "MY",
    name: "Malaysia",
    priority: 0,
    timezone: "Asia/Kuching"
  },
  MZ: {
    areaCodes: null,
    currency: i.MZN,
    dialCode: "258",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MZ.png",
    iso2: "MZ",
    name: "Mozambique (Moçambique)",
    priority: 0,
    timezone: "Africa/Maputo"
  },
  NA: {
    areaCodes: null,
    currency: i.NAD,
    dialCode: "264",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NA.png",
    iso2: "NA",
    name: "Namibia (Namibië)",
    priority: 0,
    timezone: "Africa/Windhoek"
  },
  NC: {
    areaCodes: null,
    currency: i.XPF,
    dialCode: "687",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NC.png",
    iso2: "NC",
    name: "New Caledonia (Nouvelle-Calédonie)",
    priority: 0,
    timezone: "Pacific/Noumea"
  },
  NE: {
    areaCodes: null,
    currency: i.XOF,
    dialCode: "227",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NE.png",
    iso2: "NE",
    name: "Niger (Nijar)",
    priority: 0,
    timezone: "Africa/Niamey"
  },
  NF: {
    areaCodes: null,
    currency: i.AUD,
    dialCode: "672",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NF.png",
    iso2: "NF",
    name: "Norfolk Island",
    priority: 0,
    timezone: "Pacific/Norfolk"
  },
  NG: {
    areaCodes: null,
    currency: i.NGN,
    dialCode: "234",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NG.png",
    iso2: "NG",
    name: "Nigeria",
    priority: 0,
    timezone: "Africa/Lagos"
  },
  NI: {
    areaCodes: null,
    currency: i.NIO,
    dialCode: "505",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NI.png",
    iso2: "NI",
    name: "Nicaragua",
    priority: 0,
    timezone: "America/Managua"
  },
  NL: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "31",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NL.png",
    iso2: "NL",
    name: "Netherlands (Nederland)",
    priority: 0,
    timezone: "Europe/Amsterdam"
  },
  NO: {
    areaCodes: null,
    currency: i.NOK,
    dialCode: "47",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NO.png",
    iso2: "NO",
    name: "Norway (Norge)",
    priority: 0,
    timezone: "Europe/Oslo"
  },
  NP: {
    areaCodes: null,
    currency: i.NPR,
    dialCode: "977",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NP.png",
    iso2: "NP",
    name: "Nepal (नेपाल)",
    priority: 0,
    timezone: "Asia/Kathmandu"
  },
  NR: {
    areaCodes: null,
    currency: i.AUD,
    dialCode: "674",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NR.png",
    iso2: "NR",
    name: "Nauru",
    priority: 0,
    timezone: "Pacific/Nauru"
  },
  NU: {
    areaCodes: null,
    currency: i.NZD,
    dialCode: "683",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NU.png",
    iso2: "NU",
    name: "Niue",
    priority: 0,
    timezone: "Pacific/Niue"
  },
  NZ: {
    areaCodes: null,
    currency: i.NZD,
    dialCode: "64",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NZ.png",
    iso2: "NZ",
    name: "New Zealand",
    priority: 0,
    timezone: "Pacific/Auckland"
  },
  OM: {
    areaCodes: null,
    currency: i.OMR,
    dialCode: "968",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/OM.png",
    iso2: "OM",
    name: "Oman (‫عُمان‬‎)",
    priority: 0,
    timezone: "Asia/Muscat"
  },
  PA: {
    areaCodes: null,
    currency: i.PAB,
    dialCode: "507",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PA.png",
    iso2: "PA",
    name: "Panama (Panamá)",
    priority: 0,
    timezone: "America/Panama"
  },
  PE: {
    areaCodes: null,
    currency: i.PEN,
    dialCode: "51",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PE.png",
    iso2: "PE",
    name: "Peru (Perú)",
    priority: 0,
    timezone: "America/Lima"
  },
  PF: {
    areaCodes: null,
    currency: i.XPF,
    dialCode: "689",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PF.png",
    iso2: "PF",
    name: "French Polynesia (Polynésie française)",
    priority: 0,
    timezone: "Etc/GMT+9"
  },
  PG: {
    areaCodes: null,
    currency: i.PGK,
    dialCode: "675",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PG.png",
    iso2: "PG",
    name: "Papua New Guinea",
    priority: 0,
    timezone: "Pacific/Port_Moresby"
  },
  PH: {
    areaCodes: null,
    currency: i.PHP,
    dialCode: "63",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PH.png",
    iso2: "PH",
    name: "Philippines",
    priority: 0,
    timezone: "Asia/Manila"
  },
  PK: {
    areaCodes: null,
    currency: i.PKR,
    dialCode: "92",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PK.png",
    iso2: "PK",
    name: "Pakistan (‫پاکستان‬‎)",
    priority: 0,
    timezone: "Asia/Karachi"
  },
  PL: {
    areaCodes: null,
    currency: i.PLN,
    dialCode: "48",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PL.png",
    iso2: "PL",
    name: "Poland (Polska)",
    priority: 0,
    timezone: "Europe/Warsaw"
  },
  PM: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "508",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PM.png",
    iso2: "PM",
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    priority: 0,
    timezone: "America/Miquelon"
  },
  PR: {
    areaCodes: ["787", "939"],
    currency: i.USD,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PR.png",
    iso2: "PR",
    name: "Puerto Rico",
    priority: 3,
    timezone: "America/Puerto_Rico"
  },
  PS: {
    areaCodes: null,
    currency: i.ILS,
    dialCode: "970",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PS.png",
    iso2: "PS",
    name: "Palestine (‫فلسطين‬‎)",
    priority: 0,
    timezone: "Asia/Jerusalem"
  },
  PT: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "351",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PT.png",
    iso2: "PT",
    name: "Portugal",
    priority: 0,
    timezone: "Europe/Lisbon"
  },
  PW: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "680",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PW.png",
    iso2: "PW",
    name: "Palau",
    priority: 0,
    timezone: "Etc/GMT-9"
  },
  PY: {
    areaCodes: null,
    currency: i.PYG,
    dialCode: "595",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PY.png",
    iso2: "PY",
    name: "Paraguay",
    priority: 0,
    timezone: "America/Asuncion"
  },
  QA: {
    areaCodes: null,
    currency: i.QAR,
    dialCode: "974",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/QA.png",
    iso2: "QA",
    name: "Qatar (‫قطر‬‎)",
    priority: 0,
    timezone: "Asia/Qatar"
  },
  RE: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "262",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RE.png",
    iso2: "RE",
    name: "Réunion (La Réunion)",
    priority: 0,
    timezone: "Indian/Reunion"
  },
  RO: {
    areaCodes: null,
    currency: i.RON,
    dialCode: "40",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RO.png",
    iso2: "RO",
    name: "Romania (România)",
    priority: 0,
    timezone: "Europe/Bucharest"
  },
  RS: {
    areaCodes: null,
    currency: i.RSD,
    dialCode: "381",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RS.png",
    iso2: "RS",
    name: "Serbia (Србија)",
    priority: 0,
    timezone: "Europe/Belgrade"
  },
  RU: {
    areaCodes: null,
    currency: i.RUB,
    dialCode: "7",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RU.png",
    iso2: "RU",
    name: "Russia (Россия)",
    priority: 0,
    timezone: "Asia/Krasnoyarsk"
  },
  RW: {
    areaCodes: null,
    currency: i.RWF,
    dialCode: "250",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RW.png",
    iso2: "RW",
    name: "Rwanda",
    priority: 0,
    timezone: "Africa/Kigali"
  },
  SA: {
    areaCodes: null,
    currency: i.SAR,
    dialCode: "966",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SA.png",
    iso2: "SA",
    name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    priority: 0,
    timezone: "Asia/Riyadh"
  },
  SB: {
    areaCodes: null,
    currency: i.SBD,
    dialCode: "677",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SB.png",
    iso2: "SB",
    name: "Solomon Islands",
    priority: 0,
    timezone: "Pacific/Guadalcanal"
  },
  SC: {
    areaCodes: null,
    currency: i.SCR,
    dialCode: "248",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SC.png",
    iso2: "SC",
    name: "Seychelles",
    priority: 0,
    timezone: "Indian/Mahe"
  },
  SD: {
    areaCodes: null,
    currency: i.SDG,
    dialCode: "249",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SD.png",
    iso2: "SD",
    name: "Sudan (‫السودان‬‎)",
    priority: 0,
    timezone: "Africa/Khartoum"
  },
  SE: {
    areaCodes: null,
    currency: i.SEK,
    dialCode: "46",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SE.png",
    iso2: "SE",
    name: "Sweden (Sverige)",
    priority: 0,
    timezone: "Europe/Stockholm"
  },
  SG: {
    areaCodes: null,
    currency: i.SGD,
    dialCode: "65",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SG.png",
    iso2: "SG",
    name: "Singapore",
    priority: 0,
    timezone: "Asia/Singapore"
  },
  SH: {
    areaCodes: null,
    currency: i.SHP,
    dialCode: "290",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SH.png",
    iso2: "SH",
    name: "Saint Helena",
    priority: 0,
    timezone: "Atlantic/St_Helena"
  },
  SI: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "386",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SI.png",
    iso2: "SI",
    name: "Slovenia (Slovenija)",
    priority: 0,
    timezone: "Europe/Ljubljana"
  },
  SJ: {
    areaCodes: null,
    currency: i.NOK,
    dialCode: "47",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SJ.png",
    iso2: "SJ",
    name: "Svalbard and Jan Mayen",
    priority: 1,
    timezone: "Arctic/Longyearbyen"
  },
  SK: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "421",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SK.png",
    iso2: "SK",
    name: "Slovakia (Slovensko)",
    priority: 0,
    timezone: "Europe/Bratislava"
  },
  SL: {
    areaCodes: null,
    currency: i.SLL,
    dialCode: "232",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SL.png",
    iso2: "SL",
    name: "Sierra Leone",
    priority: 0,
    timezone: "Africa/Freetown"
  },
  SM: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "378",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SM.png",
    iso2: "SM",
    name: "San Marino",
    priority: 0,
    timezone: "Europe/San_Marino"
  },
  SN: {
    areaCodes: null,
    currency: i.XOF,
    dialCode: "221",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SN.png",
    iso2: "SN",
    name: "Senegal (Sénégal)",
    priority: 0,
    timezone: "Africa/Dakar"
  },
  SO: {
    areaCodes: null,
    currency: i.SOS,
    dialCode: "252",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SO.png",
    iso2: "SO",
    name: "Somalia (Soomaaliya)",
    priority: 0,
    timezone: "Africa/Mogadishu"
  },
  SR: {
    areaCodes: null,
    currency: i.SRD,
    dialCode: "597",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SR.png",
    iso2: "SR",
    name: "Suriname",
    priority: 0,
    timezone: "America/Paramaribo"
  },
  SS: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "211",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SS.png",
    iso2: "SS",
    name: "South Sudan (‫جنوب السودان‬‎)",
    priority: 0,
    timezone: "Africa/Juba"
  },
  ST: {
    areaCodes: null,
    currency: i.STD,
    dialCode: "239",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ST.png",
    iso2: "ST",
    name: "São Tomé and Príncipe (São Tomé e Príncipe)",
    priority: 0,
    timezone: "Africa/Sao_Tome"
  },
  SV: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "503",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SV.png",
    iso2: "SV",
    name: "El Salvador",
    priority: 0,
    timezone: "America/El_Salvador"
  },
  SX: {
    areaCodes: null,
    currency: i.ANG,
    dialCode: "1721",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SX.png",
    iso2: "SX",
    name: "Sint Maarten",
    priority: 0,
    timezone: "America/Lower_Princes"
  },
  SY: {
    areaCodes: null,
    currency: i.SYP,
    dialCode: "963",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SY.png",
    iso2: "SY",
    name: "Syria (‫سوريا‬‎)",
    priority: 0,
    timezone: "Asia/Damascus"
  },
  SZ: {
    areaCodes: null,
    currency: i.SZL,
    dialCode: "268",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SZ.png",
    iso2: "SZ",
    name: "Swaziland",
    priority: 0,
    timezone: "Africa/Mbabane"
  },
  TC: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "1649",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TC.png",
    iso2: "TC",
    name: "Turks and Caicos Islands",
    priority: 0,
    timezone: "America/Grand_Turk"
  },
  TD: {
    areaCodes: null,
    currency: i.XAF,
    dialCode: "235",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TD.png",
    iso2: "TD",
    name: "Chad (Tchad)",
    priority: 0,
    timezone: "Africa/Ndjamena"
  },
  TG: {
    areaCodes: null,
    currency: i.XOF,
    dialCode: "228",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TG.png",
    iso2: "TG",
    name: "Togo",
    priority: 0,
    timezone: "Africa/Lome"
  },
  TH: {
    areaCodes: null,
    currency: i.THB,
    dialCode: "66",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TH.png",
    iso2: "TH",
    name: "Thailand (ไทย)",
    priority: 0,
    timezone: "Asia/Bangkok"
  },
  TJ: {
    areaCodes: null,
    currency: i.TJS,
    dialCode: "992",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TJ.png",
    iso2: "TJ",
    name: "Tajikistan",
    priority: 0,
    timezone: "Asia/Dushanbe"
  },
  TK: {
    areaCodes: null,
    currency: i.NZD,
    dialCode: "690",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TK.png",
    iso2: "TK",
    name: "Tokelau",
    priority: 0,
    timezone: "Pacific/Fakaofo"
  },
  TL: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "670",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TL.png",
    iso2: "TL",
    name: "Timor-Leste",
    priority: 0,
    timezone: "Asia/Dili"
  },
  TM: {
    areaCodes: null,
    currency: i.TMT,
    dialCode: "993",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TM.png",
    iso2: "TM",
    name: "Turkmenistan",
    priority: 0,
    timezone: "Asia/Ashgabat"
  },
  TN: {
    areaCodes: null,
    currency: i.TND,
    dialCode: "216",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TN.png",
    iso2: "TN",
    name: "Tunisia (‫تونس‬‎)",
    priority: 0,
    timezone: "Africa/Tunis"
  },
  TO: {
    areaCodes: null,
    currency: i.TOP,
    dialCode: "676",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TO.png",
    iso2: "TO",
    name: "Tonga",
    priority: 0,
    timezone: "Pacific/Tongatapu"
  },
  TR: {
    areaCodes: null,
    currency: i.TRY,
    dialCode: "90",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TR.png",
    iso2: "TR",
    name: "Turkey (Türkiye)",
    priority: 0,
    timezone: "Europe/Istanbul"
  },
  TT: {
    areaCodes: null,
    currency: i.TTD,
    dialCode: "1868",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TT.png",
    iso2: "TT",
    name: "Trinidad and Tobago",
    priority: 0,
    timezone: "America/Port_of_Spain"
  },
  TV: {
    areaCodes: null,
    currency: i.AUD,
    dialCode: "688",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TV.png",
    iso2: "TV",
    name: "Tuvalu",
    priority: 0,
    timezone: "Etc/GMT-12"
  },
  TW: {
    areaCodes: null,
    currency: i.TWD,
    dialCode: "886",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TW.png",
    iso2: "TW",
    name: "Taiwan (台灣)",
    priority: 0,
    timezone: "Asia/Taipei"
  },
  TZ: {
    areaCodes: null,
    currency: i.TZS,
    dialCode: "255",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TZ.png",
    iso2: "TZ",
    name: "Tanzania",
    priority: 0,
    timezone: "Africa/Dar_es_Salaam"
  },
  UA: {
    areaCodes: null,
    currency: i.UAH,
    dialCode: "380",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UA.png",
    iso2: "UA",
    name: "Ukraine (Україна)",
    priority: 0,
    timezone: "Europe/Kiev"
  },
  UG: {
    areaCodes: null,
    currency: i.UGX,
    dialCode: "256",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UG.png",
    iso2: "UG",
    name: "Uganda",
    priority: 0,
    timezone: "Africa/Kampala"
  },
  US: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/US.png",
    iso2: "US",
    name: "United States",
    priority: 0,
    timezone: "America/Chicago"
  },
  UY: {
    areaCodes: null,
    currency: i.UYU,
    dialCode: "598",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UY.png",
    iso2: "UY",
    name: "Uruguay",
    priority: 0,
    timezone: "America/Montevideo"
  },
  UZ: {
    areaCodes: null,
    currency: i.UZS,
    dialCode: "998",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UZ.png",
    iso2: "UZ",
    name: "Uzbekistan (Oʻzbekiston)",
    priority: 0,
    timezone: "Asia/Samarkand"
  },
  VA: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "39",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VA.png",
    iso2: "VA",
    name: "Vatican City (Città del Vaticano)",
    priority: 1,
    timezone: "Europe/Rome"
  },
  VC: {
    areaCodes: null,
    currency: i.XCD,
    dialCode: "1784",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VC.png",
    iso2: "VC",
    name: "Saint Vincent and the Grenadines",
    priority: 0,
    timezone: "America/St_Vincent"
  },
  VE: {
    areaCodes: null,
    currency: i.VES,
    dialCode: "58",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VE.png",
    iso2: "VE",
    name: "Venezuela",
    priority: 0,
    timezone: "America/Caracas"
  },
  VG: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "1284",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VG.png",
    iso2: "VG",
    name: "British Virgin Islands",
    priority: 0,
    timezone: "America/Tortola"
  },
  VI: {
    areaCodes: null,
    currency: i.USD,
    dialCode: "1340",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VI.png",
    iso2: "VI",
    name: "U.S. Virgin Islands",
    priority: 0,
    timezone: "America/St_Thomas"
  },
  VN: {
    areaCodes: null,
    currency: i.VND,
    dialCode: "84",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VN.png",
    iso2: "VN",
    name: "Vietnam (Việt Nam)",
    priority: 0,
    timezone: "Asia/Ho_Chi_Minh"
  },
  VU: {
    areaCodes: null,
    currency: i.VUV,
    dialCode: "678",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VU.png",
    iso2: "VU",
    name: "Vanuatu",
    priority: 0,
    timezone: "Pacific/Efate"
  },
  WF: {
    areaCodes: null,
    currency: i.XPF,
    dialCode: "681",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WF.png",
    iso2: "WF",
    name: "Wallis and Futuna (Wallis-et-Futuna)",
    priority: 0,
    timezone: "Pacific/Wallis"
  },
  WS: {
    areaCodes: null,
    currency: i.WST,
    dialCode: "685",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WS.png",
    iso2: "WS",
    name: "Samoa",
    priority: 0,
    timezone: "Pacific/Apia"
  },
  XK: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "383",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/XK.png",
    iso2: "XK",
    name: "Kosovo",
    priority: 0,
    timezone: "Europe/Rome"
  },
  YE: {
    areaCodes: null,
    currency: i.YER,
    dialCode: "967",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YE.png",
    iso2: "YE",
    name: "Yemen (‫اليمن‬‎)",
    priority: 0,
    timezone: "Asia/Aden"
  },
  YT: {
    areaCodes: null,
    currency: i.EUR,
    dialCode: "262",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YT.png",
    iso2: "YT",
    name: "Mayotte",
    priority: 1,
    timezone: "Indian/Mayotte"
  },
  ZA: {
    areaCodes: null,
    currency: i.ZAR,
    dialCode: "27",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZA.png",
    iso2: "ZA",
    name: "South Africa",
    priority: 0,
    timezone: "Africa/Johannesburg"
  },
  ZM: {
    areaCodes: null,
    currency: i.ZMK,
    dialCode: "260",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZM.png",
    iso2: "ZM",
    name: "Zambia",
    priority: 0,
    timezone: "Africa/Lusaka"
  },
  ZW: {
    areaCodes: null,
    currency: i.ZWL,
    dialCode: "263",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZW.png",
    iso2: "ZW",
    name: "Zimbabwe",
    priority: 0,
    timezone: "Africa/Harare"
  }
};
Object.values(da).map(
  (e) => e.iso2
);
var Hr = /* @__PURE__ */ ((e) => (e.Production = "LIVE", e.Sandbox = "SANDBOX", e.Staging = "STAGING", e.CiCd = "CI-CD", e.Local = "LOCAL", e))(Hr || {});
const Ne = 50;
var Yr = /* @__PURE__ */ ((e) => (e.de_DE = "de-DE", e.en_US = "en-US", e.es_ES = "es-ES", e.fr_FR = "fr-FR", e.it_IT = "it-IT", e.nl_NL = "nl-NL", e.pt_PT = "pt-PT", e))(Yr || {});
Hr.Local, Ir.EUR.code;
Yr.en_US;
var $r = /* @__PURE__ */ ((e) => (e.BookingCreated = "booking:created", e.BookingManagerNewBooking = "booking-manager:new-booking", e.BookingManagerRetrieve = "booking-manager:retrieve", e.BookingManagerRetrieveFail = "booking-manager:retrieve-fail", e.BookingPolicyCreated = "booking-policy:created", e.CancellationPoliciesUpdated = "cancellation-policies:updated", e.CurrencyUpdated = "currency:updated", e.HotelOffersItemClick = "hotel-offer-item:click", e.HotelOffersMarkerClick = "hotel-offers:marker:click", e.HotelOffersPollingStarted = "hotel-offers:polling:started", e.HotelOffersRetrieved = "hotel-offers:retrieved", e.HotelOfferRequestCreated = "hotel-offer-request:created", e.HotelOfferRequestRetrieved = "hotel-offer-request:retrieved", e.HotelRetrieved = "hotel:retrieved", e.HotelRoomOffersBtnClick = "hotel-room-offers:click:btn", e.HotelRoomOffersPriceIncreased = "hotel-room-offers:price-increased", e.HotelRoomOffersRetrieved = "hotel-room-offers:retrieved", e.HotelRoomOfferRequestCreated = "hotel-room-offer-request:created", e.HotelRoomOfferRequestRetrieved = "hotel-room-offer-request:retrieved", e.LangUpdated = "lang:updated", e.PaymentSuccess = "payment:success", e.PrebookForm = "prebook:form", e.BookingFlowStepUpdated = "booking-flow-step:updated", e.HotelOffersViewShowMap = "hotel-offers-view:show-map", e))($r || {}), kr = typeof global == "object" && global && global.Object === Object && global, Oi = typeof self == "object" && self && self.Object === Object && self, ze = kr || Oi || Function("return this")(), $e = ze.Symbol, jr = Object.prototype, Gi = jr.hasOwnProperty, Ki = jr.toString, Be = $e ? $e.toStringTag : void 0;
function Ui(e) {
  var a = Gi.call(e, Be), n = e[Be];
  try {
    e[Be] = void 0;
    var r = !0;
  } catch {
  }
  var c = Ki.call(e);
  return r && (a ? e[Be] = n : delete e[Be]), c;
}
var Fi = Object.prototype, _i = Fi.toString;
function Ii(e) {
  return _i.call(e);
}
var Hi = "[object Null]", Yi = "[object Undefined]", Mn = $e ? $e.toStringTag : void 0;
function We(e) {
  return e == null ? e === void 0 ? Yi : Hi : Mn && Mn in Object(e) ? Ui(e) : Ii(e);
}
function Fe(e) {
  return e != null && typeof e == "object";
}
var ga = Array.isArray;
function Ce(e) {
  var a = typeof e;
  return e != null && (a == "object" || a == "function");
}
function Vr(e) {
  return e;
}
var $i = "[object AsyncFunction]", ki = "[object Function]", ji = "[object GeneratorFunction]", Vi = "[object Proxy]";
function Ja(e) {
  if (!Ce(e))
    return !1;
  var a = We(e);
  return a == ki || a == ji || a == $i || a == Vi;
}
var ia = ze["__core-js_shared__"], Pn = function() {
  var e = /[^.]+$/.exec(ia && ia.keys && ia.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Zi(e) {
  return !!Pn && Pn in e;
}
var xi = Function.prototype, Wi = xi.toString;
function Ji(e) {
  if (e != null) {
    try {
      return Wi.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Xi = /[\\^$.*+?()[\]{}|]/g, qi = /^\[object .+?Constructor\]$/, Qi = Function.prototype, et = Object.prototype, at = Qi.toString, nt = et.hasOwnProperty, rt = RegExp(
  "^" + at.call(nt).replace(Xi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ot(e) {
  if (!Ce(e) || Zi(e))
    return !1;
  var a = Ja(e) ? rt : qi;
  return a.test(Ji(e));
}
function it(e, a) {
  return e?.[a];
}
function Xa(e, a) {
  var n = it(e, a);
  return ot(n) ? n : void 0;
}
var Nn = Object.create, tt = /* @__PURE__ */ function() {
  function e() {
  }
  return function(a) {
    if (!Ce(a))
      return {};
    if (Nn)
      return Nn(a);
    e.prototype = a;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function st(e, a, n) {
  switch (n.length) {
    case 0:
      return e.call(a);
    case 1:
      return e.call(a, n[0]);
    case 2:
      return e.call(a, n[0], n[1]);
    case 3:
      return e.call(a, n[0], n[1], n[2]);
  }
  return e.apply(a, n);
}
function lt(e, a) {
  var n = -1, r = e.length;
  for (a || (a = Array(r)); ++n < r; )
    a[n] = e[n];
  return a;
}
var ut = 800, ct = 16, dt = Date.now;
function gt(e) {
  var a = 0, n = 0;
  return function() {
    var r = dt(), c = ct - (r - n);
    if (n = r, c > 0) {
      if (++a >= ut)
        return arguments[0];
    } else
      a = 0;
    return e.apply(void 0, arguments);
  };
}
function mt(e) {
  return function() {
    return e;
  };
}
var ke = function() {
  try {
    var e = Xa(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), pt = ke ? function(e, a) {
  return ke(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: mt(a),
    writable: !0
  });
} : Vr, ht = gt(pt), ft = 9007199254740991, yt = /^(?:0|[1-9]\d*)$/;
function Zr(e, a) {
  var n = typeof e;
  return a = a ?? ft, !!a && (n == "number" || n != "symbol" && yt.test(e)) && e > -1 && e % 1 == 0 && e < a;
}
function qa(e, a, n) {
  a == "__proto__" && ke ? ke(e, a, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[a] = n;
}
function Je(e, a) {
  return e === a || e !== e && a !== a;
}
var bt = Object.prototype, Dt = bt.hasOwnProperty;
function Ct(e, a, n) {
  var r = e[a];
  (!(Dt.call(e, a) && Je(r, n)) || n === void 0 && !(a in e)) && qa(e, a, n);
}
function vt(e, a, n, r) {
  var c = !n;
  n || (n = {});
  for (var d = -1, u = a.length; ++d < u; ) {
    var s = a[d], g = void 0;
    g === void 0 && (g = e[s]), c ? qa(n, s, g) : Ct(n, s, g);
  }
  return n;
}
var zn = Math.max;
function At(e, a, n) {
  return a = zn(a === void 0 ? e.length - 1 : a, 0), function() {
    for (var r = arguments, c = -1, d = zn(r.length - a, 0), u = Array(d); ++c < d; )
      u[c] = r[a + c];
    c = -1;
    for (var s = Array(a + 1); ++c < a; )
      s[c] = r[c];
    return s[a] = n(u), st(e, this, s);
  };
}
function St(e, a) {
  return ht(At(e, a, Vr), e + "");
}
var Mt = 9007199254740991;
function xr(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Mt;
}
function Qa(e) {
  return e != null && xr(e.length) && !Ja(e);
}
function Pt(e, a, n) {
  if (!Ce(n))
    return !1;
  var r = typeof a;
  return (r == "number" ? Qa(n) && Zr(a, n.length) : r == "string" && a in n) ? Je(n[a], e) : !1;
}
function Nt(e) {
  return St(function(a, n) {
    var r = -1, c = n.length, d = c > 1 ? n[c - 1] : void 0, u = c > 2 ? n[2] : void 0;
    for (d = e.length > 3 && typeof d == "function" ? (c--, d) : void 0, u && Pt(n[0], n[1], u) && (d = c < 3 ? void 0 : d, c = 1), a = Object(a); ++r < c; ) {
      var s = n[r];
      s && e(a, s, r, d);
    }
    return a;
  });
}
var zt = Object.prototype;
function Wr(e) {
  var a = e && e.constructor, n = typeof a == "function" && a.prototype || zt;
  return e === n;
}
function wt(e, a) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = a(n);
  return r;
}
var Rt = "[object Arguments]";
function wn(e) {
  return Fe(e) && We(e) == Rt;
}
var Jr = Object.prototype, Bt = Jr.hasOwnProperty, Tt = Jr.propertyIsEnumerable, ma = wn(/* @__PURE__ */ function() {
  return arguments;
}()) ? wn : function(e) {
  return Fe(e) && Bt.call(e, "callee") && !Tt.call(e, "callee");
};
function Et() {
  return !1;
}
var Xr = typeof exports == "object" && exports && !exports.nodeType && exports, Rn = Xr && typeof module == "object" && module && !module.nodeType && module, Lt = Rn && Rn.exports === Xr, Bn = Lt ? ze.Buffer : void 0, Ot = Bn ? Bn.isBuffer : void 0, qr = Ot || Et, Gt = "[object Arguments]", Kt = "[object Array]", Ut = "[object Boolean]", Ft = "[object Date]", _t = "[object Error]", It = "[object Function]", Ht = "[object Map]", Yt = "[object Number]", $t = "[object Object]", kt = "[object RegExp]", jt = "[object Set]", Vt = "[object String]", Zt = "[object WeakMap]", xt = "[object ArrayBuffer]", Wt = "[object DataView]", Jt = "[object Float32Array]", Xt = "[object Float64Array]", qt = "[object Int8Array]", Qt = "[object Int16Array]", es = "[object Int32Array]", as = "[object Uint8Array]", ns = "[object Uint8ClampedArray]", rs = "[object Uint16Array]", os = "[object Uint32Array]", k = {};
k[Jt] = k[Xt] = k[qt] = k[Qt] = k[es] = k[as] = k[ns] = k[rs] = k[os] = !0;
k[Gt] = k[Kt] = k[xt] = k[Ut] = k[Wt] = k[Ft] = k[_t] = k[It] = k[Ht] = k[Yt] = k[$t] = k[kt] = k[jt] = k[Vt] = k[Zt] = !1;
function is(e) {
  return Fe(e) && xr(e.length) && !!k[We(e)];
}
function ts(e) {
  return function(a) {
    return e(a);
  };
}
var Qr = typeof exports == "object" && exports && !exports.nodeType && exports, Le = Qr && typeof module == "object" && module && !module.nodeType && module, ss = Le && Le.exports === Qr, ta = ss && kr.process, Tn = function() {
  try {
    var e = Le && Le.require && Le.require("util").types;
    return e || ta && ta.binding && ta.binding("util");
  } catch {
  }
}(), En = Tn && Tn.isTypedArray, eo = En ? ts(En) : is;
function ls(e, a) {
  var n = ga(e), r = !n && ma(e), c = !n && !r && qr(e), d = !n && !r && !c && eo(e), u = n || r || c || d, s = u ? wt(e.length, String) : [], g = s.length;
  for (var f in e)
    u && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    c && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    d && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    Zr(f, g)) || s.push(f);
  return s;
}
function us(e, a) {
  return function(n) {
    return e(a(n));
  };
}
function cs(e) {
  var a = [];
  if (e != null)
    for (var n in Object(e))
      a.push(n);
  return a;
}
var ds = Object.prototype, gs = ds.hasOwnProperty;
function ms(e) {
  if (!Ce(e))
    return cs(e);
  var a = Wr(e), n = [];
  for (var r in e)
    r == "constructor" && (a || !gs.call(e, r)) || n.push(r);
  return n;
}
function ao(e) {
  return Qa(e) ? ls(e) : ms(e);
}
var Ge = Xa(Object, "create");
function ps() {
  this.__data__ = Ge ? Ge(null) : {}, this.size = 0;
}
function hs(e) {
  var a = this.has(e) && delete this.__data__[e];
  return this.size -= a ? 1 : 0, a;
}
var fs = "__lodash_hash_undefined__", ys = Object.prototype, bs = ys.hasOwnProperty;
function Ds(e) {
  var a = this.__data__;
  if (Ge) {
    var n = a[e];
    return n === fs ? void 0 : n;
  }
  return bs.call(a, e) ? a[e] : void 0;
}
var Cs = Object.prototype, vs = Cs.hasOwnProperty;
function As(e) {
  var a = this.__data__;
  return Ge ? a[e] !== void 0 : vs.call(a, e);
}
var Ss = "__lodash_hash_undefined__";
function Ms(e, a) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Ge && a === void 0 ? Ss : a, this;
}
function be(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
be.prototype.clear = ps;
be.prototype.delete = hs;
be.prototype.get = Ds;
be.prototype.has = As;
be.prototype.set = Ms;
function Ps() {
  this.__data__ = [], this.size = 0;
}
function Xe(e, a) {
  for (var n = e.length; n--; )
    if (Je(e[n][0], a))
      return n;
  return -1;
}
var Ns = Array.prototype, zs = Ns.splice;
function ws(e) {
  var a = this.__data__, n = Xe(a, e);
  if (n < 0)
    return !1;
  var r = a.length - 1;
  return n == r ? a.pop() : zs.call(a, n, 1), --this.size, !0;
}
function Rs(e) {
  var a = this.__data__, n = Xe(a, e);
  return n < 0 ? void 0 : a[n][1];
}
function Bs(e) {
  return Xe(this.__data__, e) > -1;
}
function Ts(e, a) {
  var n = this.__data__, r = Xe(n, e);
  return r < 0 ? (++this.size, n.push([e, a])) : n[r][1] = a, this;
}
function de(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
de.prototype.clear = Ps;
de.prototype.delete = ws;
de.prototype.get = Rs;
de.prototype.has = Bs;
de.prototype.set = Ts;
var no = Xa(ze, "Map");
function Es() {
  this.size = 0, this.__data__ = {
    hash: new be(),
    map: new (no || de)(),
    string: new be()
  };
}
function Ls(e) {
  var a = typeof e;
  return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? e !== "__proto__" : e === null;
}
function qe(e, a) {
  var n = e.__data__;
  return Ls(a) ? n[typeof a == "string" ? "string" : "hash"] : n.map;
}
function Os(e) {
  var a = qe(this, e).delete(e);
  return this.size -= a ? 1 : 0, a;
}
function Gs(e) {
  return qe(this, e).get(e);
}
function Ks(e) {
  return qe(this, e).has(e);
}
function Us(e, a) {
  var n = qe(this, e), r = n.size;
  return n.set(e, a), this.size += n.size == r ? 0 : 1, this;
}
function we(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
we.prototype.clear = Es;
we.prototype.delete = Os;
we.prototype.get = Gs;
we.prototype.has = Ks;
we.prototype.set = Us;
var ro = us(Object.getPrototypeOf, Object), Fs = "[object Object]", _s = Function.prototype, Is = Object.prototype, oo = _s.toString, Hs = Is.hasOwnProperty, Ys = oo.call(Object);
function $s(e) {
  if (!Fe(e) || We(e) != Fs)
    return !1;
  var a = ro(e);
  if (a === null)
    return !0;
  var n = Hs.call(a, "constructor") && a.constructor;
  return typeof n == "function" && n instanceof n && oo.call(n) == Ys;
}
function ks() {
  this.__data__ = new de(), this.size = 0;
}
function js(e) {
  var a = this.__data__, n = a.delete(e);
  return this.size = a.size, n;
}
function Vs(e) {
  return this.__data__.get(e);
}
function Zs(e) {
  return this.__data__.has(e);
}
var xs = 200;
function Ws(e, a) {
  var n = this.__data__;
  if (n instanceof de) {
    var r = n.__data__;
    if (!no || r.length < xs - 1)
      return r.push([e, a]), this.size = ++n.size, this;
    n = this.__data__ = new we(r);
  }
  return n.set(e, a), this.size = n.size, this;
}
function Re(e) {
  var a = this.__data__ = new de(e);
  this.size = a.size;
}
Re.prototype.clear = ks;
Re.prototype.delete = js;
Re.prototype.get = Vs;
Re.prototype.has = Zs;
Re.prototype.set = Ws;
var io = typeof exports == "object" && exports && !exports.nodeType && exports, Ln = io && typeof module == "object" && module && !module.nodeType && module, Js = Ln && Ln.exports === io, On = Js ? ze.Buffer : void 0;
On && On.allocUnsafe;
function Xs(e, a) {
  return e.slice();
}
var Gn = ze.Uint8Array;
function qs(e) {
  var a = new e.constructor(e.byteLength);
  return new Gn(a).set(new Gn(e)), a;
}
function Qs(e, a) {
  var n = qs(e.buffer);
  return new e.constructor(n, e.byteOffset, e.length);
}
function el(e) {
  return typeof e.constructor == "function" && !Wr(e) ? tt(ro(e)) : {};
}
function al(e) {
  return function(a, n, r) {
    for (var c = -1, d = Object(a), u = r(a), s = u.length; s--; ) {
      var g = u[++c];
      if (n(d[g], g, d) === !1)
        break;
    }
    return a;
  };
}
var nl = al();
function pa(e, a, n) {
  (n !== void 0 && !Je(e[a], n) || n === void 0 && !(a in e)) && qa(e, a, n);
}
function rl(e) {
  return Fe(e) && Qa(e);
}
function ha(e, a) {
  if (!(a === "constructor" && typeof e[a] == "function") && a != "__proto__")
    return e[a];
}
function ol(e) {
  return vt(e, ao(e));
}
function il(e, a, n, r, c, d, u) {
  var s = ha(e, n), g = ha(a, n), f = u.get(g);
  if (f) {
    pa(e, n, f);
    return;
  }
  var b = d ? d(s, g, n + "", e, a, u) : void 0, M = b === void 0;
  if (M) {
    var C = ga(g), S = !C && qr(g), v = !C && !S && eo(g);
    b = g, C || S || v ? ga(s) ? b = s : rl(s) ? b = lt(s) : S ? (M = !1, b = Xs(g)) : v ? (M = !1, b = Qs(g)) : b = [] : $s(g) || ma(g) ? (b = s, ma(s) ? b = ol(s) : (!Ce(s) || Ja(s)) && (b = el(g))) : M = !1;
  }
  M && (u.set(g, b), c(b, g, r, d, u), u.delete(g)), pa(e, n, b);
}
function to(e, a, n, r, c) {
  e !== a && nl(a, function(d, u) {
    if (c || (c = new Re()), Ce(d))
      il(e, a, u, n, to, r, c);
    else {
      var s = r ? r(ha(e, u), d, u + "", e, a, c) : void 0;
      s === void 0 && (s = d), pa(e, u, s);
    }
  }, ao);
}
Nt(function(e, a, n) {
  to(e, a, n);
});
const so = {
  Dr: "dr",
  Mr: "mr",
  Mrs: "mrs",
  Ms: "ms",
  NotSpecified: "notSpecified",
  Prof: "prof"
}, je = {
  Coupon: "COUPON",
  CreditCard: "CREDIT_CARD",
  DepositAccount: "DEPOSIT_ACCOUNT"
}, lo = {
  Ad: "AD",
  Ae: "AE",
  Af: "AF",
  Ag: "AG",
  Ai: "AI",
  Al: "AL",
  Am: "AM",
  Ao: "AO",
  Ar: "AR",
  As: "AS",
  At: "AT",
  Au: "AU",
  Aw: "AW",
  Ax: "AX",
  Az: "AZ",
  Ba: "BA",
  Bb: "BB",
  Bd: "BD",
  Be: "BE",
  Bf: "BF",
  Bg: "BG",
  Bh: "BH",
  Bi: "BI",
  Bj: "BJ",
  Bl: "BL",
  Bm: "BM",
  Bn: "BN",
  Bo: "BO",
  Bq: "BQ",
  Br: "BR",
  Bs: "BS",
  Bt: "BT",
  Bw: "BW",
  By: "BY",
  Bz: "BZ",
  Ca: "CA",
  Cc: "CC",
  Cd: "CD",
  Cf: "CF",
  Cg: "CG",
  Ch: "CH",
  Ci: "CI",
  Ck: "CK",
  Cl: "CL",
  Cm: "CM",
  Cn: "CN",
  Co: "CO",
  Cr: "CR",
  Cu: "CU",
  Cv: "CV",
  Cw: "CW",
  Cx: "CX",
  Cy: "CY",
  Cz: "CZ",
  De: "DE",
  Dj: "DJ",
  Dk: "DK",
  Dm: "DM",
  Do: "DO",
  Dz: "DZ",
  Ec: "EC",
  Ee: "EE",
  Eg: "EG",
  Eh: "EH",
  Er: "ER",
  Es: "ES",
  Et: "ET",
  Fi: "FI",
  Fj: "FJ",
  Fk: "FK",
  Fm: "FM",
  Fo: "FO",
  Fr: "FR",
  Ga: "GA",
  Gb: "GB",
  Gd: "GD",
  Ge: "GE",
  Gf: "GF",
  Gg: "GG",
  Gh: "GH",
  Gi: "GI",
  Gl: "GL",
  Gm: "GM",
  Gn: "GN",
  Gp: "GP",
  Gq: "GQ",
  Gr: "GR",
  Gt: "GT",
  Gu: "GU",
  Gw: "GW",
  Gy: "GY",
  Hk: "HK",
  Hn: "HN",
  Hr: "HR",
  Ht: "HT",
  Hu: "HU",
  Id: "ID",
  Ie: "IE",
  Il: "IL",
  Im: "IM",
  In: "IN",
  Io: "IO",
  Iq: "IQ",
  Ir: "IR",
  Is: "IS",
  It: "IT",
  Je: "JE",
  Jm: "JM",
  Jo: "JO",
  Jp: "JP",
  Ke: "KE",
  Kg: "KG",
  Kh: "KH",
  Ki: "KI",
  Km: "KM",
  Kn: "KN",
  Kp: "KP",
  Kr: "KR",
  Kw: "KW",
  Ky: "KY",
  Kz: "KZ",
  La: "LA",
  Lb: "LB",
  Lc: "LC",
  Li: "LI",
  Lk: "LK",
  Lr: "LR",
  Ls: "LS",
  Lt: "LT",
  Lu: "LU",
  Lv: "LV",
  Ly: "LY",
  Ma: "MA",
  Mc: "MC",
  Md: "MD",
  Me: "ME",
  Mf: "MF",
  Mg: "MG",
  Mh: "MH",
  Mk: "MK",
  Ml: "ML",
  Mm: "MM",
  Mn: "MN",
  Mo: "MO",
  Mp: "MP",
  Mq: "MQ",
  Mr: "MR",
  Ms: "MS",
  Mt: "MT",
  Mu: "MU",
  Mv: "MV",
  Mw: "MW",
  Mx: "MX",
  My: "MY",
  Mz: "MZ",
  Na: "NA",
  Nc: "NC",
  Ne: "NE",
  Nf: "NF",
  Ng: "NG",
  Ni: "NI",
  Nl: "NL",
  No: "NO",
  Np: "NP",
  Nr: "NR",
  Nu: "NU",
  Nz: "NZ",
  Om: "OM",
  Pa: "PA",
  Pe: "PE",
  Pf: "PF",
  Pg: "PG",
  Ph: "PH",
  Pk: "PK",
  Pl: "PL",
  Pm: "PM",
  Pr: "PR",
  Ps: "PS",
  Pt: "PT",
  Pw: "PW",
  Py: "PY",
  Qa: "QA",
  Re: "RE",
  Ro: "RO",
  Rs: "RS",
  Ru: "RU",
  Rw: "RW",
  Sa: "SA",
  Sb: "SB",
  Sc: "SC",
  Sd: "SD",
  Se: "SE",
  Sg: "SG",
  Sh: "SH",
  Si: "SI",
  Sj: "SJ",
  Sk: "SK",
  Sl: "SL",
  Sm: "SM",
  Sn: "SN",
  So: "SO",
  Sr: "SR",
  Ss: "SS",
  St: "ST",
  Sv: "SV",
  Sx: "SX",
  Sy: "SY",
  Sz: "SZ",
  Tc: "TC",
  Td: "TD",
  Tg: "TG",
  Th: "TH",
  Tj: "TJ",
  Tk: "TK",
  Tl: "TL",
  Tm: "TM",
  Tn: "TN",
  To: "TO",
  Tr: "TR",
  Tt: "TT",
  Tv: "TV",
  Tw: "TW",
  Tz: "TZ",
  Ua: "UA",
  Ug: "UG",
  Us: "US",
  Uy: "UY",
  Uz: "UZ",
  Va: "VA",
  Vc: "VC",
  Ve: "VE",
  Vg: "VG",
  Vi: "VI",
  Vn: "VN",
  Vu: "VU",
  Wf: "WF",
  Ws: "WS",
  Xk: "XK",
  Ye: "YE",
  Yt: "YT",
  Za: "ZA",
  Zm: "ZM",
  Zw: "ZW"
};
var He = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function oe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var fa = { exports: {} }, tl = fa.exports, Kn;
function sl() {
  return Kn || (Kn = 1, function(e, a) {
    (function(n, r, c) {
      e.exports = c(), e.exports.default = c();
    })("slugify", tl, function() {
      var n = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E'","Ը":"Y'","Թ":"T'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C'","Կ":"K","Հ":"H","Ձ":"D'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P'","Ք":"Q'","Օ":"O''","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"'","’":"'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}`), r = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}');
      function c(d, u) {
        if (typeof d != "string")
          throw new Error("slugify: string argument expected");
        u = typeof u == "string" ? { replacement: u } : u || {};
        var s = r[u.locale] || {}, g = u.replacement === void 0 ? "-" : u.replacement, f = u.trim === void 0 ? !0 : u.trim, b = d.normalize().split("").reduce(function(M, C) {
          var S = s[C];
          return S === void 0 && (S = n[C]), S === void 0 && (S = C), S === g && (S = " "), M + S.replace(u.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        return u.strict && (b = b.replace(/[^A-Za-z0-9\s]/g, "")), f && (b = b.trim()), b = b.replace(/\s+/g, g), u.lower && (b = b.toLowerCase()), b;
      }
      return c.extend = function(d) {
        Object.assign(n, d);
      }, c;
    });
  }(fa)), fa.exports;
}
sl();
function ll(e, a) {
  const n = {};
  for (const r of a)
    Object.hasOwn(e, r) && (n[r] = e[r]);
  return n;
}
var t = /* @__PURE__ */ ((e) => (e.AED = "AED", e.AFN = "AFN", e.ALL = "ALL", e.AMD = "AMD", e.ANG = "ANG", e.AOA = "AOA", e.ARS = "ARS", e.AUD = "AUD", e.AWG = "AWG", e.AZN = "AZN", e.BAM = "BAM", e.BBD = "BBD", e.BDT = "BDT", e.BGN = "BGN", e.BHD = "BHD", e.BIF = "BIF", e.BMD = "BMD", e.BND = "BND", e.BOB = "BOB", e.BRL = "BRL", e.BSD = "BSD", e.BTN = "BTN", e.BWP = "BWP", e.BYN = "BYN", e.BYR = "BYR", e.BZD = "BZD", e.CAD = "CAD", e.CDF = "CDF", e.CHF = "CHF", e.CLF = "CLF", e.CLP = "CLP", e.CNY = "CNY", e.COP = "COP", e.CRC = "CRC", e.CUC = "CUC", e.CUP = "CUP", e.CVE = "CVE", e.CZK = "CZK", e.DJF = "DJF", e.DKK = "DKK", e.DOP = "DOP", e.DZD = "DZD", e.EEK = "EEK", e.EGP = "EGP", e.ERN = "ERN", e.ETB = "ETB", e.EUR = "EUR", e.FJD = "FJD", e.FKP = "FKP", e.GBP = "GBP", e.GEL = "GEL", e.GHS = "GHS", e.GIP = "GIP", e.GMD = "GMD", e.GNF = "GNF", e.GTQ = "GTQ", e.GYD = "GYD", e.HKD = "HKD", e.HNL = "HNL", e.HRK = "HRK", e.HTG = "HTG", e.HUF = "HUF", e.IDR = "IDR", e.ILS = "ILS", e.INR = "INR", e.IQD = "IQD", e.IRR = "IRR", e.ISK = "ISK", e.JMD = "JMD", e.JOD = "JOD", e.JPY = "JPY", e.KES = "KES", e.KGS = "KGS", e.KHR = "KHR", e.KMF = "KMF", e.KPW = "KPW", e.KRW = "KRW", e.KWD = "KWD", e.KYD = "KYD", e.KZT = "KZT", e.LAK = "LAK", e.LBP = "LBP", e.LKR = "LKR", e.LRD = "LRD", e.LSL = "LSL", e.LTL = "LTL", e.LVL = "LVL", e.LYD = "LYD", e.MAD = "MAD", e.MDL = "MDL", e.MGA = "MGA", e.MKD = "MKD", e.MMK = "MMK", e.MNT = "MNT", e.MOP = "MOP", e.MRO = "MRO", e.MRU = "MRU", e.MUR = "MUR", e.MVR = "MVR", e.MWK = "MWK", e.MXN = "MXN", e.MYR = "MYR", e.MZN = "MZN", e.NAD = "NAD", e.NGN = "NGN", e.NIO = "NIO", e.NOK = "NOK", e.NPR = "NPR", e.NZD = "NZD", e.OMR = "OMR", e.PAB = "PAB", e.PEN = "PEN", e.PGK = "PGK", e.PHP = "PHP", e.PKR = "PKR", e.PLN = "PLN", e.PYG = "PYG", e.QAR = "QAR", e.RON = "RON", e.RSD = "RSD", e.RUB = "RUB", e.RWF = "RWF", e.SAR = "SAR", e.SBD = "SBD", e.SCR = "SCR", e.SDG = "SDG", e.SEK = "SEK", e.SGD = "SGD", e.SHP = "SHP", e.SLL = "SLL", e.SOS = "SOS", e.SRD = "SRD", e.SSP = "SSP", e.STD = "STD", e.SYP = "SYP", e.SZL = "SZL", e.THB = "THB", e.TJS = "TJS", e.TMT = "TMT", e.TND = "TND", e.TOP = "TOP", e.TRY = "TRY", e.TTD = "TTD", e.TWD = "TWD", e.TZS = "TZS", e.UAH = "UAH", e.UGX = "UGX", e.USD = "USD", e.UYU = "UYU", e.UZS = "UZS", e.VEF = "VEF", e.VES = "VES", e.VND = "VND", e.VUV = "VUV", e.WST = "WST", e.XAF = "XAF", e.XCD = "XCD", e.XOF = "XOF", e.XPF = "XPF", e.YER = "YER", e.ZAR = "ZAR", e.ZMK = "ZMK", e.ZMW = "ZMW", e.ZWL = "ZWL", e))(t || {});
const en = {
  AED: {
    code: "AED",
    decimalDigits: 2,
    name: "United Arab Emirates Dirham",
    namePlural: "UAE dirhams",
    rounding: 0,
    symbol: "AED",
    symbolNative: "د.إ.‏",
    zeroDecimal: !1
  },
  AFN: {
    code: "AFN",
    decimalDigits: 0,
    name: "Afghan Afghani",
    namePlural: "Afghan Afghanis",
    rounding: 0,
    symbol: "Af",
    symbolNative: "؋",
    zeroDecimal: !1
  },
  ALL: {
    code: "ALL",
    decimalDigits: 0,
    name: "Albanian Lek",
    namePlural: "Albanian lekë",
    rounding: 0,
    symbol: "ALL",
    symbolNative: "Lek",
    zeroDecimal: !1
  },
  AMD: {
    code: "AMD",
    decimalDigits: 0,
    name: "Armenian Dram",
    namePlural: "Armenian drams",
    rounding: 0,
    symbol: "AMD",
    symbolNative: "դր.",
    zeroDecimal: !1
  },
  ANG: {
    code: "ANG",
    decimalDigits: 2,
    name: "Netherlands Antillean Guilder",
    namePlural: "Netherlands Antillean guilders",
    rounding: 0,
    symbol: "ANG",
    symbolNative: "NAf.",
    zeroDecimal: !1
  },
  AOA: {
    code: "AOA",
    decimalDigits: 2,
    name: "Angolan Kwanza",
    namePlural: "Angolan kwanzas",
    rounding: 0,
    symbol: "AOA",
    symbolNative: "Kz",
    zeroDecimal: !1
  },
  ARS: {
    code: "ARS",
    decimalDigits: 2,
    name: "Argentine Peso",
    namePlural: "Argentine pesos",
    rounding: 0,
    symbol: "AR$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  AUD: {
    code: "AUD",
    decimalDigits: 2,
    name: "Australian Dollar",
    namePlural: "Australian dollars",
    rounding: 0,
    symbol: "AU$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  AWG: {
    code: "AWG",
    decimalDigits: 2,
    name: "Aruban Florin",
    namePlural: "Aruban florin",
    rounding: 0,
    symbol: "AWG",
    symbolNative: "Afl.",
    zeroDecimal: !1
  },
  AZN: {
    code: "AZN",
    decimalDigits: 2,
    name: "Azerbaijani Manat",
    namePlural: "Azerbaijani manats",
    rounding: 0,
    symbol: "man.",
    symbolNative: "ман.",
    zeroDecimal: !1
  },
  BAM: {
    code: "BAM",
    decimalDigits: 2,
    name: "Bosnia-Herzegovina Convertible Mark",
    namePlural: "Bosnia-Herzegovina convertible marks",
    rounding: 0,
    symbol: "KM",
    symbolNative: "KM",
    zeroDecimal: !1
  },
  BBD: {
    code: "BBD",
    decimalDigits: 2,
    name: "Barbadian Dollar",
    namePlural: "Barbadian dollars",
    rounding: 0,
    symbol: "BBD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BDT: {
    code: "BDT",
    decimalDigits: 2,
    name: "Bangladeshi Taka",
    namePlural: "Bangladeshi takas",
    rounding: 0,
    symbol: "Tk",
    symbolNative: "৳",
    zeroDecimal: !1
  },
  BGN: {
    code: "BGN",
    decimalDigits: 2,
    name: "Bulgarian Lev",
    namePlural: "Bulgarian leva",
    rounding: 0,
    symbol: "BGN",
    symbolNative: "лв.",
    zeroDecimal: !1
  },
  BHD: {
    code: "BHD",
    decimalDigits: 3,
    name: "Bahraini Dinar",
    namePlural: "Bahraini dinars",
    rounding: 0,
    symbol: "BD",
    symbolNative: "د.ب.‏",
    zeroDecimal: !1
  },
  BIF: {
    code: "BIF",
    decimalDigits: 0,
    name: "Burundian Franc",
    namePlural: "Burundian francs",
    rounding: 0,
    symbol: "FBu",
    symbolNative: "FBu",
    zeroDecimal: !0
  },
  BMD: {
    code: "BMD",
    decimalDigits: 2,
    name: "Bermudan Dollar",
    namePlural: "Bermudan dollars",
    rounding: 0,
    symbol: "BMD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BND: {
    code: "BND",
    decimalDigits: 2,
    name: "Brunei Dollar",
    namePlural: "Brunei dollars",
    rounding: 0,
    symbol: "BN$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BOB: {
    code: "BOB",
    decimalDigits: 2,
    name: "Bolivian Boliviano",
    namePlural: "Bolivian bolivianos",
    rounding: 0,
    symbol: "Bs",
    symbolNative: "Bs",
    zeroDecimal: !1
  },
  BRL: {
    code: "BRL",
    decimalDigits: 2,
    name: "Brazilian Real",
    namePlural: "Brazilian reals",
    rounding: 0,
    symbol: "R$",
    symbolNative: "R$",
    zeroDecimal: !1
  },
  BSD: {
    code: "BSD",
    decimalDigits: 2,
    name: "Bahamian Dollar",
    namePlural: "Bahamian dollars",
    rounding: 0,
    symbol: "BSD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  BTN: {
    code: "BTN",
    decimalDigits: 2,
    name: "Bhutanese Ngultrum",
    namePlural: "Bhutanese ngultrums",
    rounding: 0,
    symbol: "BTN",
    symbolNative: "Nu.",
    zeroDecimal: !1
  },
  BWP: {
    code: "BWP",
    decimalDigits: 2,
    name: "Botswanan Pula",
    namePlural: "Botswanan pulas",
    rounding: 0,
    symbol: "BWP",
    symbolNative: "P",
    zeroDecimal: !1
  },
  BYN: {
    code: "BYN",
    decimalDigits: 2,
    name: "Belarusian Ruble",
    namePlural: "Belarusian rubles",
    rounding: 0,
    symbol: "Br",
    symbolNative: "руб.",
    zeroDecimal: !1
  },
  BYR: {
    code: "BYR",
    decimalDigits: 0,
    deprecated: !0,
    name: "Belarusian Ruble",
    namePlural: "Belarusian rubles",
    rounding: 0,
    symbol: "BYR",
    symbolNative: "BYR",
    zeroDecimal: !1
  },
  BZD: {
    code: "BZD",
    decimalDigits: 2,
    name: "Belize Dollar",
    namePlural: "Belize dollars",
    rounding: 0,
    symbol: "BZ$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CAD: {
    code: "CAD",
    decimalDigits: 2,
    name: "Canadian Dollar",
    namePlural: "Canadian dollars",
    rounding: 0,
    symbol: "CA$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CDF: {
    code: "CDF",
    decimalDigits: 2,
    name: "Congolese Franc",
    namePlural: "Congolese francs",
    rounding: 0,
    symbol: "CDF",
    symbolNative: "FrCD",
    zeroDecimal: !1
  },
  CHF: {
    code: "CHF",
    decimalDigits: 2,
    name: "Swiss Franc",
    namePlural: "Swiss francs",
    rounding: 0.05,
    symbol: "CHF",
    symbolNative: "CHF",
    zeroDecimal: !1
  },
  CLF: {
    code: "CLF",
    decimalDigits: 4,
    deprecated: !0,
    name: "Chilean Unit of Account (UF)",
    namePlural: "Chilean units of account (UF)",
    rounding: 0,
    symbol: "CLF",
    symbolNative: "CLF",
    zeroDecimal: !1
  },
  CLP: {
    code: "CLP",
    decimalDigits: 0,
    name: "Chilean Peso",
    namePlural: "Chilean pesos",
    rounding: 0,
    symbol: "CL$",
    symbolNative: "$",
    zeroDecimal: !0
  },
  CNY: {
    code: "CNY",
    decimalDigits: 2,
    name: "Chinese Yuan",
    namePlural: "Chinese yuan",
    rounding: 0,
    symbol: "CN¥",
    symbolNative: "CN¥",
    zeroDecimal: !1
  },
  COP: {
    code: "COP",
    decimalDigits: 0,
    name: "Colombian Peso",
    namePlural: "Colombian pesos",
    rounding: 0,
    symbol: "CO$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CRC: {
    code: "CRC",
    decimalDigits: 0,
    name: "Costa Rican Colón",
    namePlural: "Costa Rican colóns",
    rounding: 0,
    symbol: "₡",
    symbolNative: "₡",
    zeroDecimal: !1
  },
  CUC: {
    code: "CUC",
    decimalDigits: 2,
    name: "Cuban Convertible Peso",
    namePlural: "Cuban convertible pesos",
    rounding: 0,
    symbol: "CUC",
    symbolNative: "CUC",
    zeroDecimal: !1
  },
  CUP: {
    code: "CUP",
    decimalDigits: 2,
    name: "Cuban Peso",
    namePlural: "Cuban pesos",
    rounding: 0,
    symbol: "CUP",
    symbolNative: "$",
    zeroDecimal: !1
  },
  CVE: {
    code: "CVE",
    decimalDigits: 2,
    name: "Cape Verdean Escudo",
    namePlural: "Cape Verdean escudos",
    rounding: 0,
    symbol: "CV$",
    symbolNative: "CV$",
    zeroDecimal: !1
  },
  CZK: {
    code: "CZK",
    decimalDigits: 2,
    name: "Czech Republic Koruna",
    namePlural: "Czech Republic korunas",
    rounding: 0,
    symbol: "Kč",
    symbolNative: "Kč",
    zeroDecimal: !1
  },
  DJF: {
    code: "DJF",
    decimalDigits: 0,
    name: "Djiboutian Franc",
    namePlural: "Djiboutian francs",
    rounding: 0,
    symbol: "Fdj",
    symbolNative: "Fdj",
    zeroDecimal: !0
  },
  DKK: {
    code: "DKK",
    decimalDigits: 2,
    name: "Danish Krone",
    namePlural: "Danish kroner",
    rounding: 0,
    symbol: "Dkr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  DOP: {
    code: "DOP",
    decimalDigits: 2,
    name: "Dominican Peso",
    namePlural: "Dominican pesos",
    rounding: 0,
    symbol: "RD$",
    symbolNative: "RD$",
    zeroDecimal: !1
  },
  DZD: {
    code: "DZD",
    decimalDigits: 2,
    name: "Algerian Dinar",
    namePlural: "Algerian dinars",
    rounding: 0,
    symbol: "DA",
    symbolNative: "د.ج.‏",
    zeroDecimal: !1
  },
  EEK: {
    code: "EEK",
    decimalDigits: 2,
    deprecated: !0,
    name: "Estonian Kroon",
    namePlural: "Estonian kroons",
    rounding: 0,
    symbol: "Ekr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  EGP: {
    code: "EGP",
    decimalDigits: 2,
    name: "Egyptian Pound",
    namePlural: "Egyptian pounds",
    rounding: 0,
    symbol: "EGP",
    symbolNative: "ج.م.‏",
    zeroDecimal: !1
  },
  ERN: {
    code: "ERN",
    decimalDigits: 2,
    name: "Eritrean Nakfa",
    namePlural: "Eritrean nakfas",
    rounding: 0,
    symbol: "Nfk",
    symbolNative: "Nfk",
    zeroDecimal: !1
  },
  ETB: {
    code: "ETB",
    decimalDigits: 2,
    name: "Ethiopian Birr",
    namePlural: "Ethiopian birrs",
    rounding: 0,
    symbol: "Br",
    symbolNative: "Br",
    zeroDecimal: !1
  },
  EUR: {
    code: "EUR",
    decimalDigits: 2,
    name: "Euro",
    namePlural: "euros",
    rounding: 0,
    symbol: "€",
    symbolNative: "€",
    zeroDecimal: !1
  },
  FJD: {
    code: "FJD",
    decimalDigits: 2,
    name: "Fijian Dollar",
    namePlural: "Fijian dollars",
    rounding: 0,
    symbol: "FJD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  FKP: {
    code: "FKP",
    decimalDigits: 2,
    name: "Falkland Islands Pound",
    namePlural: "Falkland Islands pounds",
    rounding: 0,
    symbol: "FKP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GBP: {
    code: "GBP",
    decimalDigits: 2,
    name: "British Pound Sterling",
    namePlural: "British pounds sterling",
    rounding: 0,
    symbol: "£",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GEL: {
    code: "GEL",
    decimalDigits: 2,
    name: "Georgian Lari",
    namePlural: "Georgian laris",
    rounding: 0,
    symbol: "GEL",
    symbolNative: "GEL",
    zeroDecimal: !1
  },
  GHS: {
    code: "GHS",
    decimalDigits: 2,
    name: "Ghanaian Cedi",
    namePlural: "Ghanaian cedis",
    rounding: 0,
    symbol: "GH₵",
    symbolNative: "GH₵",
    zeroDecimal: !1
  },
  GIP: {
    code: "GIP",
    decimalDigits: 2,
    name: "Gibraltar Pound",
    namePlural: "Gibraltar pounds",
    rounding: 0,
    symbol: "GIP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  GMD: {
    code: "GMD",
    decimalDigits: 2,
    name: "Gambian Dalasi",
    namePlural: "Gambian dalasis",
    rounding: 0,
    symbol: "GMD",
    symbolNative: "D",
    zeroDecimal: !1
  },
  GNF: {
    code: "GNF",
    decimalDigits: 0,
    name: "Guinean Franc",
    namePlural: "Guinean francs",
    rounding: 0,
    symbol: "FG",
    symbolNative: "FG",
    zeroDecimal: !0
  },
  GTQ: {
    code: "GTQ",
    decimalDigits: 2,
    name: "Guatemalan Quetzal",
    namePlural: "Guatemalan quetzals",
    rounding: 0,
    symbol: "GTQ",
    symbolNative: "Q",
    zeroDecimal: !1
  },
  GYD: {
    code: "GYD",
    decimalDigits: 0,
    name: "Guyanaese Dollar",
    namePlural: "Guyanaese dollars",
    rounding: 0,
    symbol: "GYD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  HKD: {
    code: "HKD",
    decimalDigits: 2,
    name: "Hong Kong Dollar",
    namePlural: "Hong Kong dollars",
    rounding: 0,
    symbol: "HK$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  HNL: {
    code: "HNL",
    decimalDigits: 2,
    name: "Honduran Lempira",
    namePlural: "Honduran lempiras",
    rounding: 0,
    symbol: "HNL",
    symbolNative: "L",
    zeroDecimal: !1
  },
  HRK: {
    code: "HRK",
    decimalDigits: 2,
    deprecated: !0,
    name: "Croatian Kuna",
    namePlural: "Croatian kunas",
    rounding: 0,
    symbol: "kn",
    symbolNative: "kn",
    zeroDecimal: !1
  },
  HTG: {
    code: "HTG",
    decimalDigits: 2,
    name: "Haitian Gourde",
    namePlural: "Haitian gourdes",
    rounding: 0,
    symbol: "HTG",
    symbolNative: "G",
    zeroDecimal: !1
  },
  HUF: {
    code: "HUF",
    decimalDigits: 0,
    name: "Hungarian Forint",
    namePlural: "Hungarian forints",
    rounding: 0,
    symbol: "Ft",
    symbolNative: "Ft",
    zeroDecimal: !1
  },
  IDR: {
    code: "IDR",
    decimalDigits: 0,
    name: "Indonesian Rupiah",
    namePlural: "Indonesian rupiahs",
    rounding: 0,
    symbol: "Rp",
    symbolNative: "Rp",
    zeroDecimal: !1
  },
  ILS: {
    code: "ILS",
    decimalDigits: 2,
    name: "Israeli New Sheqel",
    namePlural: "Israeli new sheqels",
    rounding: 0,
    symbol: "₪",
    symbolNative: "₪",
    zeroDecimal: !1
  },
  INR: {
    code: "INR",
    decimalDigits: 2,
    name: "Indian Rupee",
    namePlural: "Indian rupees",
    rounding: 0,
    symbol: "Rs",
    symbolNative: "টকা",
    zeroDecimal: !1
  },
  IQD: {
    code: "IQD",
    decimalDigits: 0,
    name: "Iraqi Dinar",
    namePlural: "Iraqi dinars",
    rounding: 0,
    symbol: "IQD",
    symbolNative: "د.ع.‏",
    zeroDecimal: !1
  },
  IRR: {
    code: "IRR",
    decimalDigits: 0,
    name: "Iranian Rial",
    namePlural: "Iranian rials",
    rounding: 0,
    symbol: "IRR",
    symbolNative: "﷼",
    zeroDecimal: !0
  },
  ISK: {
    code: "ISK",
    decimalDigits: 0,
    name: "Icelandic Króna",
    namePlural: "Icelandic krónur",
    rounding: 0,
    symbol: "Ikr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  JMD: {
    code: "JMD",
    decimalDigits: 2,
    name: "Jamaican Dollar",
    namePlural: "Jamaican dollars",
    rounding: 0,
    symbol: "J$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  JOD: {
    code: "JOD",
    decimalDigits: 3,
    name: "Jordanian Dinar",
    namePlural: "Jordanian dinars",
    rounding: 0,
    symbol: "JD",
    symbolNative: "د.أ.‏",
    zeroDecimal: !1
  },
  JPY: {
    code: "JPY",
    decimalDigits: 0,
    name: "Japanese Yen",
    namePlural: "Japanese yen",
    rounding: 0,
    symbol: "¥",
    symbolNative: "￥",
    zeroDecimal: !0
  },
  KES: {
    code: "KES",
    decimalDigits: 2,
    name: "Kenyan Shilling",
    namePlural: "Kenyan shillings",
    rounding: 0,
    symbol: "Ksh",
    symbolNative: "Ksh",
    zeroDecimal: !1
  },
  KGS: {
    code: "KGS",
    decimalDigits: 2,
    name: "Kyrgystani Som",
    namePlural: "Kyrgystani soms",
    rounding: 0,
    symbol: "KGS",
    symbolNative: "сом",
    zeroDecimal: !1
  },
  KHR: {
    code: "KHR",
    decimalDigits: 2,
    name: "Cambodian Riel",
    namePlural: "Cambodian riels",
    rounding: 0,
    symbol: "KHR",
    symbolNative: "៛",
    zeroDecimal: !1
  },
  KMF: {
    code: "KMF",
    decimalDigits: 0,
    name: "Comorian Franc",
    namePlural: "Comorian francs",
    rounding: 0,
    symbol: "CF",
    symbolNative: "FC",
    zeroDecimal: !0
  },
  KPW: {
    code: "KPW",
    decimalDigits: 0,
    name: "North Korean Won",
    namePlural: "North Korean won",
    rounding: 0,
    symbol: "KPW",
    symbolNative: "KPW",
    zeroDecimal: !1
  },
  KRW: {
    code: "KRW",
    decimalDigits: 0,
    name: "South Korean Won",
    namePlural: "South Korean won",
    rounding: 0,
    symbol: "₩",
    symbolNative: "₩",
    zeroDecimal: !0
  },
  KWD: {
    code: "KWD",
    decimalDigits: 3,
    name: "Kuwaiti Dinar",
    namePlural: "Kuwaiti dinars",
    rounding: 0,
    symbol: "KD",
    symbolNative: "د.ك.‏",
    zeroDecimal: !1
  },
  KYD: {
    code: "KYD",
    decimalDigits: 2,
    name: "Cayman Islands Dollar",
    namePlural: "Cayman Islands dollars",
    rounding: 0,
    symbol: "KYD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  KZT: {
    code: "KZT",
    decimalDigits: 2,
    name: "Kazakhstani Tenge",
    namePlural: "Kazakhstani tenges",
    rounding: 0,
    symbol: "KZT",
    symbolNative: "тңг.",
    zeroDecimal: !1
  },
  LAK: {
    code: "LAK",
    decimalDigits: 0,
    name: "Laotian Kip",
    namePlural: "Laotian kips",
    rounding: 0,
    symbol: "LAK",
    symbolNative: "₭",
    zeroDecimal: !1
  },
  LBP: {
    code: "LBP",
    decimalDigits: 0,
    name: "Lebanese Pound",
    namePlural: "Lebanese pounds",
    rounding: 0,
    symbol: "LB£",
    symbolNative: "ل.ل.‏",
    zeroDecimal: !1
  },
  LKR: {
    code: "LKR",
    decimalDigits: 2,
    name: "Sri Lankan Rupee",
    namePlural: "Sri Lankan rupees",
    rounding: 0,
    symbol: "SLRs",
    symbolNative: "SL Re",
    zeroDecimal: !1
  },
  LRD: {
    code: "LRD",
    decimalDigits: 2,
    name: "Liberian Dollar",
    namePlural: "Liberian dollars",
    rounding: 0,
    symbol: "LRD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  LSL: {
    code: "LSL",
    decimalDigits: 2,
    name: "Lesotho Loti",
    namePlural: "Lesotho lotis",
    rounding: 0,
    symbol: "LSL",
    symbolNative: "LSL",
    zeroDecimal: !1
  },
  LTL: {
    code: "LTL",
    decimalDigits: 2,
    deprecated: !0,
    name: "Lithuanian Litas",
    namePlural: "Lithuanian litai",
    rounding: 0,
    symbol: "Lt",
    symbolNative: "Lt",
    zeroDecimal: !1
  },
  LVL: {
    code: "LVL",
    decimalDigits: 2,
    deprecated: !0,
    name: "Latvian Lats",
    namePlural: "Latvian lati",
    rounding: 0,
    symbol: "Ls",
    symbolNative: "Ls",
    zeroDecimal: !1
  },
  LYD: {
    code: "LYD",
    decimalDigits: 3,
    name: "Libyan Dinar",
    namePlural: "Libyan dinars",
    rounding: 0,
    symbol: "LD",
    symbolNative: "د.ل.‏",
    zeroDecimal: !1
  },
  MAD: {
    code: "MAD",
    decimalDigits: 2,
    name: "Moroccan Dirham",
    namePlural: "Moroccan dirhams",
    rounding: 0,
    symbol: "MAD",
    symbolNative: "د.م.‏",
    zeroDecimal: !1
  },
  MDL: {
    code: "MDL",
    decimalDigits: 2,
    name: "Moldovan Leu",
    namePlural: "Moldovan lei",
    rounding: 0,
    symbol: "MDL",
    symbolNative: "MDL",
    zeroDecimal: !1
  },
  MGA: {
    code: "MGA",
    decimalDigits: 0,
    name: "Malagasy Ariary",
    namePlural: "Malagasy Ariaries",
    rounding: 0,
    symbol: "MGA",
    symbolNative: "MGA",
    zeroDecimal: !0
  },
  MKD: {
    code: "MKD",
    decimalDigits: 2,
    name: "Macedonian Denar",
    namePlural: "Macedonian denari",
    rounding: 0,
    symbol: "MKD",
    symbolNative: "MKD",
    zeroDecimal: !1
  },
  MMK: {
    code: "MMK",
    decimalDigits: 0,
    name: "Myanma Kyat",
    namePlural: "Myanma kyats",
    rounding: 0,
    symbol: "MMK",
    symbolNative: "K",
    zeroDecimal: !1
  },
  MNT: {
    code: "MNT",
    decimalDigits: 0,
    name: "Mongolian Tugrik",
    namePlural: "Mongolian tugriks",
    rounding: 0,
    symbol: "MNT",
    symbolNative: "₮",
    zeroDecimal: !1
  },
  MOP: {
    code: "MOP",
    decimalDigits: 2,
    name: "Macanese Pataca",
    namePlural: "Macanese patacas",
    rounding: 0,
    symbol: "MOP$",
    symbolNative: "MOP$",
    zeroDecimal: !1
  },
  MRO: {
    code: "MRO",
    decimalDigits: 0,
    deprecated: !0,
    name: "Mauritanian Ouguiya",
    namePlural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "MRO",
    symbolNative: "أ.م.‏",
    zeroDecimal: !1
  },
  MRU: {
    code: "MRU",
    decimalDigits: 0,
    name: "Mauritanian Ouguiya",
    namePlural: "Mauritanian ouguiyas",
    rounding: 0,
    symbol: "MRU",
    symbolNative: "أ.م.‏",
    zeroDecimal: !1
  },
  MUR: {
    code: "MUR",
    decimalDigits: 0,
    name: "Mauritian Rupee",
    namePlural: "Mauritian rupees",
    rounding: 0,
    symbol: "MURs",
    symbolNative: "MURs",
    zeroDecimal: !1
  },
  MVR: {
    code: "MVR",
    decimalDigits: 0,
    name: "Maldivian rufiyaa",
    namePlural: "Maldivian rufiyaa",
    rounding: 0,
    symbol: "MVR",
    symbolNative: "Rf",
    zeroDecimal: !1
  },
  MWK: {
    code: "MWK",
    decimalDigits: 2,
    name: "Malawian Kwacha",
    namePlural: "Malawian kwachas",
    rounding: 0,
    symbol: "MWK",
    symbolNative: "MK",
    zeroDecimal: !1
  },
  MXN: {
    code: "MXN",
    decimalDigits: 2,
    name: "Mexican Peso",
    namePlural: "Mexican pesos",
    rounding: 0,
    symbol: "MX$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  MYR: {
    code: "MYR",
    decimalDigits: 2,
    name: "Malaysian Ringgit",
    namePlural: "Malaysian ringgits",
    rounding: 0,
    symbol: "RM",
    symbolNative: "RM",
    zeroDecimal: !1
  },
  MZN: {
    code: "MZN",
    decimalDigits: 2,
    name: "Mozambican Metical",
    namePlural: "Mozambican meticals",
    rounding: 0,
    symbol: "MTn",
    symbolNative: "MTn",
    zeroDecimal: !1
  },
  NAD: {
    code: "NAD",
    decimalDigits: 2,
    name: "Namibian Dollar",
    namePlural: "Namibian dollars",
    rounding: 0,
    symbol: "N$",
    symbolNative: "N$",
    zeroDecimal: !1
  },
  NGN: {
    code: "NGN",
    decimalDigits: 2,
    name: "Nigerian Naira",
    namePlural: "Nigerian nairas",
    rounding: 0,
    symbol: "₦",
    symbolNative: "₦",
    zeroDecimal: !1
  },
  NIO: {
    code: "NIO",
    decimalDigits: 2,
    name: "Nicaraguan Córdoba",
    namePlural: "Nicaraguan córdobas",
    rounding: 0,
    symbol: "C$",
    symbolNative: "C$",
    zeroDecimal: !1
  },
  NOK: {
    code: "NOK",
    decimalDigits: 2,
    name: "Norwegian Krone",
    namePlural: "Norwegian kroner",
    rounding: 0,
    symbol: "Nkr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  NPR: {
    code: "NPR",
    decimalDigits: 2,
    name: "Nepalese Rupee",
    namePlural: "Nepalese rupees",
    rounding: 0,
    symbol: "NPRs",
    symbolNative: "नेरू",
    zeroDecimal: !1
  },
  NZD: {
    code: "NZD",
    decimalDigits: 2,
    name: "New Zealand Dollar",
    namePlural: "New Zealand dollars",
    rounding: 0,
    symbol: "NZ$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  OMR: {
    code: "OMR",
    decimalDigits: 3,
    name: "Omani Rial",
    namePlural: "Omani rials",
    rounding: 0,
    symbol: "OMR",
    symbolNative: "ر.ع.‏",
    zeroDecimal: !1
  },
  PAB: {
    code: "PAB",
    decimalDigits: 2,
    name: "Panamanian Balboa",
    namePlural: "Panamanian balboas",
    rounding: 0,
    symbol: "B/.",
    symbolNative: "B/.",
    zeroDecimal: !1
  },
  PEN: {
    code: "PEN",
    decimalDigits: 2,
    name: "Peruvian Nuevo Sol",
    namePlural: "Peruvian nuevos soles",
    rounding: 0,
    symbol: "S/.",
    symbolNative: "S/.",
    zeroDecimal: !1
  },
  PGK: {
    code: "PGK",
    decimalDigits: 2,
    name: "Papua New Guinean Kina",
    namePlural: "Papua New Guinean kina",
    rounding: 0,
    symbol: "PGK",
    symbolNative: "K",
    zeroDecimal: !1
  },
  PHP: {
    code: "PHP",
    decimalDigits: 2,
    name: "Philippine Peso",
    namePlural: "Philippine pesos",
    rounding: 0,
    symbol: "₱",
    symbolNative: "₱",
    zeroDecimal: !1
  },
  PKR: {
    code: "PKR",
    decimalDigits: 0,
    name: "Pakistani Rupee",
    namePlural: "Pakistani rupees",
    rounding: 0,
    symbol: "PKRs",
    symbolNative: "₨",
    zeroDecimal: !1
  },
  PLN: {
    code: "PLN",
    decimalDigits: 2,
    name: "Polish Zloty",
    namePlural: "Polish zlotys",
    rounding: 0,
    symbol: "zł",
    symbolNative: "zł",
    zeroDecimal: !1
  },
  PYG: {
    code: "PYG",
    decimalDigits: 0,
    name: "Paraguayan Guarani",
    namePlural: "Paraguayan guaranis",
    rounding: 0,
    symbol: "₲",
    symbolNative: "₲",
    zeroDecimal: !0
  },
  QAR: {
    code: "QAR",
    decimalDigits: 2,
    name: "Qatari Rial",
    namePlural: "Qatari rials",
    rounding: 0,
    symbol: "QR",
    symbolNative: "ر.ق.‏",
    zeroDecimal: !1
  },
  RON: {
    code: "RON",
    decimalDigits: 2,
    name: "Romanian Leu",
    namePlural: "Romanian lei",
    rounding: 0,
    symbol: "RON",
    symbolNative: "RON",
    zeroDecimal: !1
  },
  RSD: {
    code: "RSD",
    decimalDigits: 0,
    name: "Serbian Dinar",
    namePlural: "Serbian dinars",
    rounding: 0,
    symbol: "din.",
    symbolNative: "дин.",
    zeroDecimal: !1
  },
  RUB: {
    code: "RUB",
    decimalDigits: 2,
    name: "Russian Ruble",
    namePlural: "Russian rubles",
    rounding: 0,
    symbol: "RUB",
    symbolNative: "₽.",
    zeroDecimal: !1
  },
  RWF: {
    code: "RWF",
    decimalDigits: 0,
    name: "Rwandan Franc",
    namePlural: "Rwandan francs",
    rounding: 0,
    symbol: "RWF",
    symbolNative: "FR",
    zeroDecimal: !0
  },
  SAR: {
    code: "SAR",
    decimalDigits: 2,
    name: "Saudi Riyal",
    namePlural: "Saudi riyals",
    rounding: 0,
    symbol: "SR",
    symbolNative: "ر.س.‏",
    zeroDecimal: !1
  },
  SBD: {
    code: "SBD",
    decimalDigits: 2,
    name: "Solomon Islands Dollar",
    namePlural: "Solomon Islands dollars",
    rounding: 0,
    symbol: "SBD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SCR: {
    code: "SCR",
    decimalDigits: 2,
    name: "Seychellois Rupee",
    namePlural: "Seychellois rupees",
    rounding: 0,
    symbol: "SCR",
    symbolNative: "SR",
    zeroDecimal: !1
  },
  SDG: {
    code: "SDG",
    decimalDigits: 2,
    name: "Sudanese Pound",
    namePlural: "Sudanese pounds",
    rounding: 0,
    symbol: "SDG",
    symbolNative: "SDG",
    zeroDecimal: !1
  },
  SEK: {
    code: "SEK",
    decimalDigits: 2,
    name: "Swedish Krona",
    namePlural: "Swedish kronor",
    rounding: 0,
    symbol: "Skr",
    symbolNative: "kr",
    zeroDecimal: !1
  },
  SGD: {
    code: "SGD",
    decimalDigits: 2,
    name: "Singapore Dollar",
    namePlural: "Singapore dollars",
    rounding: 0,
    symbol: "S$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SHP: {
    code: "SHP",
    decimalDigits: 2,
    name: "St. Helena Pound",
    namePlural: "St. Helena pounds",
    rounding: 0,
    symbol: "SHP",
    symbolNative: "£",
    zeroDecimal: !1
  },
  SLL: {
    code: "SLL",
    decimalDigits: 0,
    name: "Sierra Leonean Leone",
    namePlural: "Sierra Leonean leones",
    rounding: 0,
    symbol: "SLL",
    symbolNative: "Le",
    zeroDecimal: !1
  },
  SOS: {
    code: "SOS",
    decimalDigits: 0,
    name: "Somali Shilling",
    namePlural: "Somali shillings",
    rounding: 0,
    symbol: "Ssh",
    symbolNative: "Ssh",
    zeroDecimal: !1
  },
  SRD: {
    code: "SRD",
    decimalDigits: 2,
    name: "Surinamese Dollar",
    namePlural: "Surinamese dollars",
    rounding: 0,
    symbol: "SRD",
    symbolNative: "$",
    zeroDecimal: !1
  },
  SSP: {
    code: "SSP",
    decimalDigits: 2,
    deprecated: !0,
    name: "South Sudanese Pound",
    namePlural: "South Sudanese pounds",
    rounding: 0,
    symbol: "SSP",
    symbolNative: "SSP",
    zeroDecimal: !1
  },
  STD: {
    code: "STD",
    decimalDigits: 2,
    name: "Dobra",
    namePlural: "Dobras",
    rounding: 0,
    symbol: "Db",
    symbolNative: "Db",
    zeroDecimal: !1
  },
  SYP: {
    code: "SYP",
    decimalDigits: 0,
    name: "Syrian Pound",
    namePlural: "Syrian pounds",
    rounding: 0,
    symbol: "SY£",
    symbolNative: "ل.س.‏",
    zeroDecimal: !1
  },
  SZL: {
    code: "SZL",
    decimalDigits: 2,
    name: "Swazi Lilangeni",
    namePlural: "Swazi emalangeni",
    rounding: 0,
    symbol: "SZL",
    symbolNative: "E",
    zeroDecimal: !1
  },
  THB: {
    code: "THB",
    decimalDigits: 2,
    name: "Thai Baht",
    namePlural: "Thai baht",
    rounding: 0,
    symbol: "฿",
    symbolNative: "฿",
    zeroDecimal: !1
  },
  TJS: {
    code: "TJS",
    decimalDigits: 2,
    name: "Tajikistani Somoni",
    namePlural: "Tajikistani somonis",
    rounding: 0,
    symbol: "TJS",
    symbolNative: "сом.",
    zeroDecimal: !1
  },
  TMT: {
    code: "TMT",
    decimalDigits: 2,
    name: "Turkmenistan Manat",
    namePlural: "Turkmenistan manats",
    rounding: 0,
    symbol: "TMT",
    symbolNative: "TMT",
    zeroDecimal: !1
  },
  TND: {
    code: "TND",
    decimalDigits: 3,
    name: "Tunisian Dinar",
    namePlural: "Tunisian dinars",
    rounding: 0,
    symbol: "DT",
    symbolNative: "د.ت.‏",
    zeroDecimal: !1
  },
  TOP: {
    code: "TOP",
    decimalDigits: 2,
    name: "Tongan Paʻanga",
    namePlural: "Tongan paʻanga",
    rounding: 0,
    symbol: "T$",
    symbolNative: "T$",
    zeroDecimal: !1
  },
  TRY: {
    code: "TRY",
    decimalDigits: 2,
    name: "Turkish Lira",
    namePlural: "Turkish Lira",
    rounding: 0,
    symbol: "TL",
    symbolNative: "TL",
    zeroDecimal: !1
  },
  TTD: {
    code: "TTD",
    decimalDigits: 2,
    name: "Trinidad and Tobago Dollar",
    namePlural: "Trinidad and Tobago dollars",
    rounding: 0,
    symbol: "TT$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  TWD: {
    code: "TWD",
    decimalDigits: 2,
    name: "New Taiwan Dollar",
    namePlural: "New Taiwan dollars",
    rounding: 0,
    symbol: "NT$",
    symbolNative: "NT$",
    zeroDecimal: !1
  },
  TZS: {
    code: "TZS",
    decimalDigits: 0,
    name: "Tanzanian Shilling",
    namePlural: "Tanzanian shillings",
    rounding: 0,
    symbol: "TSh",
    symbolNative: "TSh",
    zeroDecimal: !1
  },
  UAH: {
    code: "UAH",
    decimalDigits: 2,
    name: "Ukrainian Hryvnia",
    namePlural: "Ukrainian hryvnias",
    rounding: 0,
    symbol: "₴",
    symbolNative: "₴",
    zeroDecimal: !1
  },
  UGX: {
    code: "UGX",
    decimalDigits: 0,
    name: "Ugandan Shilling",
    namePlural: "Ugandan shillings",
    rounding: 0,
    symbol: "USh",
    symbolNative: "USh",
    zeroDecimal: !0
  },
  USD: {
    code: "USD",
    decimalDigits: 2,
    name: "US Dollar",
    namePlural: "US dollars",
    rounding: 0,
    symbol: "$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  UYU: {
    code: "UYU",
    decimalDigits: 2,
    name: "Uruguayan Peso",
    namePlural: "Uruguayan pesos",
    rounding: 0,
    symbol: "$U",
    symbolNative: "$",
    zeroDecimal: !1
  },
  UZS: {
    code: "UZS",
    decimalDigits: 0,
    name: "Uzbekistan Som",
    namePlural: "Uzbekistan som",
    rounding: 0,
    symbol: "UZS",
    symbolNative: "UZS",
    zeroDecimal: !1
  },
  VEF: {
    code: "VEF",
    decimalDigits: 2,
    deprecated: !0,
    name: "Venezuelan Bolívar",
    namePlural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbolNative: "Bs.F.",
    zeroDecimal: !1
  },
  VES: {
    code: "VES",
    decimalDigits: 2,
    name: "Venezuelan Bolívar",
    namePlural: "Venezuelan bolívars",
    rounding: 0,
    symbol: "Bs.F.",
    symbolNative: "Bs.F.",
    zeroDecimal: !1
  },
  VND: {
    code: "VND",
    decimalDigits: 0,
    name: "Vietnamese Dong",
    namePlural: "Vietnamese dong",
    rounding: 0,
    symbol: "₫",
    symbolNative: "₫",
    zeroDecimal: !0
  },
  VUV: {
    code: "VUV",
    decimalDigits: 0,
    name: "Vanuatu Vatu",
    namePlural: "Vanuatu vatus",
    rounding: 0,
    symbol: "VUV",
    symbolNative: "VT",
    zeroDecimal: !0
  },
  WST: {
    code: "WST",
    decimalDigits: 2,
    name: "Samoan Tala",
    namePlural: "Samoan tala",
    rounding: 0,
    symbol: "WST",
    symbolNative: "WS$",
    zeroDecimal: !1
  },
  XAF: {
    code: "XAF",
    decimalDigits: 0,
    name: "CFA Franc BEAC",
    namePlural: "CFA francs BEAC",
    rounding: 0,
    symbol: "FCFA",
    symbolNative: "FCFA",
    zeroDecimal: !0
  },
  XCD: {
    code: "XCD",
    decimalDigits: 2,
    name: "East Caribbean Dollar",
    namePlural: "East Caribbean dollars",
    rounding: 0,
    symbol: "EC$",
    symbolNative: "$",
    zeroDecimal: !1
  },
  XOF: {
    code: "XOF",
    decimalDigits: 0,
    name: "CFA Franc BCEAO",
    namePlural: "CFA francs BCEAO",
    rounding: 0,
    symbol: "CFA",
    symbolNative: "CFA",
    zeroDecimal: !0
  },
  XPF: {
    code: "XPF",
    decimalDigits: 0,
    name: "CFP Franc",
    namePlural: "CFP francs",
    rounding: 0,
    symbol: "CFPF",
    symbolNative: "FCFP",
    zeroDecimal: !0
  },
  YER: {
    code: "YER",
    decimalDigits: 0,
    name: "Yemeni Rial",
    namePlural: "Yemeni rials",
    rounding: 0,
    symbol: "YR",
    symbolNative: "ر.ي.‏",
    zeroDecimal: !1
  },
  ZAR: {
    code: "ZAR",
    decimalDigits: 2,
    name: "South African Rand",
    namePlural: "South African rand",
    rounding: 0,
    symbol: "R",
    symbolNative: "R",
    zeroDecimal: !1
  },
  ZMK: {
    code: "ZMK",
    decimalDigits: 0,
    name: "Zambian Kwacha",
    namePlural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZK",
    symbolNative: "ZK",
    zeroDecimal: !0
  },
  ZMW: {
    code: "ZMW",
    decimalDigits: 2,
    name: "Zambian Kwacha",
    namePlural: "Zambian kwachas",
    rounding: 0,
    symbol: "ZMW",
    symbolNative: "K",
    zeroDecimal: !1
  },
  ZWL: {
    code: "ZWL",
    decimalDigits: 0,
    name: "Zimbabwean Dollar",
    namePlural: "Zimbabwean Dollar",
    rounding: 0,
    symbol: "ZWL$",
    symbolNative: "ZWL$",
    zeroDecimal: !0
  }
}, ul = [
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BHD",
  "BGN",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BWP",
  "BZD",
  "CAD",
  "CDF",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CRC",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "GBP",
  "GEL",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRU",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SEK",
  "SGD",
  "SHP",
  "SLL",
  "SOS",
  "SRD",
  "STD",
  "SZL",
  "THB",
  "TJS",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "USD",
  "UYU",
  "UZS",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XCD",
  "XOF",
  "XPF",
  "YER",
  "ZAR",
  "ZMW"
  /* ZMW */
];
Object.values(en).filter((e) => !e.deprecated).map((e) => e.code);
const cl = ll(en, ul);
Object.values(en).filter(
  (e) => e.zeroDecimal && e.code in cl
).map((e) => e.code);
const dl = {
  AD: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "376",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AD.png",
    iso2: "AD",
    name: "Andorra",
    priority: 0,
    timezone: "Europe/Andorra"
  },
  AE: {
    areaCodes: null,
    currency: t.AED,
    dialCode: "971",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AE.png",
    iso2: "AE",
    name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    priority: 0,
    timezone: "Asia/Dubai"
  },
  AF: {
    areaCodes: null,
    currency: t.AFN,
    dialCode: "93",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AF.png",
    iso2: "AF",
    name: "Afghanistan (‫افغانستان‬‎)",
    priority: 0,
    timezone: "Asia/Kabul"
  },
  AG: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1268",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AG.png",
    iso2: "AG",
    name: "Antigua and Barbuda",
    priority: 0,
    timezone: "America/Antigua"
  },
  AI: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1264",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AI.png",
    iso2: "AI",
    name: "Anguilla",
    priority: 0,
    timezone: "America/Anguilla"
  },
  AL: {
    areaCodes: null,
    currency: t.ALL,
    dialCode: "355",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AL.png",
    iso2: "AL",
    name: "Albania (Shqipëri)",
    priority: 0,
    timezone: "Europe/Tirane"
  },
  AM: {
    areaCodes: null,
    currency: t.AMD,
    dialCode: "374",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AM.png",
    iso2: "AM",
    name: "Armenia (Հայաստան)",
    priority: 0,
    timezone: "Asia/Yerevan"
  },
  AO: {
    areaCodes: null,
    currency: t.AOA,
    dialCode: "244",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AO.png",
    iso2: "AO",
    name: "Angola",
    priority: 0,
    timezone: "Africa/Luanda"
  },
  AR: {
    areaCodes: null,
    currency: t.ARS,
    dialCode: "54",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AR.png",
    iso2: "AR",
    name: "Argentina",
    priority: 0,
    timezone: "America/Argentina/Cordoba"
  },
  AS: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1684",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AS.png",
    iso2: "AS",
    name: "American Samoa",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  AT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "43",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AT.png",
    iso2: "AT",
    name: "Austria (Österreich)",
    priority: 0,
    timezone: "Europe/Vienna"
  },
  AU: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AU.png",
    iso2: "AU",
    name: "Australia",
    priority: 0,
    timezone: "Australia/Darwin"
  },
  AW: {
    areaCodes: null,
    currency: t.AWG,
    dialCode: "297",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AW.png",
    iso2: "AW",
    name: "Aruba",
    priority: 0,
    timezone: "America/Aruba"
  },
  AX: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "358",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AX.png",
    iso2: "AX",
    name: "Åland Islands",
    priority: 1,
    timezone: "Europe/Helsinki"
  },
  AZ: {
    areaCodes: null,
    currency: t.AZN,
    dialCode: "994",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AZ.png",
    iso2: "AZ",
    name: "Azerbaijan (Azərbaycan)",
    priority: 0,
    timezone: "Asia/Baku"
  },
  BA: {
    areaCodes: null,
    currency: t.BAM,
    dialCode: "387",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BA.png",
    iso2: "BA",
    name: "Bosnia and Herzegovina (Босна и Херцеговина)",
    priority: 0,
    timezone: "Europe/Sarajevo"
  },
  BB: {
    areaCodes: null,
    currency: t.BBD,
    dialCode: "1246",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BB.png",
    iso2: "BB",
    name: "Barbados",
    priority: 0,
    timezone: "America/Barbados"
  },
  BD: {
    areaCodes: null,
    currency: t.BDT,
    dialCode: "880",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BD.png",
    iso2: "BD",
    name: "Bangladesh (বাংলাদেশ)",
    priority: 0,
    timezone: "Asia/Dhaka"
  },
  BE: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "32",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BE.png",
    iso2: "BE",
    name: "Belgium (België)",
    priority: 0,
    timezone: "Europe/Brussels"
  },
  BF: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "226",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BF.png",
    iso2: "BF",
    name: "Burkina Faso",
    priority: 0,
    timezone: "Africa/Ouagadougou"
  },
  BG: {
    areaCodes: null,
    currency: t.BGN,
    dialCode: "359",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BG.png",
    iso2: "BG",
    name: "Bulgaria (България)",
    priority: 0,
    timezone: "Europe/Sofia"
  },
  BH: {
    areaCodes: null,
    currency: t.BHD,
    dialCode: "973",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BH.png",
    iso2: "BH",
    name: "Bahrain (‫البحرين‬‎)",
    priority: 0,
    timezone: "Asia/Bahrain"
  },
  BI: {
    areaCodes: null,
    currency: t.BIF,
    dialCode: "257",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BI.png",
    iso2: "BI",
    name: "Burundi (Uburundi)",
    priority: 0,
    timezone: "Africa/Bujumbura"
  },
  BJ: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "229",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BJ.png",
    iso2: "BJ",
    name: "Benin (Bénin)",
    priority: 0,
    timezone: "Africa/Porto-Novo"
  },
  BL: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BL.png",
    iso2: "BL",
    name: "Saint Barthélemy",
    priority: 1,
    timezone: "America/St_Barthelemy"
  },
  BM: {
    areaCodes: null,
    currency: t.BMD,
    dialCode: "1441",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BM.png",
    iso2: "BM",
    name: "Bermuda",
    priority: 0,
    timezone: "Atlantic/Bermuda"
  },
  BN: {
    areaCodes: null,
    currency: t.BND,
    dialCode: "673",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BN.png",
    iso2: "BN",
    name: "Brunei",
    priority: 0,
    timezone: "Asia/Brunei"
  },
  BO: {
    areaCodes: null,
    currency: t.BOB,
    dialCode: "591",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BO.png",
    iso2: "BO",
    name: "Bolivia",
    priority: 0,
    timezone: "America/La_Paz"
  },
  BQ: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "599",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BQ.png",
    iso2: "BQ",
    name: "Caribbean Netherlands",
    priority: 1,
    timezone: "America/Kralendijk"
  },
  BR: {
    areaCodes: null,
    currency: t.BRL,
    dialCode: "55",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BR.png",
    iso2: "BR",
    name: "Brazil (Brasil)",
    priority: 0,
    timezone: "America/Cuiaba"
  },
  BS: {
    areaCodes: null,
    currency: t.BSD,
    dialCode: "1242",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BS.png",
    iso2: "BS",
    name: "Bahamas",
    priority: 0,
    timezone: "America/Nassau"
  },
  BT: {
    areaCodes: null,
    currency: t.BTN,
    dialCode: "975",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BT.png",
    iso2: "BT",
    name: "Bhutan (འབྲུག)",
    priority: 0,
    timezone: "Asia/Thimphu"
  },
  BW: {
    areaCodes: null,
    currency: t.BWP,
    dialCode: "267",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BW.png",
    iso2: "BW",
    name: "Botswana",
    priority: 0,
    timezone: "Africa/Gaborone"
  },
  BY: {
    areaCodes: null,
    currency: t.BYN,
    dialCode: "375",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BY.png",
    iso2: "BY",
    name: "Belarus (Беларусь)",
    priority: 0,
    timezone: "Europe/Minsk"
  },
  BZ: {
    areaCodes: null,
    currency: t.BZD,
    dialCode: "501",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BZ.png",
    iso2: "BZ",
    name: "Belize",
    priority: 0,
    timezone: "America/Belize"
  },
  CA: {
    areaCodes: [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ],
    currency: t.CAD,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CA.png",
    iso2: "CA",
    name: "Canada",
    priority: 1,
    timezone: "America/Rankin_Inlet"
  },
  CC: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CC.png",
    iso2: "CC",
    name: "Cocos (Keeling) Islands",
    priority: 1,
    timezone: "Indian/Cocos"
  },
  CD: {
    areaCodes: null,
    currency: t.CDF,
    dialCode: "243",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CD.png",
    iso2: "CD",
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    priority: 0,
    timezone: "Africa/Lubumbashi"
  },
  CF: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "236",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CF.png",
    iso2: "CF",
    name: "Central African Republic (République centrafricaine)",
    priority: 0,
    timezone: "Africa/Bangui"
  },
  CG: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "242",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CG.png",
    iso2: "CG",
    name: "Congo (Republic) (Congo-Brazzaville)",
    priority: 0,
    timezone: "Africa/Brazzaville"
  },
  CH: {
    areaCodes: null,
    currency: t.CHF,
    dialCode: "41",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CH.png",
    iso2: "CH",
    name: "Switzerland (Schweiz)",
    priority: 0,
    timezone: "Europe/Zurich"
  },
  CI: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "225",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CI.png",
    iso2: "CI",
    name: "Côte d’Ivoire",
    priority: 0,
    timezone: "Africa/Abidjan"
  },
  CK: {
    areaCodes: null,
    currency: t.NZD,
    dialCode: "682",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CK.png",
    iso2: "CK",
    name: "Cook Islands",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  CL: {
    areaCodes: null,
    currency: t.CLP,
    dialCode: "56",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CL.png",
    iso2: "CL",
    name: "Chile",
    priority: 0,
    timezone: "America/Santiago"
  },
  CM: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "237",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CM.png",
    iso2: "CM",
    name: "Cameroon (Cameroun)",
    priority: 0,
    timezone: "Africa/Douala"
  },
  CN: {
    areaCodes: null,
    currency: t.CNY,
    dialCode: "86",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CN.png",
    iso2: "CN",
    name: "China (中国)",
    priority: 0,
    timezone: "Asia/Shanghai"
  },
  CO: {
    areaCodes: null,
    currency: t.COP,
    dialCode: "57",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CO.png",
    iso2: "CO",
    name: "Colombia",
    priority: 0,
    timezone: "America/Bogota"
  },
  CR: {
    areaCodes: null,
    currency: t.CRC,
    dialCode: "506",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CR.png",
    iso2: "CR",
    name: "Costa Rica",
    priority: 0,
    timezone: "America/Costa_Rica"
  },
  CU: {
    areaCodes: null,
    currency: t.CUP,
    dialCode: "53",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CU.png",
    iso2: "CU",
    name: "Cuba",
    priority: 0,
    timezone: "America/Havana"
  },
  CV: {
    areaCodes: null,
    currency: t.CVE,
    dialCode: "238",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CV.png",
    iso2: "CV",
    name: "Cape Verde (Kabu Verdi)",
    priority: 0,
    timezone: "Atlantic/Cape_Verde"
  },
  CW: {
    areaCodes: null,
    currency: t.ANG,
    dialCode: "599",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CW.png",
    iso2: "CW",
    name: "Curaçao",
    priority: 0,
    timezone: "America/Curacao"
  },
  CX: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "61",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CX.png",
    iso2: "CX",
    name: "Christmas Island",
    priority: 2,
    timezone: "Indian/Christmas"
  },
  CY: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "357",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CY.png",
    iso2: "CY",
    name: "Cyprus (Κύπρος)",
    priority: 0,
    timezone: "Asia/Nicosia"
  },
  CZ: {
    areaCodes: null,
    currency: t.CZK,
    dialCode: "420",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CZ.png",
    iso2: "CZ",
    name: "Czech Republic (Česká republika)",
    priority: 0,
    timezone: "Europe/Prague"
  },
  DE: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "49",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DE.png",
    iso2: "DE",
    name: "Germany (Deutschland)",
    priority: 0,
    timezone: "Europe/Berlin"
  },
  DJ: {
    areaCodes: null,
    currency: t.DJF,
    dialCode: "253",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DJ.png",
    iso2: "DJ",
    name: "Djibouti",
    priority: 0,
    timezone: "Africa/Djibouti"
  },
  DK: {
    areaCodes: null,
    currency: t.DKK,
    dialCode: "45",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DK.png",
    iso2: "DK",
    name: "Denmark (Danmark)",
    priority: 0,
    timezone: "Europe/Copenhagen"
  },
  DM: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1767",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DM.png",
    iso2: "DM",
    name: "Dominica",
    priority: 0,
    timezone: "America/Dominica"
  },
  DO: {
    areaCodes: ["809", "829", "849"],
    currency: t.DOP,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DO.png",
    iso2: "DO",
    name: "Dominican Republic (República Dominicana)",
    priority: 2,
    timezone: "America/Santo_Domingo"
  },
  DZ: {
    areaCodes: null,
    currency: t.DZD,
    dialCode: "213",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DZ.png",
    iso2: "DZ",
    name: "Algeria (‫الجزائر‬‎)",
    priority: 0,
    timezone: "Africa/Algiers"
  },
  EC: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "593",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EC.png",
    iso2: "EC",
    name: "Ecuador",
    priority: 0,
    timezone: "America/Guayaquil"
  },
  EE: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "372",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EE.png",
    iso2: "EE",
    name: "Estonia (Eesti)",
    priority: 0,
    timezone: "Europe/Tallinn"
  },
  EG: {
    areaCodes: null,
    currency: t.EGP,
    dialCode: "20",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EG.png",
    iso2: "EG",
    name: "Egypt (‫مصر‬‎)",
    priority: 0,
    timezone: "Africa/Cairo"
  },
  EH: {
    areaCodes: null,
    currency: t.MAD,
    dialCode: "212",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EH.png",
    iso2: "EH",
    name: "Western Sahara (‫الصحراء الغربية‬‎)",
    priority: 1,
    timezone: "Africa/El_Aaiun"
  },
  ER: {
    areaCodes: null,
    currency: t.ERN,
    dialCode: "291",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ER.png",
    iso2: "ER",
    name: "Eritrea",
    priority: 0,
    timezone: "Africa/Asmara"
  },
  ES: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "34",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ES.png",
    iso2: "ES",
    name: "Spain (España)",
    priority: 0,
    timezone: "Europe/Madrid"
  },
  ET: {
    areaCodes: null,
    currency: t.ETB,
    dialCode: "251",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ET.png",
    iso2: "ET",
    name: "Ethiopia",
    priority: 0,
    timezone: "Africa/Addis_Ababa"
  },
  FI: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "358",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FI.png",
    iso2: "FI",
    name: "Finland (Suomi)",
    priority: 0,
    timezone: "Europe/Helsinki"
  },
  FJ: {
    areaCodes: null,
    currency: t.FJD,
    dialCode: "679",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FJ.png",
    iso2: "FJ",
    name: "Fiji",
    priority: 0,
    timezone: "Pacific/Fiji"
  },
  FK: {
    areaCodes: null,
    currency: t.FKP,
    dialCode: "500",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FK.png",
    iso2: "FK",
    name: "Falkland Islands (Islas Malvinas)",
    priority: 0,
    timezone: "Atlantic/Stanley"
  },
  FM: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "691",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FM.png",
    iso2: "FM",
    name: "Micronesia",
    priority: 0,
    timezone: "Etc/GMT-10"
  },
  FO: {
    areaCodes: null,
    currency: t.DKK,
    dialCode: "298",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FO.png",
    iso2: "FO",
    name: "Faroe Islands (Føroyar)",
    priority: 0,
    timezone: "Atlantic/Faroe"
  },
  FR: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "33",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FR.png",
    iso2: "FR",
    name: "France",
    priority: 0,
    timezone: "Europe/Paris"
  },
  GA: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "241",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GA.png",
    iso2: "GA",
    name: "Gabon",
    priority: 0,
    timezone: "Africa/Libreville"
  },
  GB: {
    areaCodes: null,
    currency: t.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GB.png",
    iso2: "GB",
    name: "United Kingdom",
    priority: 0,
    timezone: "Etc/GMT"
  },
  GD: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1473",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GD.png",
    iso2: "GD",
    name: "Grenada",
    priority: 0,
    timezone: "America/Grenada"
  },
  GE: {
    areaCodes: null,
    currency: t.GEL,
    dialCode: "995",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GE.png",
    iso2: "GE",
    name: "Georgia (საქართველო)",
    priority: 0,
    timezone: "Asia/Tbilisi"
  },
  GF: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "594",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GF.png",
    iso2: "GF",
    name: "French Guiana (Guyane française)",
    priority: 0,
    timezone: "America/Cayenne"
  },
  GG: {
    areaCodes: null,
    currency: t.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GG.png",
    iso2: "GG",
    name: "Guernsey",
    priority: 1,
    timezone: "Europe/Guernsey"
  },
  GH: {
    areaCodes: null,
    currency: t.GHS,
    dialCode: "233",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GH.png",
    iso2: "GH",
    name: "Ghana (Gaana)",
    priority: 0,
    timezone: "Africa/Accra"
  },
  GI: {
    areaCodes: null,
    currency: t.GIP,
    dialCode: "350",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GI.png",
    iso2: "GI",
    name: "Gibraltar",
    priority: 0,
    timezone: "Europe/Gibraltar"
  },
  GL: {
    areaCodes: null,
    currency: t.DKK,
    dialCode: "299",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GL.png",
    iso2: "GL",
    name: "Greenland (Kalaallit Nunaat)",
    priority: 0,
    timezone: "America/Godthab"
  },
  GM: {
    areaCodes: null,
    currency: t.GMD,
    dialCode: "220",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GM.png",
    iso2: "GM",
    name: "Gambia",
    priority: 0,
    timezone: "Africa/Banjul"
  },
  GN: {
    areaCodes: null,
    currency: t.GNF,
    dialCode: "224",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GN.png",
    iso2: "GN",
    name: "Guinea (Guinée)",
    priority: 0,
    timezone: "Africa/Conakry"
  },
  GP: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GP.png",
    iso2: "GP",
    name: "Guadeloupe",
    priority: 0,
    timezone: "America/Guadeloupe"
  },
  GQ: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "240",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GQ.png",
    iso2: "GQ",
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    priority: 0,
    timezone: "Africa/Malabo"
  },
  GR: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "30",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GR.png",
    iso2: "GR",
    name: "Greece (Ελλάδα)",
    priority: 0,
    timezone: "Europe/Athens"
  },
  GT: {
    areaCodes: null,
    currency: t.GTQ,
    dialCode: "502",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GT.png",
    iso2: "GT",
    name: "Guatemala",
    priority: 0,
    timezone: "America/Guatemala"
  },
  GU: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1671",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GU.png",
    iso2: "GU",
    name: "Guam",
    priority: 0,
    timezone: "Pacific/Guam"
  },
  GW: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "245",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GW.png",
    iso2: "GW",
    name: "Guinea-Bissau (Guiné Bissau)",
    priority: 0,
    timezone: "Africa/Bissau"
  },
  GY: {
    areaCodes: null,
    currency: t.GYD,
    dialCode: "592",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GY.png",
    iso2: "GY",
    name: "Guyana",
    priority: 0,
    timezone: "America/Guyana"
  },
  HK: {
    areaCodes: null,
    currency: t.HKD,
    dialCode: "852",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HK.png",
    iso2: "HK",
    name: "Hong Kong (香港)",
    priority: 0,
    timezone: "Asia/Hong_Kong"
  },
  HN: {
    areaCodes: null,
    currency: t.HNL,
    dialCode: "504",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HN.png",
    iso2: "HN",
    name: "Honduras",
    priority: 0,
    timezone: "America/Tegucigalpa"
  },
  HR: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "385",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HR.png",
    iso2: "HR",
    name: "Croatia (Hrvatska)",
    priority: 0,
    timezone: "Europe/Zagreb"
  },
  HT: {
    areaCodes: null,
    currency: t.HTG,
    dialCode: "509",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HT.png",
    iso2: "HT",
    name: "Haiti",
    priority: 0,
    timezone: "America/Port-au-Prince"
  },
  HU: {
    areaCodes: null,
    currency: t.HUF,
    dialCode: "36",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HU.png",
    iso2: "HU",
    name: "Hungary (Magyarország)",
    priority: 0,
    timezone: "Europe/Budapest"
  },
  ID: {
    areaCodes: null,
    currency: t.IDR,
    dialCode: "62",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ID.png",
    iso2: "ID",
    name: "Indonesia",
    priority: 0,
    timezone: "Asia/Makassar"
  },
  IE: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "353",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IE.png",
    iso2: "IE",
    name: "Ireland",
    priority: 0,
    timezone: "Europe/Dublin"
  },
  IL: {
    areaCodes: null,
    currency: t.ILS,
    dialCode: "972",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IL.png",
    iso2: "IL",
    name: "Israel (‫ישראל‬‎)",
    priority: 0,
    timezone: "Asia/Jerusalem"
  },
  IM: {
    areaCodes: null,
    currency: t.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IM.png",
    iso2: "IM",
    name: "Isle of Man",
    priority: 2,
    timezone: "Europe/Isle_of_Man"
  },
  IN: {
    areaCodes: null,
    currency: t.INR,
    dialCode: "91",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IN.png",
    iso2: "IN",
    name: "India (भारत)",
    priority: 0,
    timezone: "Asia/Kolkata"
  },
  IO: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "246",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IO.png",
    iso2: "IO",
    name: "British Indian Ocean Territory",
    priority: 0,
    timezone: "Etc/GMT-5"
  },
  IQ: {
    areaCodes: null,
    currency: t.IQD,
    dialCode: "964",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IQ.png",
    iso2: "IQ",
    name: "Iraq (‫العراق‬‎)",
    priority: 0,
    timezone: "Asia/Baghdad"
  },
  IR: {
    areaCodes: null,
    currency: t.IRR,
    dialCode: "98",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IR.png",
    iso2: "IR",
    name: "Iran (‫ایران‬‎)",
    priority: 0,
    timezone: "Asia/Tehran"
  },
  IS: {
    areaCodes: null,
    currency: t.ISK,
    dialCode: "354",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IS.png",
    iso2: "IS",
    name: "Iceland (Ísland)",
    priority: 0,
    timezone: "Atlantic/Reykjavik"
  },
  IT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "39",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IT.png",
    iso2: "IT",
    name: "Italy (Italia)",
    priority: 0,
    timezone: "Europe/Rome"
  },
  JE: {
    areaCodes: null,
    currency: t.GBP,
    dialCode: "44",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JE.png",
    iso2: "JE",
    name: "Jersey",
    priority: 3,
    timezone: "Europe/Jersey"
  },
  JM: {
    areaCodes: null,
    currency: t.JMD,
    dialCode: "1876",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JM.png",
    iso2: "JM",
    name: "Jamaica",
    priority: 0,
    timezone: "America/Jamaica"
  },
  JO: {
    areaCodes: null,
    currency: t.JOD,
    dialCode: "962",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JO.png",
    iso2: "JO",
    name: "Jordan (‫الأردن‬‎)",
    priority: 0,
    timezone: "Asia/Amman"
  },
  JP: {
    areaCodes: null,
    currency: t.JPY,
    dialCode: "81",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JP.png",
    iso2: "JP",
    name: "Japan (日本)",
    priority: 0,
    timezone: "Asia/Tokyo"
  },
  KE: {
    areaCodes: null,
    currency: t.KES,
    dialCode: "254",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KE.png",
    iso2: "KE",
    name: "Kenya",
    priority: 0,
    timezone: "Africa/Nairobi"
  },
  KG: {
    areaCodes: null,
    currency: t.KGS,
    dialCode: "996",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KG.png",
    iso2: "KG",
    name: "Kyrgyzstan (Кыргызстан)",
    priority: 0,
    timezone: "Asia/Bishkek"
  },
  KH: {
    areaCodes: null,
    currency: t.KHR,
    dialCode: "855",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KH.png",
    iso2: "KH",
    name: "Cambodia (កម្ពុជា)",
    priority: 0,
    timezone: "Asia/Phnom_Penh"
  },
  KI: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "686",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KI.png",
    iso2: "KI",
    name: "Kiribati",
    priority: 0,
    timezone: "Etc/GMT+11"
  },
  KM: {
    areaCodes: null,
    currency: t.KMF,
    dialCode: "269",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KM.png",
    iso2: "KM",
    name: "Comoros (‫جزر القمر‬‎)",
    priority: 0,
    timezone: "Indian/Comoro"
  },
  KN: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1869",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KN.png",
    iso2: "KN",
    name: "Saint Kitts and Nevis",
    priority: 0,
    timezone: "America/St_Kitts"
  },
  KP: {
    areaCodes: null,
    currency: t.KPW,
    dialCode: "850",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KP.png",
    iso2: "KP",
    name: "North Korea (조선 민주주의 인민 공화국)",
    priority: 0,
    timezone: "Asia/Pyongyang"
  },
  KR: {
    areaCodes: null,
    currency: t.KRW,
    dialCode: "82",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KR.png",
    iso2: "KR",
    name: "South Korea (대한민국)",
    priority: 0,
    timezone: "Asia/Seoul"
  },
  KW: {
    areaCodes: null,
    currency: t.KWD,
    dialCode: "965",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KW.png",
    iso2: "KW",
    name: "Kuwait (‫الكويت‬‎)",
    priority: 0,
    timezone: "Asia/Kuwait"
  },
  KY: {
    areaCodes: null,
    currency: t.KYD,
    dialCode: "1345",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KY.png",
    iso2: "KY",
    name: "Cayman Islands",
    priority: 0,
    timezone: "Etc/GMT+5"
  },
  KZ: {
    areaCodes: null,
    currency: t.KZT,
    dialCode: "7",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KZ.png",
    iso2: "KZ",
    name: "Kazakhstan (Казахстан)",
    priority: 1,
    timezone: "Asia/Almaty"
  },
  LA: {
    areaCodes: null,
    currency: t.LAK,
    dialCode: "856",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LA.png",
    iso2: "LA",
    name: "Laos (ລາວ)",
    priority: 0,
    timezone: "Asia/Vientiane"
  },
  LB: {
    areaCodes: null,
    currency: t.LBP,
    dialCode: "961",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LB.png",
    iso2: "LB",
    name: "Lebanon (‫لبنان‬‎)",
    priority: 0,
    timezone: "Asia/Beirut"
  },
  LC: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1758",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LC.png",
    iso2: "LC",
    name: "Saint Lucia",
    priority: 0,
    timezone: "America/St_Lucia"
  },
  LI: {
    areaCodes: null,
    currency: t.CHF,
    dialCode: "423",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LI.png",
    iso2: "LI",
    name: "Liechtenstein",
    priority: 0,
    timezone: "Europe/Vaduz"
  },
  LK: {
    areaCodes: null,
    currency: t.LKR,
    dialCode: "94",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LK.png",
    iso2: "LK",
    name: "Sri Lanka (ශ්‍රී ලංකාව)",
    priority: 0,
    timezone: "Asia/Colombo"
  },
  LR: {
    areaCodes: null,
    currency: t.LRD,
    dialCode: "231",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LR.png",
    iso2: "LR",
    name: "Liberia",
    priority: 0,
    timezone: "Africa/Monrovia"
  },
  LS: {
    areaCodes: null,
    currency: t.LSL,
    dialCode: "266",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LS.png",
    iso2: "LS",
    name: "Lesotho",
    priority: 0,
    timezone: "Africa/Maseru"
  },
  LT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "370",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LT.png",
    iso2: "LT",
    name: "Lithuania (Lietuva)",
    priority: 0,
    timezone: "Europe/Vilnius"
  },
  LU: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "352",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LU.png",
    iso2: "LU",
    name: "Luxembourg",
    priority: 0,
    timezone: "Europe/Luxembourg"
  },
  LV: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "371",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LV.png",
    iso2: "LV",
    name: "Latvia (Latvija)",
    priority: 0,
    timezone: "Europe/Riga"
  },
  LY: {
    areaCodes: null,
    currency: t.LYD,
    dialCode: "218",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LY.png",
    iso2: "LY",
    name: "Libya (‫ليبيا‬‎)",
    priority: 0,
    timezone: "Africa/Tripoli"
  },
  MA: {
    areaCodes: null,
    currency: t.MAD,
    dialCode: "212",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MA.png",
    iso2: "MA",
    name: "Morocco (‫المغرب‬‎)",
    priority: 0,
    timezone: "Africa/Casablanca"
  },
  MC: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "377",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MC.png",
    iso2: "MC",
    name: "Monaco",
    priority: 0,
    timezone: "Europe/Paris"
  },
  MD: {
    areaCodes: null,
    currency: t.MDL,
    dialCode: "373",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MD.png",
    iso2: "MD",
    name: "Moldova (Republica Moldova)",
    priority: 0,
    timezone: "Europe/Chisinau"
  },
  ME: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "382",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ME.png",
    iso2: "ME",
    name: "Montenegro (Crna Gora)",
    priority: 0,
    timezone: "Europe/Podgorica"
  },
  MF: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "590",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MF.png",
    iso2: "MF",
    name: "Saint Martin (Saint-Martin (partie française))",
    priority: 2,
    timezone: "America/Marigot"
  },
  MG: {
    areaCodes: null,
    currency: t.MGA,
    dialCode: "261",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MG.png",
    iso2: "MG",
    name: "Madagascar (Madagasikara)",
    priority: 0,
    timezone: "Indian/Antananarivo"
  },
  MH: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "692",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MH.png",
    iso2: "MH",
    name: "Marshall Islands",
    priority: 0,
    timezone: "Etc/GMT-11"
  },
  MK: {
    areaCodes: null,
    currency: t.MKD,
    dialCode: "389",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MK.png",
    iso2: "MK",
    name: "Macedonia (FYROM) (Македонија)",
    priority: 0,
    timezone: "Europe/Skopje"
  },
  ML: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "223",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ML.png",
    iso2: "ML",
    name: "Mali",
    priority: 0,
    timezone: "Africa/Bamako"
  },
  MM: {
    areaCodes: null,
    currency: t.MMK,
    dialCode: "95",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MM.png",
    iso2: "MM",
    name: "Myanmar (Burma) (မြန်မာ)",
    priority: 0,
    timezone: "Asia/Yangon"
  },
  MN: {
    areaCodes: null,
    currency: t.MNT,
    dialCode: "976",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MN.png",
    iso2: "MN",
    name: "Mongolia (Монгол)",
    priority: 0,
    timezone: "Asia/Ulaanbaatar"
  },
  MO: {
    areaCodes: null,
    currency: t.MOP,
    dialCode: "853",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MO.png",
    iso2: "MO",
    name: "Macau (澳門)",
    priority: 0,
    timezone: "Asia/Macau"
  },
  MP: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1670",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MP.png",
    iso2: "MP",
    name: "Northern Mariana Islands",
    priority: 0,
    timezone: "Pacific/Saipan"
  },
  MQ: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "596",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MQ.png",
    iso2: "MQ",
    name: "Martinique",
    priority: 0,
    timezone: "America/Martinique"
  },
  MR: {
    areaCodes: null,
    currency: t.MRU,
    dialCode: "222",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MR.png",
    iso2: "MR",
    name: "Mauritania (‫موريتانيا‬‎)",
    priority: 0,
    timezone: "Africa/Nouakchott"
  },
  MS: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1664",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MS.png",
    iso2: "MS",
    name: "Montserrat",
    priority: 0,
    timezone: "America/Montserrat"
  },
  MT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "356",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MT.png",
    iso2: "MT",
    name: "Malta",
    priority: 0,
    timezone: "Europe/Malta"
  },
  MU: {
    areaCodes: null,
    currency: t.MUR,
    dialCode: "230",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MU.png",
    iso2: "MU",
    name: "Mauritius (Moris)",
    priority: 0,
    timezone: "Indian/Mauritius"
  },
  MV: {
    areaCodes: null,
    currency: t.MVR,
    dialCode: "960",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MV.png",
    iso2: "MV",
    name: "Maldives",
    priority: 0,
    timezone: "Indian/Maldives"
  },
  MW: {
    areaCodes: null,
    currency: t.MWK,
    dialCode: "265",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MW.png",
    iso2: "MW",
    name: "Malawi",
    priority: 0,
    timezone: "Africa/Blantyre"
  },
  MX: {
    areaCodes: null,
    currency: t.MXN,
    dialCode: "52",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MX.png",
    iso2: "MX",
    name: "Mexico (México)",
    priority: 0,
    timezone: "America/Mexico_City"
  },
  MY: {
    areaCodes: null,
    currency: t.MYR,
    dialCode: "60",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MY.png",
    iso2: "MY",
    name: "Malaysia",
    priority: 0,
    timezone: "Asia/Kuching"
  },
  MZ: {
    areaCodes: null,
    currency: t.MZN,
    dialCode: "258",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MZ.png",
    iso2: "MZ",
    name: "Mozambique (Moçambique)",
    priority: 0,
    timezone: "Africa/Maputo"
  },
  NA: {
    areaCodes: null,
    currency: t.NAD,
    dialCode: "264",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NA.png",
    iso2: "NA",
    name: "Namibia (Namibië)",
    priority: 0,
    timezone: "Africa/Windhoek"
  },
  NC: {
    areaCodes: null,
    currency: t.XPF,
    dialCode: "687",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NC.png",
    iso2: "NC",
    name: "New Caledonia (Nouvelle-Calédonie)",
    priority: 0,
    timezone: "Pacific/Noumea"
  },
  NE: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "227",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NE.png",
    iso2: "NE",
    name: "Niger (Nijar)",
    priority: 0,
    timezone: "Africa/Niamey"
  },
  NF: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "672",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NF.png",
    iso2: "NF",
    name: "Norfolk Island",
    priority: 0,
    timezone: "Pacific/Norfolk"
  },
  NG: {
    areaCodes: null,
    currency: t.NGN,
    dialCode: "234",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NG.png",
    iso2: "NG",
    name: "Nigeria",
    priority: 0,
    timezone: "Africa/Lagos"
  },
  NI: {
    areaCodes: null,
    currency: t.NIO,
    dialCode: "505",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NI.png",
    iso2: "NI",
    name: "Nicaragua",
    priority: 0,
    timezone: "America/Managua"
  },
  NL: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "31",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NL.png",
    iso2: "NL",
    name: "Netherlands (Nederland)",
    priority: 0,
    timezone: "Europe/Amsterdam"
  },
  NO: {
    areaCodes: null,
    currency: t.NOK,
    dialCode: "47",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NO.png",
    iso2: "NO",
    name: "Norway (Norge)",
    priority: 0,
    timezone: "Europe/Oslo"
  },
  NP: {
    areaCodes: null,
    currency: t.NPR,
    dialCode: "977",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NP.png",
    iso2: "NP",
    name: "Nepal (नेपाल)",
    priority: 0,
    timezone: "Asia/Kathmandu"
  },
  NR: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "674",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NR.png",
    iso2: "NR",
    name: "Nauru",
    priority: 0,
    timezone: "Pacific/Nauru"
  },
  NU: {
    areaCodes: null,
    currency: t.NZD,
    dialCode: "683",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NU.png",
    iso2: "NU",
    name: "Niue",
    priority: 0,
    timezone: "Pacific/Niue"
  },
  NZ: {
    areaCodes: null,
    currency: t.NZD,
    dialCode: "64",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NZ.png",
    iso2: "NZ",
    name: "New Zealand",
    priority: 0,
    timezone: "Pacific/Auckland"
  },
  OM: {
    areaCodes: null,
    currency: t.OMR,
    dialCode: "968",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/OM.png",
    iso2: "OM",
    name: "Oman (‫عُمان‬‎)",
    priority: 0,
    timezone: "Asia/Muscat"
  },
  PA: {
    areaCodes: null,
    currency: t.PAB,
    dialCode: "507",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PA.png",
    iso2: "PA",
    name: "Panama (Panamá)",
    priority: 0,
    timezone: "America/Panama"
  },
  PE: {
    areaCodes: null,
    currency: t.PEN,
    dialCode: "51",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PE.png",
    iso2: "PE",
    name: "Peru (Perú)",
    priority: 0,
    timezone: "America/Lima"
  },
  PF: {
    areaCodes: null,
    currency: t.XPF,
    dialCode: "689",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PF.png",
    iso2: "PF",
    name: "French Polynesia (Polynésie française)",
    priority: 0,
    timezone: "Etc/GMT+9"
  },
  PG: {
    areaCodes: null,
    currency: t.PGK,
    dialCode: "675",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PG.png",
    iso2: "PG",
    name: "Papua New Guinea",
    priority: 0,
    timezone: "Pacific/Port_Moresby"
  },
  PH: {
    areaCodes: null,
    currency: t.PHP,
    dialCode: "63",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PH.png",
    iso2: "PH",
    name: "Philippines",
    priority: 0,
    timezone: "Asia/Manila"
  },
  PK: {
    areaCodes: null,
    currency: t.PKR,
    dialCode: "92",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PK.png",
    iso2: "PK",
    name: "Pakistan (‫پاکستان‬‎)",
    priority: 0,
    timezone: "Asia/Karachi"
  },
  PL: {
    areaCodes: null,
    currency: t.PLN,
    dialCode: "48",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PL.png",
    iso2: "PL",
    name: "Poland (Polska)",
    priority: 0,
    timezone: "Europe/Warsaw"
  },
  PM: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "508",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PM.png",
    iso2: "PM",
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    priority: 0,
    timezone: "America/Miquelon"
  },
  PR: {
    areaCodes: ["787", "939"],
    currency: t.USD,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PR.png",
    iso2: "PR",
    name: "Puerto Rico",
    priority: 3,
    timezone: "America/Puerto_Rico"
  },
  PS: {
    areaCodes: null,
    currency: t.ILS,
    dialCode: "970",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PS.png",
    iso2: "PS",
    name: "Palestine (‫فلسطين‬‎)",
    priority: 0,
    timezone: "Asia/Jerusalem"
  },
  PT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "351",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PT.png",
    iso2: "PT",
    name: "Portugal",
    priority: 0,
    timezone: "Europe/Lisbon"
  },
  PW: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "680",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PW.png",
    iso2: "PW",
    name: "Palau",
    priority: 0,
    timezone: "Etc/GMT-9"
  },
  PY: {
    areaCodes: null,
    currency: t.PYG,
    dialCode: "595",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PY.png",
    iso2: "PY",
    name: "Paraguay",
    priority: 0,
    timezone: "America/Asuncion"
  },
  QA: {
    areaCodes: null,
    currency: t.QAR,
    dialCode: "974",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/QA.png",
    iso2: "QA",
    name: "Qatar (‫قطر‬‎)",
    priority: 0,
    timezone: "Asia/Qatar"
  },
  RE: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "262",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RE.png",
    iso2: "RE",
    name: "Réunion (La Réunion)",
    priority: 0,
    timezone: "Indian/Reunion"
  },
  RO: {
    areaCodes: null,
    currency: t.RON,
    dialCode: "40",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RO.png",
    iso2: "RO",
    name: "Romania (România)",
    priority: 0,
    timezone: "Europe/Bucharest"
  },
  RS: {
    areaCodes: null,
    currency: t.RSD,
    dialCode: "381",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RS.png",
    iso2: "RS",
    name: "Serbia (Србија)",
    priority: 0,
    timezone: "Europe/Belgrade"
  },
  RU: {
    areaCodes: null,
    currency: t.RUB,
    dialCode: "7",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RU.png",
    iso2: "RU",
    name: "Russia (Россия)",
    priority: 0,
    timezone: "Asia/Krasnoyarsk"
  },
  RW: {
    areaCodes: null,
    currency: t.RWF,
    dialCode: "250",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RW.png",
    iso2: "RW",
    name: "Rwanda",
    priority: 0,
    timezone: "Africa/Kigali"
  },
  SA: {
    areaCodes: null,
    currency: t.SAR,
    dialCode: "966",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SA.png",
    iso2: "SA",
    name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    priority: 0,
    timezone: "Asia/Riyadh"
  },
  SB: {
    areaCodes: null,
    currency: t.SBD,
    dialCode: "677",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SB.png",
    iso2: "SB",
    name: "Solomon Islands",
    priority: 0,
    timezone: "Pacific/Guadalcanal"
  },
  SC: {
    areaCodes: null,
    currency: t.SCR,
    dialCode: "248",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SC.png",
    iso2: "SC",
    name: "Seychelles",
    priority: 0,
    timezone: "Indian/Mahe"
  },
  SD: {
    areaCodes: null,
    currency: t.SDG,
    dialCode: "249",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SD.png",
    iso2: "SD",
    name: "Sudan (‫السودان‬‎)",
    priority: 0,
    timezone: "Africa/Khartoum"
  },
  SE: {
    areaCodes: null,
    currency: t.SEK,
    dialCode: "46",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SE.png",
    iso2: "SE",
    name: "Sweden (Sverige)",
    priority: 0,
    timezone: "Europe/Stockholm"
  },
  SG: {
    areaCodes: null,
    currency: t.SGD,
    dialCode: "65",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SG.png",
    iso2: "SG",
    name: "Singapore",
    priority: 0,
    timezone: "Asia/Singapore"
  },
  SH: {
    areaCodes: null,
    currency: t.SHP,
    dialCode: "290",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SH.png",
    iso2: "SH",
    name: "Saint Helena",
    priority: 0,
    timezone: "Atlantic/St_Helena"
  },
  SI: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "386",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SI.png",
    iso2: "SI",
    name: "Slovenia (Slovenija)",
    priority: 0,
    timezone: "Europe/Ljubljana"
  },
  SJ: {
    areaCodes: null,
    currency: t.NOK,
    dialCode: "47",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SJ.png",
    iso2: "SJ",
    name: "Svalbard and Jan Mayen",
    priority: 1,
    timezone: "Arctic/Longyearbyen"
  },
  SK: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "421",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SK.png",
    iso2: "SK",
    name: "Slovakia (Slovensko)",
    priority: 0,
    timezone: "Europe/Bratislava"
  },
  SL: {
    areaCodes: null,
    currency: t.SLL,
    dialCode: "232",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SL.png",
    iso2: "SL",
    name: "Sierra Leone",
    priority: 0,
    timezone: "Africa/Freetown"
  },
  SM: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "378",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SM.png",
    iso2: "SM",
    name: "San Marino",
    priority: 0,
    timezone: "Europe/San_Marino"
  },
  SN: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "221",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SN.png",
    iso2: "SN",
    name: "Senegal (Sénégal)",
    priority: 0,
    timezone: "Africa/Dakar"
  },
  SO: {
    areaCodes: null,
    currency: t.SOS,
    dialCode: "252",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SO.png",
    iso2: "SO",
    name: "Somalia (Soomaaliya)",
    priority: 0,
    timezone: "Africa/Mogadishu"
  },
  SR: {
    areaCodes: null,
    currency: t.SRD,
    dialCode: "597",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SR.png",
    iso2: "SR",
    name: "Suriname",
    priority: 0,
    timezone: "America/Paramaribo"
  },
  SS: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "211",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SS.png",
    iso2: "SS",
    name: "South Sudan (‫جنوب السودان‬‎)",
    priority: 0,
    timezone: "Africa/Juba"
  },
  ST: {
    areaCodes: null,
    currency: t.STD,
    dialCode: "239",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ST.png",
    iso2: "ST",
    name: "São Tomé and Príncipe (São Tomé e Príncipe)",
    priority: 0,
    timezone: "Africa/Sao_Tome"
  },
  SV: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "503",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SV.png",
    iso2: "SV",
    name: "El Salvador",
    priority: 0,
    timezone: "America/El_Salvador"
  },
  SX: {
    areaCodes: null,
    currency: t.ANG,
    dialCode: "1721",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SX.png",
    iso2: "SX",
    name: "Sint Maarten",
    priority: 0,
    timezone: "America/Lower_Princes"
  },
  SY: {
    areaCodes: null,
    currency: t.SYP,
    dialCode: "963",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SY.png",
    iso2: "SY",
    name: "Syria (‫سوريا‬‎)",
    priority: 0,
    timezone: "Asia/Damascus"
  },
  SZ: {
    areaCodes: null,
    currency: t.SZL,
    dialCode: "268",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SZ.png",
    iso2: "SZ",
    name: "Swaziland",
    priority: 0,
    timezone: "Africa/Mbabane"
  },
  TC: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1649",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TC.png",
    iso2: "TC",
    name: "Turks and Caicos Islands",
    priority: 0,
    timezone: "America/Grand_Turk"
  },
  TD: {
    areaCodes: null,
    currency: t.XAF,
    dialCode: "235",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TD.png",
    iso2: "TD",
    name: "Chad (Tchad)",
    priority: 0,
    timezone: "Africa/Ndjamena"
  },
  TG: {
    areaCodes: null,
    currency: t.XOF,
    dialCode: "228",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TG.png",
    iso2: "TG",
    name: "Togo",
    priority: 0,
    timezone: "Africa/Lome"
  },
  TH: {
    areaCodes: null,
    currency: t.THB,
    dialCode: "66",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TH.png",
    iso2: "TH",
    name: "Thailand (ไทย)",
    priority: 0,
    timezone: "Asia/Bangkok"
  },
  TJ: {
    areaCodes: null,
    currency: t.TJS,
    dialCode: "992",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TJ.png",
    iso2: "TJ",
    name: "Tajikistan",
    priority: 0,
    timezone: "Asia/Dushanbe"
  },
  TK: {
    areaCodes: null,
    currency: t.NZD,
    dialCode: "690",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TK.png",
    iso2: "TK",
    name: "Tokelau",
    priority: 0,
    timezone: "Pacific/Fakaofo"
  },
  TL: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "670",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TL.png",
    iso2: "TL",
    name: "Timor-Leste",
    priority: 0,
    timezone: "Asia/Dili"
  },
  TM: {
    areaCodes: null,
    currency: t.TMT,
    dialCode: "993",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TM.png",
    iso2: "TM",
    name: "Turkmenistan",
    priority: 0,
    timezone: "Asia/Ashgabat"
  },
  TN: {
    areaCodes: null,
    currency: t.TND,
    dialCode: "216",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TN.png",
    iso2: "TN",
    name: "Tunisia (‫تونس‬‎)",
    priority: 0,
    timezone: "Africa/Tunis"
  },
  TO: {
    areaCodes: null,
    currency: t.TOP,
    dialCode: "676",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TO.png",
    iso2: "TO",
    name: "Tonga",
    priority: 0,
    timezone: "Pacific/Tongatapu"
  },
  TR: {
    areaCodes: null,
    currency: t.TRY,
    dialCode: "90",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TR.png",
    iso2: "TR",
    name: "Turkey (Türkiye)",
    priority: 0,
    timezone: "Europe/Istanbul"
  },
  TT: {
    areaCodes: null,
    currency: t.TTD,
    dialCode: "1868",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TT.png",
    iso2: "TT",
    name: "Trinidad and Tobago",
    priority: 0,
    timezone: "America/Port_of_Spain"
  },
  TV: {
    areaCodes: null,
    currency: t.AUD,
    dialCode: "688",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TV.png",
    iso2: "TV",
    name: "Tuvalu",
    priority: 0,
    timezone: "Etc/GMT-12"
  },
  TW: {
    areaCodes: null,
    currency: t.TWD,
    dialCode: "886",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TW.png",
    iso2: "TW",
    name: "Taiwan (台灣)",
    priority: 0,
    timezone: "Asia/Taipei"
  },
  TZ: {
    areaCodes: null,
    currency: t.TZS,
    dialCode: "255",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TZ.png",
    iso2: "TZ",
    name: "Tanzania",
    priority: 0,
    timezone: "Africa/Dar_es_Salaam"
  },
  UA: {
    areaCodes: null,
    currency: t.UAH,
    dialCode: "380",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UA.png",
    iso2: "UA",
    name: "Ukraine (Україна)",
    priority: 0,
    timezone: "Europe/Kiev"
  },
  UG: {
    areaCodes: null,
    currency: t.UGX,
    dialCode: "256",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UG.png",
    iso2: "UG",
    name: "Uganda",
    priority: 0,
    timezone: "Africa/Kampala"
  },
  US: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/US.png",
    iso2: "US",
    name: "United States",
    priority: 0,
    timezone: "America/Chicago"
  },
  UY: {
    areaCodes: null,
    currency: t.UYU,
    dialCode: "598",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UY.png",
    iso2: "UY",
    name: "Uruguay",
    priority: 0,
    timezone: "America/Montevideo"
  },
  UZ: {
    areaCodes: null,
    currency: t.UZS,
    dialCode: "998",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UZ.png",
    iso2: "UZ",
    name: "Uzbekistan (Oʻzbekiston)",
    priority: 0,
    timezone: "Asia/Samarkand"
  },
  VA: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "39",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VA.png",
    iso2: "VA",
    name: "Vatican City (Città del Vaticano)",
    priority: 1,
    timezone: "Europe/Rome"
  },
  VC: {
    areaCodes: null,
    currency: t.XCD,
    dialCode: "1784",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VC.png",
    iso2: "VC",
    name: "Saint Vincent and the Grenadines",
    priority: 0,
    timezone: "America/St_Vincent"
  },
  VE: {
    areaCodes: null,
    currency: t.VES,
    dialCode: "58",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VE.png",
    iso2: "VE",
    name: "Venezuela",
    priority: 0,
    timezone: "America/Caracas"
  },
  VG: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1284",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VG.png",
    iso2: "VG",
    name: "British Virgin Islands",
    priority: 0,
    timezone: "America/Tortola"
  },
  VI: {
    areaCodes: null,
    currency: t.USD,
    dialCode: "1340",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VI.png",
    iso2: "VI",
    name: "U.S. Virgin Islands",
    priority: 0,
    timezone: "America/St_Thomas"
  },
  VN: {
    areaCodes: null,
    currency: t.VND,
    dialCode: "84",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VN.png",
    iso2: "VN",
    name: "Vietnam (Việt Nam)",
    priority: 0,
    timezone: "Asia/Ho_Chi_Minh"
  },
  VU: {
    areaCodes: null,
    currency: t.VUV,
    dialCode: "678",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VU.png",
    iso2: "VU",
    name: "Vanuatu",
    priority: 0,
    timezone: "Pacific/Efate"
  },
  WF: {
    areaCodes: null,
    currency: t.XPF,
    dialCode: "681",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WF.png",
    iso2: "WF",
    name: "Wallis and Futuna (Wallis-et-Futuna)",
    priority: 0,
    timezone: "Pacific/Wallis"
  },
  WS: {
    areaCodes: null,
    currency: t.WST,
    dialCode: "685",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WS.png",
    iso2: "WS",
    name: "Samoa",
    priority: 0,
    timezone: "Pacific/Apia"
  },
  XK: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "383",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/XK.png",
    iso2: "XK",
    name: "Kosovo",
    priority: 0,
    timezone: "Europe/Rome"
  },
  YE: {
    areaCodes: null,
    currency: t.YER,
    dialCode: "967",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YE.png",
    iso2: "YE",
    name: "Yemen (‫اليمن‬‎)",
    priority: 0,
    timezone: "Asia/Aden"
  },
  YT: {
    areaCodes: null,
    currency: t.EUR,
    dialCode: "262",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YT.png",
    iso2: "YT",
    name: "Mayotte",
    priority: 1,
    timezone: "Indian/Mayotte"
  },
  ZA: {
    areaCodes: null,
    currency: t.ZAR,
    dialCode: "27",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZA.png",
    iso2: "ZA",
    name: "South Africa",
    priority: 0,
    timezone: "Africa/Johannesburg"
  },
  ZM: {
    areaCodes: null,
    currency: t.ZMK,
    dialCode: "260",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZM.png",
    iso2: "ZM",
    name: "Zambia",
    priority: 0,
    timezone: "Africa/Lusaka"
  },
  ZW: {
    areaCodes: null,
    currency: t.ZWL,
    dialCode: "263",
    icon: "https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZW.png",
    iso2: "ZW",
    name: "Zimbabwe",
    priority: 0,
    timezone: "Africa/Harare"
  }
};
Object.values(dl).map(
  (e) => e.iso2
);
var ya = { exports: {} }, gl = ya.exports, Un;
function uo() {
  return Un || (Un = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(gl, function() {
      var n = 1e3, r = 6e4, c = 36e5, d = "millisecond", u = "second", s = "minute", g = "hour", f = "day", b = "week", M = "month", C = "quarter", S = "year", v = "date", m = "Invalid Date", P = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, L = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, T = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(A) {
        var o = ["th", "st", "nd", "rd"], l = A % 100;
        return "[" + A + (o[(l - 20) % 10] || o[l] || o[0]) + "]";
      } }, R = function(A, o, l) {
        var h = String(A);
        return !h || h.length >= o ? A : "" + Array(o + 1 - h.length).join(l) + A;
      }, K = { s: R, z: function(A) {
        var o = -A.utcOffset(), l = Math.abs(o), h = Math.floor(l / 60), p = l % 60;
        return (o <= 0 ? "+" : "-") + R(h, 2, "0") + ":" + R(p, 2, "0");
      }, m: function A(o, l) {
        if (o.date() < l.date()) return -A(l, o);
        var h = 12 * (l.year() - o.year()) + (l.month() - o.month()), p = o.clone().add(h, M), D = l - p < 0, y = o.clone().add(h + (D ? -1 : 1), M);
        return +(-(h + (l - p) / (D ? p - y : y - p)) || 0);
      }, a: function(A) {
        return A < 0 ? Math.ceil(A) || 0 : Math.floor(A);
      }, p: function(A) {
        return { M, y: S, w: b, d: f, D: v, h: g, m: s, s: u, ms: d, Q: C }[A] || String(A || "").toLowerCase().replace(/s$/, "");
      }, u: function(A) {
        return A === void 0;
      } }, z = "en", O = {};
      O[z] = T;
      var F = "$isDayjsObject", I = function(A) {
        return A instanceof Z || !(!A || !A[F]);
      }, _ = function A(o, l, h) {
        var p;
        if (!o) return z;
        if (typeof o == "string") {
          var D = o.toLowerCase();
          O[D] && (p = D), l && (O[D] = l, p = D);
          var y = o.split("-");
          if (!p && y.length > 1) return A(y[0]);
        } else {
          var w = o.name;
          O[w] = o, p = w;
        }
        return !h && p && (z = p), p || !h && z;
      }, B = function(A, o) {
        if (I(A)) return A.clone();
        var l = typeof o == "object" ? o : {};
        return l.date = A, l.args = arguments, new Z(l);
      }, N = K;
      N.l = _, N.i = I, N.w = function(A, o) {
        return B(A, { locale: o.$L, utc: o.$u, x: o.$x, $offset: o.$offset });
      };
      var Z = function() {
        function A(l) {
          this.$L = _(l.locale, null, !0), this.parse(l), this.$x = this.$x || l.x || {}, this[F] = !0;
        }
        var o = A.prototype;
        return o.parse = function(l) {
          this.$d = function(h) {
            var p = h.date, D = h.utc;
            if (p === null) return /* @__PURE__ */ new Date(NaN);
            if (N.u(p)) return /* @__PURE__ */ new Date();
            if (p instanceof Date) return new Date(p);
            if (typeof p == "string" && !/Z$/i.test(p)) {
              var y = p.match(P);
              if (y) {
                var w = y[2] - 1 || 0, G = (y[7] || "0").substring(0, 3);
                return D ? new Date(Date.UTC(y[1], w, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, G)) : new Date(y[1], w, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, G);
              }
            }
            return new Date(p);
          }(l), this.init();
        }, o.init = function() {
          var l = this.$d;
          this.$y = l.getFullYear(), this.$M = l.getMonth(), this.$D = l.getDate(), this.$W = l.getDay(), this.$H = l.getHours(), this.$m = l.getMinutes(), this.$s = l.getSeconds(), this.$ms = l.getMilliseconds();
        }, o.$utils = function() {
          return N;
        }, o.isValid = function() {
          return this.$d.toString() !== m;
        }, o.isSame = function(l, h) {
          var p = B(l);
          return this.startOf(h) <= p && p <= this.endOf(h);
        }, o.isAfter = function(l, h) {
          return B(l) < this.startOf(h);
        }, o.isBefore = function(l, h) {
          return this.endOf(h) < B(l);
        }, o.$g = function(l, h, p) {
          return N.u(l) ? this[h] : this.set(p, l);
        }, o.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, o.valueOf = function() {
          return this.$d.getTime();
        }, o.startOf = function(l, h) {
          var p = this, D = !!N.u(h) || h, y = N.p(l), w = function(X, Y) {
            var x = N.w(p.$u ? Date.UTC(p.$y, Y, X) : new Date(p.$y, Y, X), p);
            return D ? x : x.endOf(f);
          }, G = function(X, Y) {
            return N.w(p.toDate()[X].apply(p.toDate("s"), (D ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Y)), p);
          }, U = this.$W, E = this.$M, H = this.$D, q = "set" + (this.$u ? "UTC" : "");
          switch (y) {
            case S:
              return D ? w(1, 0) : w(31, 11);
            case M:
              return D ? w(1, E) : w(0, E + 1);
            case b:
              var J = this.$locale().weekStart || 0, Q = (U < J ? U + 7 : U) - J;
              return w(D ? H - Q : H + (6 - Q), E);
            case f:
            case v:
              return G(q + "Hours", 0);
            case g:
              return G(q + "Minutes", 1);
            case s:
              return G(q + "Seconds", 2);
            case u:
              return G(q + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, o.endOf = function(l) {
          return this.startOf(l, !1);
        }, o.$set = function(l, h) {
          var p, D = N.p(l), y = "set" + (this.$u ? "UTC" : ""), w = (p = {}, p[f] = y + "Date", p[v] = y + "Date", p[M] = y + "Month", p[S] = y + "FullYear", p[g] = y + "Hours", p[s] = y + "Minutes", p[u] = y + "Seconds", p[d] = y + "Milliseconds", p)[D], G = D === f ? this.$D + (h - this.$W) : h;
          if (D === M || D === S) {
            var U = this.clone().set(v, 1);
            U.$d[w](G), U.init(), this.$d = U.set(v, Math.min(this.$D, U.daysInMonth())).$d;
          } else w && this.$d[w](G);
          return this.init(), this;
        }, o.set = function(l, h) {
          return this.clone().$set(l, h);
        }, o.get = function(l) {
          return this[N.p(l)]();
        }, o.add = function(l, h) {
          var p, D = this;
          l = Number(l);
          var y = N.p(h), w = function(E) {
            var H = B(D);
            return N.w(H.date(H.date() + Math.round(E * l)), D);
          };
          if (y === M) return this.set(M, this.$M + l);
          if (y === S) return this.set(S, this.$y + l);
          if (y === f) return w(1);
          if (y === b) return w(7);
          var G = (p = {}, p[s] = r, p[g] = c, p[u] = n, p)[y] || 1, U = this.$d.getTime() + l * G;
          return N.w(U, this);
        }, o.subtract = function(l, h) {
          return this.add(-1 * l, h);
        }, o.format = function(l) {
          var h = this, p = this.$locale();
          if (!this.isValid()) return p.invalidDate || m;
          var D = l || "YYYY-MM-DDTHH:mm:ssZ", y = N.z(this), w = this.$H, G = this.$m, U = this.$M, E = p.weekdays, H = p.months, q = p.meridiem, J = function(Y, x, ee, te) {
            return Y && (Y[x] || Y(h, D)) || ee[x].slice(0, te);
          }, Q = function(Y) {
            return N.s(w % 12 || 12, Y, "0");
          }, X = q || function(Y, x, ee) {
            var te = Y < 12 ? "AM" : "PM";
            return ee ? te.toLowerCase() : te;
          };
          return D.replace(L, function(Y, x) {
            return x || function(ee) {
              switch (ee) {
                case "YY":
                  return String(h.$y).slice(-2);
                case "YYYY":
                  return N.s(h.$y, 4, "0");
                case "M":
                  return U + 1;
                case "MM":
                  return N.s(U + 1, 2, "0");
                case "MMM":
                  return J(p.monthsShort, U, H, 3);
                case "MMMM":
                  return J(H, U);
                case "D":
                  return h.$D;
                case "DD":
                  return N.s(h.$D, 2, "0");
                case "d":
                  return String(h.$W);
                case "dd":
                  return J(p.weekdaysMin, h.$W, E, 2);
                case "ddd":
                  return J(p.weekdaysShort, h.$W, E, 3);
                case "dddd":
                  return E[h.$W];
                case "H":
                  return String(w);
                case "HH":
                  return N.s(w, 2, "0");
                case "h":
                  return Q(1);
                case "hh":
                  return Q(2);
                case "a":
                  return X(w, G, !0);
                case "A":
                  return X(w, G, !1);
                case "m":
                  return String(G);
                case "mm":
                  return N.s(G, 2, "0");
                case "s":
                  return String(h.$s);
                case "ss":
                  return N.s(h.$s, 2, "0");
                case "SSS":
                  return N.s(h.$ms, 3, "0");
                case "Z":
                  return y;
              }
              return null;
            }(Y) || y.replace(":", "");
          });
        }, o.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, o.diff = function(l, h, p) {
          var D, y = this, w = N.p(h), G = B(l), U = (G.utcOffset() - this.utcOffset()) * r, E = this - G, H = function() {
            return N.m(y, G);
          };
          switch (w) {
            case S:
              D = H() / 12;
              break;
            case M:
              D = H();
              break;
            case C:
              D = H() / 3;
              break;
            case b:
              D = (E - U) / 6048e5;
              break;
            case f:
              D = (E - U) / 864e5;
              break;
            case g:
              D = E / c;
              break;
            case s:
              D = E / r;
              break;
            case u:
              D = E / n;
              break;
            default:
              D = E;
          }
          return p ? D : N.a(D);
        }, o.daysInMonth = function() {
          return this.endOf(M).$D;
        }, o.$locale = function() {
          return O[this.$L];
        }, o.locale = function(l, h) {
          if (!l) return this.$L;
          var p = this.clone(), D = _(l, h, !0);
          return D && (p.$L = D), p;
        }, o.clone = function() {
          return N.w(this.$d, this);
        }, o.toDate = function() {
          return new Date(this.valueOf());
        }, o.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, o.toISOString = function() {
          return this.$d.toISOString();
        }, o.toString = function() {
          return this.$d.toUTCString();
        }, A;
      }(), ye = Z.prototype;
      return B.prototype = ye, [["$ms", d], ["$s", u], ["$m", s], ["$H", g], ["$W", f], ["$M", M], ["$y", S], ["$D", v]].forEach(function(A) {
        ye[A[1]] = function(o) {
          return this.$g(o, A[0], A[1]);
        };
      }), B.extend = function(A, o) {
        return A.$i || (A(o, Z, B), A.$i = !0), B;
      }, B.locale = _, B.isDayjs = I, B.unix = function(A) {
        return B(1e3 * A);
      }, B.en = O[z], B.Ls = O, B.p = {}, B;
    });
  }(ya)), ya.exports;
}
var ml = uo();
const ge = /* @__PURE__ */ oe(ml);
var ba = { exports: {} }, pl = ba.exports, Fn;
function hl() {
  return Fn || (Fn = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(pl, function() {
      return function(n, r) {
        var c = r.prototype, d = c.format;
        c.format = function(u) {
          var s = this, g = this.$locale();
          if (!this.isValid()) return d.bind(this)(u);
          var f = this.$utils(), b = (u || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(M) {
            switch (M) {
              case "Q":
                return Math.ceil((s.$M + 1) / 3);
              case "Do":
                return g.ordinal(s.$D);
              case "gggg":
                return s.weekYear();
              case "GGGG":
                return s.isoWeekYear();
              case "wo":
                return g.ordinal(s.week(), "W");
              case "w":
              case "ww":
                return f.s(s.week(), M === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return f.s(s.isoWeek(), M === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return f.s(String(s.$H === 0 ? 24 : s.$H), M === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(s.$d.getTime() / 1e3);
              case "x":
                return s.$d.getTime();
              case "z":
                return "[" + s.offsetName() + "]";
              case "zzz":
                return "[" + s.offsetName("long") + "]";
              default:
                return M;
            }
          });
          return d.bind(this)(b);
        };
      };
    });
  }(ba)), ba.exports;
}
var fl = hl();
const yl = /* @__PURE__ */ oe(fl);
var Da = { exports: {} }, bl = Da.exports, _n;
function Dl() {
  return _n || (_n = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(bl, function() {
      return function(n, r, c) {
        r.prototype.isBetween = function(d, u, s, g) {
          var f = c(d), b = c(u), M = (g = g || "()")[0] === "(", C = g[1] === ")";
          return (M ? this.isAfter(f, s) : !this.isBefore(f, s)) && (C ? this.isBefore(b, s) : !this.isAfter(b, s)) || (M ? this.isBefore(f, s) : !this.isAfter(f, s)) && (C ? this.isAfter(b, s) : !this.isBefore(b, s));
        };
      };
    });
  }(Da)), Da.exports;
}
var Cl = Dl();
const vl = /* @__PURE__ */ oe(Cl);
var Ca = { exports: {} }, Al = Ca.exports, In;
function Sl() {
  return In || (In = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Al, function() {
      return function(n, r) {
        r.prototype.isSameOrAfter = function(c, d) {
          return this.isSame(c, d) || this.isAfter(c, d);
        };
      };
    });
  }(Ca)), Ca.exports;
}
var Ml = Sl();
const Pl = /* @__PURE__ */ oe(Ml);
var va = { exports: {} }, Nl = va.exports, Hn;
function zl() {
  return Hn || (Hn = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Nl, function() {
      return function(n, r) {
        r.prototype.isSameOrBefore = function(c, d) {
          return this.isSame(c, d) || this.isBefore(c, d);
        };
      };
    });
  }(va)), va.exports;
}
var wl = zl();
const Rl = /* @__PURE__ */ oe(wl);
var Aa = { exports: {} }, Bl = Aa.exports, Yn;
function Tl() {
  return Yn || (Yn = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Bl, function() {
      var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
      return function(r, c, d) {
        var u = c.prototype, s = u.format;
        d.en.formats = n, u.format = function(g) {
          g === void 0 && (g = "YYYY-MM-DDTHH:mm:ssZ");
          var f = this.$locale().formats, b = function(M, C) {
            return M.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(S, v, m) {
              var P = m && m.toUpperCase();
              return v || C[m] || n[m] || C[P].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(L, T, R) {
                return T || R.slice(1);
              });
            });
          }(g, f === void 0 ? {} : f);
          return s.call(this, b);
        };
      };
    });
  }(Aa)), Aa.exports;
}
var El = Tl();
const Ll = /* @__PURE__ */ oe(El);
var Sa = { exports: {} }, Ol = Sa.exports, $n;
function Gl() {
  return $n || ($n = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Ol, function() {
      return function(n, r, c) {
        var d = function(u, s) {
          if (!s || !s.length || s.length === 1 && !s[0] || s.length === 1 && Array.isArray(s[0]) && !s[0].length) return null;
          var g;
          s.length === 1 && s[0].length > 0 && (s = s[0]), g = (s = s.filter(function(b) {
            return b;
          }))[0];
          for (var f = 1; f < s.length; f += 1) s[f].isValid() && !s[f][u](g) || (g = s[f]);
          return g;
        };
        c.max = function() {
          var u = [].slice.call(arguments, 0);
          return d("isAfter", u);
        }, c.min = function() {
          var u = [].slice.call(arguments, 0);
          return d("isBefore", u);
        };
      };
    });
  }(Sa)), Sa.exports;
}
var Kl = Gl();
const Ul = /* @__PURE__ */ oe(Kl);
var Ma = { exports: {} }, Fl = Ma.exports, kn;
function _l() {
  return kn || (kn = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Fl, function() {
      return function(n, r, c) {
        n = n || {};
        var d = r.prototype, u = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function s(f, b, M, C) {
          return d.fromToBase(f, b, M, C);
        }
        c.en.relativeTime = u, d.fromToBase = function(f, b, M, C, S) {
          for (var v, m, P, L = M.$locale().relativeTime || u, T = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], R = T.length, K = 0; K < R; K += 1) {
            var z = T[K];
            z.d && (v = C ? c(f).diff(M, z.d, !0) : M.diff(f, z.d, !0));
            var O = (n.rounding || Math.round)(Math.abs(v));
            if (P = v > 0, O <= z.r || !z.r) {
              O <= 1 && K > 0 && (z = T[K - 1]);
              var F = L[z.l];
              S && (O = S("" + O)), m = typeof F == "string" ? F.replace("%d", O) : F(O, b, z.l, P);
              break;
            }
          }
          if (b) return m;
          var I = P ? L.future : L.past;
          return typeof I == "function" ? I(m) : I.replace("%s", m);
        }, d.to = function(f, b) {
          return s(f, b, this, !0);
        }, d.from = function(f, b) {
          return s(f, b, this);
        };
        var g = function(f) {
          return f.$u ? c.utc() : c();
        };
        d.toNow = function(f) {
          return this.to(g(this), f);
        }, d.fromNow = function(f) {
          return this.from(g(this), f);
        };
      };
    });
  }(Ma)), Ma.exports;
}
var Il = _l();
const Hl = /* @__PURE__ */ oe(Il);
var Pa = { exports: {} }, Yl = Pa.exports, jn;
function $l() {
  return jn || (jn = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Yl, function() {
      var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, r = {};
      return function(c, d, u) {
        var s, g = function(C, S, v) {
          v === void 0 && (v = {});
          var m = new Date(C), P = function(L, T) {
            T === void 0 && (T = {});
            var R = T.timeZoneName || "short", K = L + "|" + R, z = r[K];
            return z || (z = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: L, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: R }), r[K] = z), z;
          }(S, v);
          return P.formatToParts(m);
        }, f = function(C, S) {
          for (var v = g(C, S), m = [], P = 0; P < v.length; P += 1) {
            var L = v[P], T = L.type, R = L.value, K = n[T];
            K >= 0 && (m[K] = parseInt(R, 10));
          }
          var z = m[3], O = z === 24 ? 0 : z, F = m[0] + "-" + m[1] + "-" + m[2] + " " + O + ":" + m[4] + ":" + m[5] + ":000", I = +C;
          return (u.utc(F).valueOf() - (I -= I % 1e3)) / 6e4;
        }, b = d.prototype;
        b.tz = function(C, S) {
          C === void 0 && (C = s);
          var v, m = this.utcOffset(), P = this.toDate(), L = P.toLocaleString("en-US", { timeZone: C }), T = Math.round((P - new Date(L)) / 1e3 / 60), R = 15 * -Math.round(P.getTimezoneOffset() / 15) - T;
          if (!Number(R)) v = this.utcOffset(0, S);
          else if (v = u(L, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(R, !0), S) {
            var K = v.utcOffset();
            v = v.add(m - K, "minute");
          }
          return v.$x.$timezone = C, v;
        }, b.offsetName = function(C) {
          var S = this.$x.$timezone || u.tz.guess(), v = g(this.valueOf(), S, { timeZoneName: C }).find(function(m) {
            return m.type.toLowerCase() === "timezonename";
          });
          return v && v.value;
        };
        var M = b.startOf;
        b.startOf = function(C, S) {
          if (!this.$x || !this.$x.$timezone) return M.call(this, C, S);
          var v = u(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return M.call(v, C, S).tz(this.$x.$timezone, !0);
        }, u.tz = function(C, S, v) {
          var m = v && S, P = v || S || s, L = f(+u(), P);
          if (typeof C != "string") return u(C).tz(P);
          var T = function(O, F, I) {
            var _ = O - 60 * F * 1e3, B = f(_, I);
            if (F === B) return [_, F];
            var N = f(_ -= 60 * (B - F) * 1e3, I);
            return B === N ? [_, B] : [O - 60 * Math.min(B, N) * 1e3, Math.max(B, N)];
          }(u.utc(C, m).valueOf(), L, P), R = T[0], K = T[1], z = u(R).utcOffset(K);
          return z.$x.$timezone = P, z;
        }, u.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, u.tz.setDefault = function(C) {
          s = C;
        };
      };
    });
  }(Pa)), Pa.exports;
}
var kl = $l();
const jl = /* @__PURE__ */ oe(kl);
var Na = { exports: {} }, Vl = Na.exports, Vn;
function Zl() {
  return Vn || (Vn = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Vl, function() {
      var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, c = /([+-]|\d\d)/g;
      return function(d, u, s) {
        var g = u.prototype;
        s.utc = function(m) {
          var P = { date: m, utc: !0, args: arguments };
          return new u(P);
        }, g.utc = function(m) {
          var P = s(this.toDate(), { locale: this.$L, utc: !0 });
          return m ? P.add(this.utcOffset(), n) : P;
        }, g.local = function() {
          return s(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var f = g.parse;
        g.parse = function(m) {
          m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), f.call(this, m);
        };
        var b = g.init;
        g.init = function() {
          if (this.$u) {
            var m = this.$d;
            this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
          } else b.call(this);
        };
        var M = g.utcOffset;
        g.utcOffset = function(m, P) {
          var L = this.$utils().u;
          if (L(m)) return this.$u ? 0 : L(this.$offset) ? M.call(this) : this.$offset;
          if (typeof m == "string" && (m = function(z) {
            z === void 0 && (z = "");
            var O = z.match(r);
            if (!O) return null;
            var F = ("" + O[0]).match(c) || ["-", 0, 0], I = F[0], _ = 60 * +F[1] + +F[2];
            return _ === 0 ? 0 : I === "+" ? _ : -_;
          }(m), m === null)) return this;
          var T = Math.abs(m) <= 16 ? 60 * m : m, R = this;
          if (P) return R.$offset = T, R.$u = m === 0, R;
          if (m !== 0) {
            var K = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (R = this.local().add(T + K, n)).$offset = T, R.$x.$localOffset = K;
          } else R = this.utc();
          return R;
        };
        var C = g.format;
        g.format = function(m) {
          var P = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return C.call(this, P);
        }, g.valueOf = function() {
          var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * m;
        }, g.isUTC = function() {
          return !!this.$u;
        }, g.toISOString = function() {
          return this.toDate().toISOString();
        }, g.toString = function() {
          return this.toDate().toUTCString();
        };
        var S = g.toDate;
        g.toDate = function(m) {
          return m === "s" && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : S.call(this);
        };
        var v = g.diff;
        g.diff = function(m, P, L) {
          if (m && this.$u === m.$u) return v.call(this, m, P, L);
          var T = this.local(), R = s(m).local();
          return v.call(T, R, P, L);
        };
      };
    });
  }(Na)), Na.exports;
}
var xl = Zl();
const Wl = /* @__PURE__ */ oe(xl);
var za = { exports: {} }, Jl = za.exports, Zn;
function Xl() {
  return Zn || (Zn = 1, function(e, a) {
    (function(n, r) {
      e.exports = r(uo());
    })(Jl, function(n) {
      function r(u) {
        return u && typeof u == "object" && "default" in u ? u : { default: u };
      }
      var c = r(n), d = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(u) {
        return "" + u + (u === 1 ? "er" : "");
      } };
      return c.default.locale(d, null, !0), d;
    });
  }(za)), za.exports;
}
Xl();
var wa = { exports: {} }, ql = wa.exports, xn;
function Ql() {
  return xn || (xn = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(ql, function() {
      return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(n) {
        var r = ["th", "st", "nd", "rd"], c = n % 100;
        return "[" + n + (r[(c - 20) % 10] || r[c] || r[0]) + "]";
      } };
    });
  }(wa)), wa.exports;
}
Ql();
ge.extend(yl);
ge.extend(vl);
ge.extend(Pl);
ge.extend(Rl);
ge.extend(Ll);
ge.extend(Ul);
ge.extend(Hl);
ge.extend(jl);
ge.extend(Wl);
const eu = [];
for (let e = 0; e < 256; ++e)
  eu.push((e + 256).toString(16).slice(1));
typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var sa = { exports: {} }, Wn;
function au() {
  return Wn || (Wn = 1, function(e, a) {
    var n = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof He < "u" && He, r = function() {
      function d() {
        this.fetch = !1, this.DOMException = n.DOMException;
      }
      return d.prototype = n, new d();
    }();
    (function(d) {
      (function(u) {
        var s = typeof d < "u" && d || typeof self < "u" && self || // eslint-disable-next-line no-undef
        typeof He < "u" && He || {}, g = {
          searchParams: "URLSearchParams" in s,
          iterable: "Symbol" in s && "iterator" in Symbol,
          blob: "FileReader" in s && "Blob" in s && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(),
          formData: "FormData" in s,
          arrayBuffer: "ArrayBuffer" in s
        };
        function f(o) {
          return o && DataView.prototype.isPrototypeOf(o);
        }
        if (g.arrayBuffer)
          var b = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], M = ArrayBuffer.isView || function(o) {
            return o && b.indexOf(Object.prototype.toString.call(o)) > -1;
          };
        function C(o) {
          if (typeof o != "string" && (o = String(o)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(o) || o === "")
            throw new TypeError('Invalid character in header field name: "' + o + '"');
          return o.toLowerCase();
        }
        function S(o) {
          return typeof o != "string" && (o = String(o)), o;
        }
        function v(o) {
          var l = {
            next: function() {
              var h = o.shift();
              return { done: h === void 0, value: h };
            }
          };
          return g.iterable && (l[Symbol.iterator] = function() {
            return l;
          }), l;
        }
        function m(o) {
          this.map = {}, o instanceof m ? o.forEach(function(l, h) {
            this.append(h, l);
          }, this) : Array.isArray(o) ? o.forEach(function(l) {
            if (l.length != 2)
              throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + l.length);
            this.append(l[0], l[1]);
          }, this) : o && Object.getOwnPropertyNames(o).forEach(function(l) {
            this.append(l, o[l]);
          }, this);
        }
        m.prototype.append = function(o, l) {
          o = C(o), l = S(l);
          var h = this.map[o];
          this.map[o] = h ? h + ", " + l : l;
        }, m.prototype.delete = function(o) {
          delete this.map[C(o)];
        }, m.prototype.get = function(o) {
          return o = C(o), this.has(o) ? this.map[o] : null;
        }, m.prototype.has = function(o) {
          return this.map.hasOwnProperty(C(o));
        }, m.prototype.set = function(o, l) {
          this.map[C(o)] = S(l);
        }, m.prototype.forEach = function(o, l) {
          for (var h in this.map)
            this.map.hasOwnProperty(h) && o.call(l, this.map[h], h, this);
        }, m.prototype.keys = function() {
          var o = [];
          return this.forEach(function(l, h) {
            o.push(h);
          }), v(o);
        }, m.prototype.values = function() {
          var o = [];
          return this.forEach(function(l) {
            o.push(l);
          }), v(o);
        }, m.prototype.entries = function() {
          var o = [];
          return this.forEach(function(l, h) {
            o.push([h, l]);
          }), v(o);
        }, g.iterable && (m.prototype[Symbol.iterator] = m.prototype.entries);
        function P(o) {
          if (!o._noBody) {
            if (o.bodyUsed)
              return Promise.reject(new TypeError("Already read"));
            o.bodyUsed = !0;
          }
        }
        function L(o) {
          return new Promise(function(l, h) {
            o.onload = function() {
              l(o.result);
            }, o.onerror = function() {
              h(o.error);
            };
          });
        }
        function T(o) {
          var l = new FileReader(), h = L(l);
          return l.readAsArrayBuffer(o), h;
        }
        function R(o) {
          var l = new FileReader(), h = L(l), p = /charset=([A-Za-z0-9_-]+)/.exec(o.type), D = p ? p[1] : "utf-8";
          return l.readAsText(o, D), h;
        }
        function K(o) {
          for (var l = new Uint8Array(o), h = new Array(l.length), p = 0; p < l.length; p++)
            h[p] = String.fromCharCode(l[p]);
          return h.join("");
        }
        function z(o) {
          if (o.slice)
            return o.slice(0);
          var l = new Uint8Array(o.byteLength);
          return l.set(new Uint8Array(o)), l.buffer;
        }
        function O() {
          return this.bodyUsed = !1, this._initBody = function(o) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = o, o ? typeof o == "string" ? this._bodyText = o : g.blob && Blob.prototype.isPrototypeOf(o) ? this._bodyBlob = o : g.formData && FormData.prototype.isPrototypeOf(o) ? this._bodyFormData = o : g.searchParams && URLSearchParams.prototype.isPrototypeOf(o) ? this._bodyText = o.toString() : g.arrayBuffer && g.blob && f(o) ? (this._bodyArrayBuffer = z(o.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : g.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(o) || M(o)) ? this._bodyArrayBuffer = z(o) : this._bodyText = o = Object.prototype.toString.call(o) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof o == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : g.searchParams && URLSearchParams.prototype.isPrototypeOf(o) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, g.blob && (this.blob = function() {
            var o = P(this);
            if (o)
              return o;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }), this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var o = P(this);
              return o || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else {
              if (g.blob)
                return this.blob().then(T);
              throw new Error("could not read as ArrayBuffer");
            }
          }, this.text = function() {
            var o = P(this);
            if (o)
              return o;
            if (this._bodyBlob)
              return R(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(K(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, g.formData && (this.formData = function() {
            return this.text().then(B);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var F = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
        function I(o) {
          var l = o.toUpperCase();
          return F.indexOf(l) > -1 ? l : o;
        }
        function _(o, l) {
          if (!(this instanceof _))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          l = l || {};
          var h = l.body;
          if (o instanceof _) {
            if (o.bodyUsed)
              throw new TypeError("Already read");
            this.url = o.url, this.credentials = o.credentials, l.headers || (this.headers = new m(o.headers)), this.method = o.method, this.mode = o.mode, this.signal = o.signal, !h && o._bodyInit != null && (h = o._bodyInit, o.bodyUsed = !0);
          } else
            this.url = String(o);
          if (this.credentials = l.credentials || this.credentials || "same-origin", (l.headers || !this.headers) && (this.headers = new m(l.headers)), this.method = I(l.method || this.method || "GET"), this.mode = l.mode || this.mode || null, this.signal = l.signal || this.signal || function() {
            if ("AbortController" in s) {
              var y = new AbortController();
              return y.signal;
            }
          }(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && h)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(h), (this.method === "GET" || this.method === "HEAD") && (l.cache === "no-store" || l.cache === "no-cache")) {
            var p = /([?&])_=[^&]*/;
            if (p.test(this.url))
              this.url = this.url.replace(p, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var D = /\?/;
              this.url += (D.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        _.prototype.clone = function() {
          return new _(this, { body: this._bodyInit });
        };
        function B(o) {
          var l = new FormData();
          return o.trim().split("&").forEach(function(h) {
            if (h) {
              var p = h.split("="), D = p.shift().replace(/\+/g, " "), y = p.join("=").replace(/\+/g, " ");
              l.append(decodeURIComponent(D), decodeURIComponent(y));
            }
          }), l;
        }
        function N(o) {
          var l = new m(), h = o.replace(/\r?\n[\t ]+/g, " ");
          return h.split("\r").map(function(p) {
            return p.indexOf(`
`) === 0 ? p.substr(1, p.length) : p;
          }).forEach(function(p) {
            var D = p.split(":"), y = D.shift().trim();
            if (y) {
              var w = D.join(":").trim();
              try {
                l.append(y, w);
              } catch (G) {
                console.warn("Response " + G.message);
              }
            }
          }), l;
        }
        O.call(_.prototype);
        function Z(o, l) {
          if (!(this instanceof Z))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          if (l || (l = {}), this.type = "default", this.status = l.status === void 0 ? 200 : l.status, this.status < 200 || this.status > 599)
            throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
          this.ok = this.status >= 200 && this.status < 300, this.statusText = l.statusText === void 0 ? "" : "" + l.statusText, this.headers = new m(l.headers), this.url = l.url || "", this._initBody(o);
        }
        O.call(Z.prototype), Z.prototype.clone = function() {
          return new Z(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new m(this.headers),
            url: this.url
          });
        }, Z.error = function() {
          var o = new Z(null, { status: 200, statusText: "" });
          return o.ok = !1, o.status = 0, o.type = "error", o;
        };
        var ye = [301, 302, 303, 307, 308];
        Z.redirect = function(o, l) {
          if (ye.indexOf(l) === -1)
            throw new RangeError("Invalid status code");
          return new Z(null, { status: l, headers: { location: o } });
        }, u.DOMException = s.DOMException;
        try {
          new u.DOMException();
        } catch {
          u.DOMException = function(o, l) {
            this.message = o, this.name = l;
            var h = Error(o);
            this.stack = h.stack;
          }, u.DOMException.prototype = Object.create(Error.prototype), u.DOMException.prototype.constructor = u.DOMException;
        }
        function A(o, l) {
          return new Promise(function(h, p) {
            var D = new _(o, l);
            if (D.signal && D.signal.aborted)
              return p(new u.DOMException("Aborted", "AbortError"));
            var y = new XMLHttpRequest();
            function w() {
              y.abort();
            }
            y.onload = function() {
              var E = {
                statusText: y.statusText,
                headers: N(y.getAllResponseHeaders() || "")
              };
              D.url.indexOf("file://") === 0 && (y.status < 200 || y.status > 599) ? E.status = 200 : E.status = y.status, E.url = "responseURL" in y ? y.responseURL : E.headers.get("X-Request-URL");
              var H = "response" in y ? y.response : y.responseText;
              setTimeout(function() {
                h(new Z(H, E));
              }, 0);
            }, y.onerror = function() {
              setTimeout(function() {
                p(new TypeError("Network request failed"));
              }, 0);
            }, y.ontimeout = function() {
              setTimeout(function() {
                p(new TypeError("Network request timed out"));
              }, 0);
            }, y.onabort = function() {
              setTimeout(function() {
                p(new u.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function G(E) {
              try {
                return E === "" && s.location.href ? s.location.href : E;
              } catch {
                return E;
              }
            }
            if (y.open(D.method, G(D.url), !0), D.credentials === "include" ? y.withCredentials = !0 : D.credentials === "omit" && (y.withCredentials = !1), "responseType" in y && (g.blob ? y.responseType = "blob" : g.arrayBuffer && (y.responseType = "arraybuffer")), l && typeof l.headers == "object" && !(l.headers instanceof m || s.Headers && l.headers instanceof s.Headers)) {
              var U = [];
              Object.getOwnPropertyNames(l.headers).forEach(function(E) {
                U.push(C(E)), y.setRequestHeader(E, S(l.headers[E]));
              }), D.headers.forEach(function(E, H) {
                U.indexOf(H) === -1 && y.setRequestHeader(H, E);
              });
            } else
              D.headers.forEach(function(E, H) {
                y.setRequestHeader(H, E);
              });
            D.signal && (D.signal.addEventListener("abort", w), y.onreadystatechange = function() {
              y.readyState === 4 && D.signal.removeEventListener("abort", w);
            }), y.send(typeof D._bodyInit > "u" ? null : D._bodyInit);
          });
        }
        return A.polyfill = !0, s.fetch || (s.fetch = A, s.Headers = m, s.Request = _, s.Response = Z), u.Headers = m, u.Request = _, u.Response = Z, u.fetch = A, u;
      })({});
    })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
    var c = n.fetch ? n : r;
    a = c.fetch, a.default = c.fetch, a.fetch = c.fetch, a.Headers = c.Headers, a.Request = c.Request, a.Response = c.Response, e.exports = a;
  }(sa, sa.exports)), sa.exports;
}
au();
i.EUR;
const nu = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), ru = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), ou = new RegExp("(\\d)\\p{Ll}|(\\p{L})\\d", "u"), iu = /[^\p{L}\d]+/giu, Jn = "$1\0$2", Xn = "";
function co(e) {
  let a = e.trim();
  a = a.replace(nu, Jn).replace(ru, Jn), a = a.replace(iu, "\0");
  let n = 0, r = a.length;
  for (; a.charAt(n) === "\0"; )
    n++;
  if (n === r)
    return [];
  for (; a.charAt(r - 1) === "\0"; )
    r--;
  return a.slice(n, r).split(/\0/g);
}
function tu(e) {
  const a = co(e);
  for (let n = 0; n < a.length; n++) {
    const r = a[n], c = ou.exec(r);
    if (c) {
      const d = c.index + (c[1] ?? c[2]).length;
      a.splice(n, 1, r.slice(0, d), r.slice(d));
    }
  }
  return a;
}
function go(e, a) {
  const [n, r, c] = ea(e, a);
  return n + r.map(Qe(a?.locale)).join(a?.delimiter ?? " ") + c;
}
function su(e, a) {
  const [n, r, c] = ea(e, a), d = Qe(a?.locale), u = an(a?.locale), s = a?.mergeAmbiguousCharacters ? nn(d, u) : po(d, u);
  return n + r.map((g, f) => f === 0 ? d(g) : s(g, f)).join(a?.delimiter ?? "") + c;
}
function lu(e, a) {
  const [n, r, c] = ea(e, a), d = Qe(a?.locale), u = an(a?.locale), s = a?.mergeAmbiguousCharacters ? nn(d, u) : po(d, u);
  return n + r.map(s).join(a?.delimiter ?? "") + c;
}
function uu(e, a) {
  const [n, r, c] = ea(e, a), d = Qe(a?.locale), u = an(a?.locale);
  return n + r.map(nn(d, u)).join(a?.delimiter ?? " ") + c;
}
function mo(e, a) {
  return go(e, { delimiter: "-", ...a });
}
function cu(e, a) {
  return go(e, { delimiter: "_", ...a });
}
function Qe(e) {
  return e === !1 ? (a) => a.toLowerCase() : (a) => a.toLocaleLowerCase(e);
}
function an(e) {
  return e === !1 ? (a) => a.toUpperCase() : (a) => a.toLocaleUpperCase(e);
}
function nn(e, a) {
  return (n) => `${a(n[0])}${e(n.slice(1))}`;
}
function po(e, a) {
  return (n, r) => {
    const c = n[0];
    return (r > 0 && c >= "0" && c <= "9" ? "_" + c : a(c)) + e(n.slice(1));
  };
}
function ea(e, a = {}) {
  const n = a.split ?? (a.separateNumbers ? tu : co), r = a.prefixCharacters ?? Xn, c = a.suffixCharacters ?? Xn;
  let d = 0, u = e.length;
  for (; d < e.length; ) {
    const s = e.charAt(d);
    if (!r.includes(s))
      break;
    d++;
  }
  for (; u > d; ) {
    const s = u - 1, g = e.charAt(s);
    if (!c.includes(g))
      break;
    u = s;
  }
  return [
    e.slice(0, d),
    n(e.slice(d, u)),
    e.slice(u)
  ];
}
function ae(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ra = { exports: {} }, du = Ra.exports, qn;
function gu() {
  return qn || (qn = 1, function(e, a) {
    (function(n, r, c) {
      e.exports = c(), e.exports.default = c();
    })("slugify", du, function() {
      var n = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E'","Ը":"Y'","Թ":"T'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C'","Կ":"K","Հ":"H","Ձ":"D'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P'","Ք":"Q'","Օ":"O''","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"'","’":"'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}`), r = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}');
      function c(d, u) {
        if (typeof d != "string")
          throw new Error("slugify: string argument expected");
        u = typeof u == "string" ? { replacement: u } : u || {};
        var s = r[u.locale] || {}, g = u.replacement === void 0 ? "-" : u.replacement, f = u.trim === void 0 ? !0 : u.trim, b = d.normalize().split("").reduce(function(M, C) {
          var S = s[C];
          return S === void 0 && (S = n[C]), S === void 0 && (S = C), S === g && (S = " "), M + S.replace(u.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        return u.strict && (b = b.replace(/[^A-Za-z0-9\s]/g, "")), f && (b = b.trim()), b = b.replace(/\s+/g, g), u.lower && (b = b.toLowerCase()), b;
      }
      return c.extend = function(d) {
        Object.assign(n, d);
      }, c;
    });
  }(Ra)), Ra.exports;
}
var mu = gu();
const pu = /* @__PURE__ */ ae(mu);
function hu(e) {
  return pu(mo(e), {
    lower: !0,
    strict: !0
  });
}
var ho = /* @__PURE__ */ ((e) => (e.Camel = "camelCase", e.Capital = "capitalCase", e.Param = "paramCase", e.Pascal = "pascalCase", e.Slug = "slugCase", e.Snake = "snakeCase", e))(ho || {});
const fu = {
  camelCase: su,
  capitalCase: uu,
  paramCase: mo,
  pascalCase: lu,
  slugCase: hu,
  snakeCase: cu
};
function yu(e, a) {
  return e.some(
    (n) => typeof n == "string" ? n === a : n.test(a)
  );
}
function bu(e) {
  return e === Object(e) && !Array.isArray(e) && typeof e != "function";
}
function Ba(e, a, n = { deep: !0 }) {
  return bu(e) ? Object.keys(e).reduce((r, c) => {
    const d = n?.exclude && yu(n.exclude, c) ? c : fu[a](c);
    return r[d] = n.deep ? Ba(e[c], a, n) : e[c], r;
  }, {}) : Array.isArray(e) ? e.map((r) => Ba(r, a, n)) : e;
}
var fo = typeof global == "object" && global && global.Object === Object && global, Du = typeof self == "object" && self && self.Object === Object && self, ie = fo || Du || Function("return this")(), re = ie.Symbol, yo = Object.prototype, Cu = yo.hasOwnProperty, vu = yo.toString, Te = re ? re.toStringTag : void 0;
function Au(e) {
  var a = Cu.call(e, Te), n = e[Te];
  try {
    e[Te] = void 0;
    var r = !0;
  } catch {
  }
  var c = vu.call(e);
  return r && (a ? e[Te] = n : delete e[Te]), c;
}
var Su = Object.prototype, Mu = Su.toString;
function Pu(e) {
  return Mu.call(e);
}
var Nu = "[object Null]", zu = "[object Undefined]", Qn = re ? re.toStringTag : void 0;
function ve(e) {
  return e == null ? e === void 0 ? zu : Nu : Qn && Qn in Object(e) ? Au(e) : Pu(e);
}
function pe(e) {
  return e != null && typeof e == "object";
}
var wu = "[object Symbol]";
function rn(e) {
  return typeof e == "symbol" || pe(e) && ve(e) == wu;
}
function bo(e, a) {
  for (var n = -1, r = e == null ? 0 : e.length, c = Array(r); ++n < r; )
    c[n] = a(e[n], n, e);
  return c;
}
var ue = Array.isArray, er = re ? re.prototype : void 0, ar = er ? er.toString : void 0;
function Do(e) {
  if (typeof e == "string")
    return e;
  if (ue(e))
    return bo(e, Do) + "";
  if (rn(e))
    return ar ? ar.call(e) : "";
  var a = e + "";
  return a == "0" && 1 / e == -1 / 0 ? "-0" : a;
}
function he(e) {
  var a = typeof e;
  return e != null && (a == "object" || a == "function");
}
function Co(e) {
  return e;
}
var Ru = "[object AsyncFunction]", Bu = "[object Function]", Tu = "[object GeneratorFunction]", Eu = "[object Proxy]";
function on(e) {
  if (!he(e))
    return !1;
  var a = ve(e);
  return a == Bu || a == Tu || a == Ru || a == Eu;
}
var la = ie["__core-js_shared__"], nr = function() {
  var e = /[^.]+$/.exec(la && la.keys && la.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Lu(e) {
  return !!nr && nr in e;
}
var Ou = Function.prototype, Gu = Ou.toString;
function Ae(e) {
  if (e != null) {
    try {
      return Gu.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Ku = /[\\^$.*+?()[\]{}|]/g, Uu = /^\[object .+?Constructor\]$/, Fu = Function.prototype, _u = Object.prototype, Iu = Fu.toString, Hu = _u.hasOwnProperty, Yu = RegExp(
  "^" + Iu.call(Hu).replace(Ku, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function $u(e) {
  if (!he(e) || Lu(e))
    return !1;
  var a = on(e) ? Yu : Uu;
  return a.test(Ae(e));
}
function ku(e, a) {
  return e?.[a];
}
function Se(e, a) {
  var n = ku(e, a);
  return $u(n) ? n : void 0;
}
var Ta = Se(ie, "WeakMap"), rr = Object.create, ju = /* @__PURE__ */ function() {
  function e() {
  }
  return function(a) {
    if (!he(a))
      return {};
    if (rr)
      return rr(a);
    e.prototype = a;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function Vu(e, a, n) {
  switch (n.length) {
    case 0:
      return e.call(a);
    case 1:
      return e.call(a, n[0]);
    case 2:
      return e.call(a, n[0], n[1]);
    case 3:
      return e.call(a, n[0], n[1], n[2]);
  }
  return e.apply(a, n);
}
function Zu(e, a) {
  var n = -1, r = e.length;
  for (a || (a = Array(r)); ++n < r; )
    a[n] = e[n];
  return a;
}
var xu = 800, Wu = 16, Ju = Date.now;
function Xu(e) {
  var a = 0, n = 0;
  return function() {
    var r = Ju(), c = Wu - (r - n);
    if (n = r, c > 0) {
      if (++a >= xu)
        return arguments[0];
    } else
      a = 0;
    return e.apply(void 0, arguments);
  };
}
function qu(e) {
  return function() {
    return e;
  };
}
var Ve = function() {
  try {
    var e = Se(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Qu = Ve ? function(e, a) {
  return Ve(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: qu(a),
    writable: !0
  });
} : Co, vo = Xu(Qu);
function ec(e, a) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && a(e[n], n, e) !== !1; )
    ;
  return e;
}
var ac = 9007199254740991, nc = /^(?:0|[1-9]\d*)$/;
function Ao(e, a) {
  var n = typeof e;
  return a = a ?? ac, !!a && (n == "number" || n != "symbol" && nc.test(e)) && e > -1 && e % 1 == 0 && e < a;
}
function tn(e, a, n) {
  a == "__proto__" && Ve ? Ve(e, a, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[a] = n;
}
function aa(e, a) {
  return e === a || e !== e && a !== a;
}
var rc = Object.prototype, oc = rc.hasOwnProperty;
function So(e, a, n) {
  var r = e[a];
  (!(oc.call(e, a) && aa(r, n)) || n === void 0 && !(a in e)) && tn(e, a, n);
}
function Mo(e, a, n, r) {
  var c = !n;
  n || (n = {});
  for (var d = -1, u = a.length; ++d < u; ) {
    var s = a[d], g = void 0;
    g === void 0 && (g = e[s]), c ? tn(n, s, g) : So(n, s, g);
  }
  return n;
}
var or = Math.max;
function Po(e, a, n) {
  return a = or(a === void 0 ? e.length - 1 : a, 0), function() {
    for (var r = arguments, c = -1, d = or(r.length - a, 0), u = Array(d); ++c < d; )
      u[c] = r[a + c];
    c = -1;
    for (var s = Array(a + 1); ++c < a; )
      s[c] = r[c];
    return s[a] = n(u), Vu(e, this, s);
  };
}
function ic(e, a) {
  return vo(Po(e, a, Co), e + "");
}
var tc = 9007199254740991;
function No(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= tc;
}
function sn(e) {
  return e != null && No(e.length) && !on(e);
}
function sc(e, a, n) {
  if (!he(n))
    return !1;
  var r = typeof a;
  return (r == "number" ? sn(n) && Ao(a, n.length) : r == "string" && a in n) ? aa(n[a], e) : !1;
}
function lc(e) {
  return ic(function(a, n) {
    var r = -1, c = n.length, d = c > 1 ? n[c - 1] : void 0, u = c > 2 ? n[2] : void 0;
    for (d = e.length > 3 && typeof d == "function" ? (c--, d) : void 0, u && sc(n[0], n[1], u) && (d = c < 3 ? void 0 : d, c = 1), a = Object(a); ++r < c; ) {
      var s = n[r];
      s && e(a, s, r, d);
    }
    return a;
  });
}
var uc = Object.prototype;
function zo(e) {
  var a = e && e.constructor, n = typeof a == "function" && a.prototype || uc;
  return e === n;
}
function cc(e, a) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = a(n);
  return r;
}
var dc = "[object Arguments]";
function ir(e) {
  return pe(e) && ve(e) == dc;
}
var wo = Object.prototype, gc = wo.hasOwnProperty, mc = wo.propertyIsEnumerable, Ze = ir(/* @__PURE__ */ function() {
  return arguments;
}()) ? ir : function(e) {
  return pe(e) && gc.call(e, "callee") && !mc.call(e, "callee");
};
function pc() {
  return !1;
}
var Ro = typeof exports == "object" && exports && !exports.nodeType && exports, tr = Ro && typeof module == "object" && module && !module.nodeType && module, hc = tr && tr.exports === Ro, sr = hc ? ie.Buffer : void 0, fc = sr ? sr.isBuffer : void 0, ln = fc || pc, yc = "[object Arguments]", bc = "[object Array]", Dc = "[object Boolean]", Cc = "[object Date]", vc = "[object Error]", Ac = "[object Function]", Sc = "[object Map]", Mc = "[object Number]", Pc = "[object Object]", Nc = "[object RegExp]", zc = "[object Set]", wc = "[object String]", Rc = "[object WeakMap]", Bc = "[object ArrayBuffer]", Tc = "[object DataView]", Ec = "[object Float32Array]", Lc = "[object Float64Array]", Oc = "[object Int8Array]", Gc = "[object Int16Array]", Kc = "[object Int32Array]", Uc = "[object Uint8Array]", Fc = "[object Uint8ClampedArray]", _c = "[object Uint16Array]", Ic = "[object Uint32Array]", j = {};
j[Ec] = j[Lc] = j[Oc] = j[Gc] = j[Kc] = j[Uc] = j[Fc] = j[_c] = j[Ic] = !0;
j[yc] = j[bc] = j[Bc] = j[Dc] = j[Tc] = j[Cc] = j[vc] = j[Ac] = j[Sc] = j[Mc] = j[Pc] = j[Nc] = j[zc] = j[wc] = j[Rc] = !1;
function Hc(e) {
  return pe(e) && No(e.length) && !!j[ve(e)];
}
function un(e) {
  return function(a) {
    return e(a);
  };
}
var Bo = typeof exports == "object" && exports && !exports.nodeType && exports, Oe = Bo && typeof module == "object" && module && !module.nodeType && module, Yc = Oe && Oe.exports === Bo, ua = Yc && fo.process, Pe = function() {
  try {
    var e = Oe && Oe.require && Oe.require("util").types;
    return e || ua && ua.binding && ua.binding("util");
  } catch {
  }
}(), lr = Pe && Pe.isTypedArray, To = lr ? un(lr) : Hc;
function $c(e, a) {
  var n = ue(e), r = !n && Ze(e), c = !n && !r && ln(e), d = !n && !r && !c && To(e), u = n || r || c || d, s = u ? cc(e.length, String) : [], g = s.length;
  for (var f in e)
    u && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    c && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    d && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    Ao(f, g)) || s.push(f);
  return s;
}
function kc(e, a) {
  return function(n) {
    return e(a(n));
  };
}
function jc(e) {
  var a = [];
  if (e != null)
    for (var n in Object(e))
      a.push(n);
  return a;
}
var Vc = Object.prototype, Zc = Vc.hasOwnProperty;
function xc(e) {
  if (!he(e))
    return jc(e);
  var a = zo(e), n = [];
  for (var r in e)
    r == "constructor" && (a || !Zc.call(e, r)) || n.push(r);
  return n;
}
function cn(e) {
  return sn(e) ? $c(e) : xc(e);
}
var Wc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Jc = /^\w*$/;
function Xc(e, a) {
  if (ue(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || rn(e) ? !0 : Jc.test(e) || !Wc.test(e) || a != null && e in Object(a);
}
var Ke = Se(Object, "create");
function qc() {
  this.__data__ = Ke ? Ke(null) : {}, this.size = 0;
}
function Qc(e) {
  var a = this.has(e) && delete this.__data__[e];
  return this.size -= a ? 1 : 0, a;
}
var ed = "__lodash_hash_undefined__", ad = Object.prototype, nd = ad.hasOwnProperty;
function rd(e) {
  var a = this.__data__;
  if (Ke) {
    var n = a[e];
    return n === ed ? void 0 : n;
  }
  return nd.call(a, e) ? a[e] : void 0;
}
var od = Object.prototype, id = od.hasOwnProperty;
function td(e) {
  var a = this.__data__;
  return Ke ? a[e] !== void 0 : id.call(a, e);
}
var sd = "__lodash_hash_undefined__";
function ld(e, a) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Ke && a === void 0 ? sd : a, this;
}
function De(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
De.prototype.clear = qc;
De.prototype.delete = Qc;
De.prototype.get = rd;
De.prototype.has = td;
De.prototype.set = ld;
function ud() {
  this.__data__ = [], this.size = 0;
}
function na(e, a) {
  for (var n = e.length; n--; )
    if (aa(e[n][0], a))
      return n;
  return -1;
}
var cd = Array.prototype, dd = cd.splice;
function gd(e) {
  var a = this.__data__, n = na(a, e);
  if (n < 0)
    return !1;
  var r = a.length - 1;
  return n == r ? a.pop() : dd.call(a, n, 1), --this.size, !0;
}
function md(e) {
  var a = this.__data__, n = na(a, e);
  return n < 0 ? void 0 : a[n][1];
}
function pd(e) {
  return na(this.__data__, e) > -1;
}
function hd(e, a) {
  var n = this.__data__, r = na(n, e);
  return r < 0 ? (++this.size, n.push([e, a])) : n[r][1] = a, this;
}
function me(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
me.prototype.clear = ud;
me.prototype.delete = gd;
me.prototype.get = md;
me.prototype.has = pd;
me.prototype.set = hd;
var Ue = Se(ie, "Map");
function fd() {
  this.size = 0, this.__data__ = {
    hash: new De(),
    map: new (Ue || me)(),
    string: new De()
  };
}
function yd(e) {
  var a = typeof e;
  return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? e !== "__proto__" : e === null;
}
function ra(e, a) {
  var n = e.__data__;
  return yd(a) ? n[typeof a == "string" ? "string" : "hash"] : n.map;
}
function bd(e) {
  var a = ra(this, e).delete(e);
  return this.size -= a ? 1 : 0, a;
}
function Dd(e) {
  return ra(this, e).get(e);
}
function Cd(e) {
  return ra(this, e).has(e);
}
function vd(e, a) {
  var n = ra(this, e), r = n.size;
  return n.set(e, a), this.size += n.size == r ? 0 : 1, this;
}
function fe(e) {
  var a = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++a < n; ) {
    var r = e[a];
    this.set(r[0], r[1]);
  }
}
fe.prototype.clear = fd;
fe.prototype.delete = bd;
fe.prototype.get = Dd;
fe.prototype.has = Cd;
fe.prototype.set = vd;
var Ad = "Expected a function";
function dn(e, a) {
  if (typeof e != "function" || a != null && typeof a != "function")
    throw new TypeError(Ad);
  var n = function() {
    var r = arguments, c = a ? a.apply(this, r) : r[0], d = n.cache;
    if (d.has(c))
      return d.get(c);
    var u = e.apply(this, r);
    return n.cache = d.set(c, u) || d, u;
  };
  return n.cache = new (dn.Cache || fe)(), n;
}
dn.Cache = fe;
var Sd = 500;
function Md(e) {
  var a = dn(e, function(r) {
    return n.size === Sd && n.clear(), r;
  }), n = a.cache;
  return a;
}
var Pd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Nd = /\\(\\)?/g, zd = Md(function(e) {
  var a = [];
  return e.charCodeAt(0) === 46 && a.push(""), e.replace(Pd, function(n, r, c, d) {
    a.push(c ? d.replace(Nd, "$1") : r || n);
  }), a;
});
function wd(e) {
  return e == null ? "" : Do(e);
}
function gn(e, a) {
  return ue(e) ? e : Xc(e, a) ? [e] : zd(wd(e));
}
function Eo(e) {
  if (typeof e == "string" || rn(e))
    return e;
  var a = e + "";
  return a == "0" && 1 / e == -1 / 0 ? "-0" : a;
}
function Rd(e, a) {
  a = gn(a, e);
  for (var n = 0, r = a.length; e != null && n < r; )
    e = e[Eo(a[n++])];
  return n && n == r ? e : void 0;
}
function mn(e, a) {
  for (var n = -1, r = a.length, c = e.length; ++n < r; )
    e[c + n] = a[n];
  return e;
}
var ur = re ? re.isConcatSpreadable : void 0;
function Bd(e) {
  return ue(e) || Ze(e) || !!(ur && e && e[ur]);
}
function Td(e, a, n, r, c) {
  var d = -1, u = e.length;
  for (n || (n = Bd), c || (c = []); ++d < u; ) {
    var s = e[d];
    n(s) ? mn(c, s) : c[c.length] = s;
  }
  return c;
}
function Ed(e) {
  var a = e == null ? 0 : e.length;
  return a ? Td(e) : [];
}
function Ld(e) {
  return vo(Po(e, void 0, Ed), e + "");
}
var pn = kc(Object.getPrototypeOf, Object), Od = "[object Object]", Gd = Function.prototype, Kd = Object.prototype, Lo = Gd.toString, Ud = Kd.hasOwnProperty, Fd = Lo.call(Object);
function Oo(e) {
  if (!pe(e) || ve(e) != Od)
    return !1;
  var a = pn(e);
  if (a === null)
    return !0;
  var n = Ud.call(a, "constructor") && a.constructor;
  return typeof n == "function" && n instanceof n && Lo.call(n) == Fd;
}
function _d(e, a, n) {
  var r = -1, c = e.length;
  a < 0 && (a = -a > c ? 0 : c + a), n = n > c ? c : n, n < 0 && (n += c), c = a > n ? 0 : n - a >>> 0, a >>>= 0;
  for (var d = Array(c); ++r < c; )
    d[r] = e[r + a];
  return d;
}
function Id() {
  this.__data__ = new me(), this.size = 0;
}
function Hd(e) {
  var a = this.__data__, n = a.delete(e);
  return this.size = a.size, n;
}
function Yd(e) {
  return this.__data__.get(e);
}
function $d(e) {
  return this.__data__.has(e);
}
var kd = 200;
function jd(e, a) {
  var n = this.__data__;
  if (n instanceof me) {
    var r = n.__data__;
    if (!Ue || r.length < kd - 1)
      return r.push([e, a]), this.size = ++n.size, this;
    n = this.__data__ = new fe(r);
  }
  return n.set(e, a), this.size = n.size, this;
}
function Me(e) {
  var a = this.__data__ = new me(e);
  this.size = a.size;
}
Me.prototype.clear = Id;
Me.prototype.delete = Hd;
Me.prototype.get = Yd;
Me.prototype.has = $d;
Me.prototype.set = jd;
var Go = typeof exports == "object" && exports && !exports.nodeType && exports, cr = Go && typeof module == "object" && module && !module.nodeType && module, Vd = cr && cr.exports === Go, dr = Vd ? ie.Buffer : void 0, gr = dr ? dr.allocUnsafe : void 0;
function Ko(e, a) {
  if (a)
    return e.slice();
  var n = e.length, r = gr ? gr(n) : new e.constructor(n);
  return e.copy(r), r;
}
function Zd(e, a) {
  for (var n = -1, r = e == null ? 0 : e.length, c = 0, d = []; ++n < r; ) {
    var u = e[n];
    a(u, n, e) && (d[c++] = u);
  }
  return d;
}
function Uo() {
  return [];
}
var xd = Object.prototype, Wd = xd.propertyIsEnumerable, mr = Object.getOwnPropertySymbols, Jd = mr ? function(e) {
  return e == null ? [] : (e = Object(e), Zd(mr(e), function(a) {
    return Wd.call(e, a);
  }));
} : Uo, Xd = Object.getOwnPropertySymbols, qd = Xd ? function(e) {
  for (var a = []; e; )
    mn(a, Jd(e)), e = pn(e);
  return a;
} : Uo;
function Qd(e, a, n) {
  var r = a(e);
  return ue(e) ? r : mn(r, n(e));
}
function Fo(e) {
  return Qd(e, cn, qd);
}
var Ea = Se(ie, "DataView"), La = Se(ie, "Promise"), Oa = Se(ie, "Set"), pr = "[object Map]", eg = "[object Object]", hr = "[object Promise]", fr = "[object Set]", yr = "[object WeakMap]", br = "[object DataView]", ag = Ae(Ea), ng = Ae(Ue), rg = Ae(La), og = Ae(Oa), ig = Ae(Ta), se = ve;
(Ea && se(new Ea(new ArrayBuffer(1))) != br || Ue && se(new Ue()) != pr || La && se(La.resolve()) != hr || Oa && se(new Oa()) != fr || Ta && se(new Ta()) != yr) && (se = function(e) {
  var a = ve(e), n = a == eg ? e.constructor : void 0, r = n ? Ae(n) : "";
  if (r)
    switch (r) {
      case ag:
        return br;
      case ng:
        return pr;
      case rg:
        return hr;
      case og:
        return fr;
      case ig:
        return yr;
    }
  return a;
});
var tg = Object.prototype, sg = tg.hasOwnProperty;
function lg(e) {
  var a = e.length, n = new e.constructor(a);
  return a && typeof e[0] == "string" && sg.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var Dr = ie.Uint8Array;
function hn(e) {
  var a = new e.constructor(e.byteLength);
  return new Dr(a).set(new Dr(e)), a;
}
function ug(e, a) {
  var n = hn(e.buffer);
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var cg = /\w*$/;
function dg(e) {
  var a = new e.constructor(e.source, cg.exec(e));
  return a.lastIndex = e.lastIndex, a;
}
var Cr = re ? re.prototype : void 0, vr = Cr ? Cr.valueOf : void 0;
function gg(e) {
  return vr ? Object(vr.call(e)) : {};
}
function _o(e, a) {
  var n = a ? hn(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var mg = "[object Boolean]", pg = "[object Date]", hg = "[object Map]", fg = "[object Number]", yg = "[object RegExp]", bg = "[object Set]", Dg = "[object String]", Cg = "[object Symbol]", vg = "[object ArrayBuffer]", Ag = "[object DataView]", Sg = "[object Float32Array]", Mg = "[object Float64Array]", Pg = "[object Int8Array]", Ng = "[object Int16Array]", zg = "[object Int32Array]", wg = "[object Uint8Array]", Rg = "[object Uint8ClampedArray]", Bg = "[object Uint16Array]", Tg = "[object Uint32Array]";
function Eg(e, a, n) {
  var r = e.constructor;
  switch (a) {
    case vg:
      return hn(e);
    case mg:
    case pg:
      return new r(+e);
    case Ag:
      return ug(e);
    case Sg:
    case Mg:
    case Pg:
    case Ng:
    case zg:
    case wg:
    case Rg:
    case Bg:
    case Tg:
      return _o(e, n);
    case hg:
      return new r();
    case fg:
    case Dg:
      return new r(e);
    case yg:
      return dg(e);
    case bg:
      return new r();
    case Cg:
      return gg(e);
  }
}
function Lg(e) {
  return typeof e.constructor == "function" && !zo(e) ? ju(pn(e)) : {};
}
var Og = "[object Map]";
function Gg(e) {
  return pe(e) && se(e) == Og;
}
var Ar = Pe && Pe.isMap, Kg = Ar ? un(Ar) : Gg, Ug = "[object Set]";
function Fg(e) {
  return pe(e) && se(e) == Ug;
}
var Sr = Pe && Pe.isSet, _g = Sr ? un(Sr) : Fg, Ig = 1, Io = "[object Arguments]", Hg = "[object Array]", Yg = "[object Boolean]", $g = "[object Date]", kg = "[object Error]", Ho = "[object Function]", jg = "[object GeneratorFunction]", Vg = "[object Map]", Zg = "[object Number]", Yo = "[object Object]", xg = "[object RegExp]", Wg = "[object Set]", Jg = "[object String]", Xg = "[object Symbol]", qg = "[object WeakMap]", Qg = "[object ArrayBuffer]", em = "[object DataView]", am = "[object Float32Array]", nm = "[object Float64Array]", rm = "[object Int8Array]", om = "[object Int16Array]", im = "[object Int32Array]", tm = "[object Uint8Array]", sm = "[object Uint8ClampedArray]", lm = "[object Uint16Array]", um = "[object Uint32Array]", $ = {};
$[Io] = $[Hg] = $[Qg] = $[em] = $[Yg] = $[$g] = $[am] = $[nm] = $[rm] = $[om] = $[im] = $[Vg] = $[Zg] = $[Yo] = $[xg] = $[Wg] = $[Jg] = $[Xg] = $[tm] = $[sm] = $[lm] = $[um] = !0;
$[kg] = $[Ho] = $[qg] = !1;
function Ye(e, a, n, r, c, d) {
  var u, s = a & Ig;
  if (n && (u = c ? n(e, r, c, d) : n(e)), u !== void 0)
    return u;
  if (!he(e))
    return e;
  var g = ue(e);
  if (g)
    u = lg(e);
  else {
    var f = se(e), b = f == Ho || f == jg;
    if (ln(e))
      return Ko(e, s);
    if (f == Yo || f == Io || b && !c)
      u = {};
    else {
      if (!$[f])
        return c ? e : {};
      u = Eg(e, f, s);
    }
  }
  d || (d = new Me());
  var M = d.get(e);
  if (M)
    return M;
  d.set(e, u), _g(e) ? e.forEach(function(v) {
    u.add(Ye(v, a, n, v, e, d));
  }) : Kg(e) && e.forEach(function(v, m) {
    u.set(m, Ye(v, a, n, m, e, d));
  });
  var C = Fo, S = g ? void 0 : C(e);
  return ec(S || e, function(v, m) {
    S && (m = v, v = e[m]), So(u, m, Ye(v, a, n, m, e, d));
  }), u;
}
function cm(e) {
  return function(a, n, r) {
    for (var c = -1, d = Object(a), u = r(a), s = u.length; s--; ) {
      var g = u[++c];
      if (n(d[g], g, d) === !1)
        break;
    }
    return a;
  };
}
var dm = cm();
function Ga(e, a, n) {
  (n !== void 0 && !aa(e[a], n) || n === void 0 && !(a in e)) && tn(e, a, n);
}
function gm(e) {
  return pe(e) && sn(e);
}
function Ka(e, a) {
  if (!(a === "constructor" && typeof e[a] == "function") && a != "__proto__")
    return e[a];
}
function mm(e) {
  return Mo(e, cn(e));
}
function pm(e, a, n, r, c, d, u) {
  var s = Ka(e, n), g = Ka(a, n), f = u.get(g);
  if (f) {
    Ga(e, n, f);
    return;
  }
  var b = d ? d(s, g, n + "", e, a, u) : void 0, M = b === void 0;
  if (M) {
    var C = ue(g), S = !C && ln(g), v = !C && !S && To(g);
    b = g, C || S || v ? ue(s) ? b = s : gm(s) ? b = Zu(s) : S ? (M = !1, b = Ko(g, !0)) : v ? (M = !1, b = _o(g, !0)) : b = [] : Oo(g) || Ze(g) ? (b = s, Ze(s) ? b = mm(s) : (!he(s) || on(s)) && (b = Lg(g))) : M = !1;
  }
  M && (u.set(g, b), c(b, g, r, d, u), u.delete(g)), Ga(e, n, b);
}
function $o(e, a, n, r, c) {
  e !== a && dm(a, function(d, u) {
    if (c || (c = new Me()), he(d))
      pm(e, a, u, n, $o, r, c);
    else {
      var s = r ? r(Ka(e, u), d, u + "", e, a, c) : void 0;
      s === void 0 && (s = d), Ga(e, u, s);
    }
  }, cn);
}
function hm(e) {
  var a = e == null ? 0 : e.length;
  return a ? e[a - 1] : void 0;
}
function fm(e, a) {
  return a.length < 2 ? e : Rd(e, _d(a, 0, -1));
}
var Mr = lc(function(e, a, n) {
  $o(e, a, n);
});
function ym(e, a) {
  return a = gn(a, e), e = fm(e, a), e == null || delete e[Eo(hm(a))];
}
function bm(e) {
  return Oo(e) ? void 0 : e;
}
var Dm = 1, Cm = 2, vm = 4, ce = Ld(function(e, a) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  a = bo(a, function(d) {
    return d = gn(d, e), r || (r = d.length > 1), d;
  }), Mo(e, Fo(e), n), r && (n = Ye(n, Dm | Cm | vm, bm));
  for (var c = a.length; c--; )
    ym(n, a[c]);
  return n;
}), Ua = { exports: {} }, Am = Ua.exports, Pr;
function ko() {
  return Pr || (Pr = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Am, function() {
      var n = 1e3, r = 6e4, c = 36e5, d = "millisecond", u = "second", s = "minute", g = "hour", f = "day", b = "week", M = "month", C = "quarter", S = "year", v = "date", m = "Invalid Date", P = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, L = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, T = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(A) {
        var o = ["th", "st", "nd", "rd"], l = A % 100;
        return "[" + A + (o[(l - 20) % 10] || o[l] || o[0]) + "]";
      } }, R = function(A, o, l) {
        var h = String(A);
        return !h || h.length >= o ? A : "" + Array(o + 1 - h.length).join(l) + A;
      }, K = { s: R, z: function(A) {
        var o = -A.utcOffset(), l = Math.abs(o), h = Math.floor(l / 60), p = l % 60;
        return (o <= 0 ? "+" : "-") + R(h, 2, "0") + ":" + R(p, 2, "0");
      }, m: function A(o, l) {
        if (o.date() < l.date()) return -A(l, o);
        var h = 12 * (l.year() - o.year()) + (l.month() - o.month()), p = o.clone().add(h, M), D = l - p < 0, y = o.clone().add(h + (D ? -1 : 1), M);
        return +(-(h + (l - p) / (D ? p - y : y - p)) || 0);
      }, a: function(A) {
        return A < 0 ? Math.ceil(A) || 0 : Math.floor(A);
      }, p: function(A) {
        return { M, y: S, w: b, d: f, D: v, h: g, m: s, s: u, ms: d, Q: C }[A] || String(A || "").toLowerCase().replace(/s$/, "");
      }, u: function(A) {
        return A === void 0;
      } }, z = "en", O = {};
      O[z] = T;
      var F = "$isDayjsObject", I = function(A) {
        return A instanceof Z || !(!A || !A[F]);
      }, _ = function A(o, l, h) {
        var p;
        if (!o) return z;
        if (typeof o == "string") {
          var D = o.toLowerCase();
          O[D] && (p = D), l && (O[D] = l, p = D);
          var y = o.split("-");
          if (!p && y.length > 1) return A(y[0]);
        } else {
          var w = o.name;
          O[w] = o, p = w;
        }
        return !h && p && (z = p), p || !h && z;
      }, B = function(A, o) {
        if (I(A)) return A.clone();
        var l = typeof o == "object" ? o : {};
        return l.date = A, l.args = arguments, new Z(l);
      }, N = K;
      N.l = _, N.i = I, N.w = function(A, o) {
        return B(A, { locale: o.$L, utc: o.$u, x: o.$x, $offset: o.$offset });
      };
      var Z = function() {
        function A(l) {
          this.$L = _(l.locale, null, !0), this.parse(l), this.$x = this.$x || l.x || {}, this[F] = !0;
        }
        var o = A.prototype;
        return o.parse = function(l) {
          this.$d = function(h) {
            var p = h.date, D = h.utc;
            if (p === null) return /* @__PURE__ */ new Date(NaN);
            if (N.u(p)) return /* @__PURE__ */ new Date();
            if (p instanceof Date) return new Date(p);
            if (typeof p == "string" && !/Z$/i.test(p)) {
              var y = p.match(P);
              if (y) {
                var w = y[2] - 1 || 0, G = (y[7] || "0").substring(0, 3);
                return D ? new Date(Date.UTC(y[1], w, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, G)) : new Date(y[1], w, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, G);
              }
            }
            return new Date(p);
          }(l), this.init();
        }, o.init = function() {
          var l = this.$d;
          this.$y = l.getFullYear(), this.$M = l.getMonth(), this.$D = l.getDate(), this.$W = l.getDay(), this.$H = l.getHours(), this.$m = l.getMinutes(), this.$s = l.getSeconds(), this.$ms = l.getMilliseconds();
        }, o.$utils = function() {
          return N;
        }, o.isValid = function() {
          return this.$d.toString() !== m;
        }, o.isSame = function(l, h) {
          var p = B(l);
          return this.startOf(h) <= p && p <= this.endOf(h);
        }, o.isAfter = function(l, h) {
          return B(l) < this.startOf(h);
        }, o.isBefore = function(l, h) {
          return this.endOf(h) < B(l);
        }, o.$g = function(l, h, p) {
          return N.u(l) ? this[h] : this.set(p, l);
        }, o.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, o.valueOf = function() {
          return this.$d.getTime();
        }, o.startOf = function(l, h) {
          var p = this, D = !!N.u(h) || h, y = N.p(l), w = function(X, Y) {
            var x = N.w(p.$u ? Date.UTC(p.$y, Y, X) : new Date(p.$y, Y, X), p);
            return D ? x : x.endOf(f);
          }, G = function(X, Y) {
            return N.w(p.toDate()[X].apply(p.toDate("s"), (D ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Y)), p);
          }, U = this.$W, E = this.$M, H = this.$D, q = "set" + (this.$u ? "UTC" : "");
          switch (y) {
            case S:
              return D ? w(1, 0) : w(31, 11);
            case M:
              return D ? w(1, E) : w(0, E + 1);
            case b:
              var J = this.$locale().weekStart || 0, Q = (U < J ? U + 7 : U) - J;
              return w(D ? H - Q : H + (6 - Q), E);
            case f:
            case v:
              return G(q + "Hours", 0);
            case g:
              return G(q + "Minutes", 1);
            case s:
              return G(q + "Seconds", 2);
            case u:
              return G(q + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, o.endOf = function(l) {
          return this.startOf(l, !1);
        }, o.$set = function(l, h) {
          var p, D = N.p(l), y = "set" + (this.$u ? "UTC" : ""), w = (p = {}, p[f] = y + "Date", p[v] = y + "Date", p[M] = y + "Month", p[S] = y + "FullYear", p[g] = y + "Hours", p[s] = y + "Minutes", p[u] = y + "Seconds", p[d] = y + "Milliseconds", p)[D], G = D === f ? this.$D + (h - this.$W) : h;
          if (D === M || D === S) {
            var U = this.clone().set(v, 1);
            U.$d[w](G), U.init(), this.$d = U.set(v, Math.min(this.$D, U.daysInMonth())).$d;
          } else w && this.$d[w](G);
          return this.init(), this;
        }, o.set = function(l, h) {
          return this.clone().$set(l, h);
        }, o.get = function(l) {
          return this[N.p(l)]();
        }, o.add = function(l, h) {
          var p, D = this;
          l = Number(l);
          var y = N.p(h), w = function(E) {
            var H = B(D);
            return N.w(H.date(H.date() + Math.round(E * l)), D);
          };
          if (y === M) return this.set(M, this.$M + l);
          if (y === S) return this.set(S, this.$y + l);
          if (y === f) return w(1);
          if (y === b) return w(7);
          var G = (p = {}, p[s] = r, p[g] = c, p[u] = n, p)[y] || 1, U = this.$d.getTime() + l * G;
          return N.w(U, this);
        }, o.subtract = function(l, h) {
          return this.add(-1 * l, h);
        }, o.format = function(l) {
          var h = this, p = this.$locale();
          if (!this.isValid()) return p.invalidDate || m;
          var D = l || "YYYY-MM-DDTHH:mm:ssZ", y = N.z(this), w = this.$H, G = this.$m, U = this.$M, E = p.weekdays, H = p.months, q = p.meridiem, J = function(Y, x, ee, te) {
            return Y && (Y[x] || Y(h, D)) || ee[x].slice(0, te);
          }, Q = function(Y) {
            return N.s(w % 12 || 12, Y, "0");
          }, X = q || function(Y, x, ee) {
            var te = Y < 12 ? "AM" : "PM";
            return ee ? te.toLowerCase() : te;
          };
          return D.replace(L, function(Y, x) {
            return x || function(ee) {
              switch (ee) {
                case "YY":
                  return String(h.$y).slice(-2);
                case "YYYY":
                  return N.s(h.$y, 4, "0");
                case "M":
                  return U + 1;
                case "MM":
                  return N.s(U + 1, 2, "0");
                case "MMM":
                  return J(p.monthsShort, U, H, 3);
                case "MMMM":
                  return J(H, U);
                case "D":
                  return h.$D;
                case "DD":
                  return N.s(h.$D, 2, "0");
                case "d":
                  return String(h.$W);
                case "dd":
                  return J(p.weekdaysMin, h.$W, E, 2);
                case "ddd":
                  return J(p.weekdaysShort, h.$W, E, 3);
                case "dddd":
                  return E[h.$W];
                case "H":
                  return String(w);
                case "HH":
                  return N.s(w, 2, "0");
                case "h":
                  return Q(1);
                case "hh":
                  return Q(2);
                case "a":
                  return X(w, G, !0);
                case "A":
                  return X(w, G, !1);
                case "m":
                  return String(G);
                case "mm":
                  return N.s(G, 2, "0");
                case "s":
                  return String(h.$s);
                case "ss":
                  return N.s(h.$s, 2, "0");
                case "SSS":
                  return N.s(h.$ms, 3, "0");
                case "Z":
                  return y;
              }
              return null;
            }(Y) || y.replace(":", "");
          });
        }, o.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, o.diff = function(l, h, p) {
          var D, y = this, w = N.p(h), G = B(l), U = (G.utcOffset() - this.utcOffset()) * r, E = this - G, H = function() {
            return N.m(y, G);
          };
          switch (w) {
            case S:
              D = H() / 12;
              break;
            case M:
              D = H();
              break;
            case C:
              D = H() / 3;
              break;
            case b:
              D = (E - U) / 6048e5;
              break;
            case f:
              D = (E - U) / 864e5;
              break;
            case g:
              D = E / c;
              break;
            case s:
              D = E / r;
              break;
            case u:
              D = E / n;
              break;
            default:
              D = E;
          }
          return p ? D : N.a(D);
        }, o.daysInMonth = function() {
          return this.endOf(M).$D;
        }, o.$locale = function() {
          return O[this.$L];
        }, o.locale = function(l, h) {
          if (!l) return this.$L;
          var p = this.clone(), D = _(l, h, !0);
          return D && (p.$L = D), p;
        }, o.clone = function() {
          return N.w(this.$d, this);
        }, o.toDate = function() {
          return new Date(this.valueOf());
        }, o.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, o.toISOString = function() {
          return this.$d.toISOString();
        }, o.toString = function() {
          return this.$d.toUTCString();
        }, A;
      }(), ye = Z.prototype;
      return B.prototype = ye, [["$ms", d], ["$s", u], ["$m", s], ["$H", g], ["$W", f], ["$M", M], ["$y", S], ["$D", v]].forEach(function(A) {
        ye[A[1]] = function(o) {
          return this.$g(o, A[0], A[1]);
        };
      }), B.extend = function(A, o) {
        return A.$i || (A(o, Z, B), A.$i = !0), B;
      }, B.locale = _, B.isDayjs = I, B.unix = function(A) {
        return B(1e3 * A);
      }, B.en = O[z], B.Ls = O, B.p = {}, B;
    });
  }(Ua)), Ua.exports;
}
var Sm = ko();
const W = /* @__PURE__ */ ae(Sm);
var Fa = { exports: {} }, Mm = Fa.exports, Nr;
function Pm() {
  return Nr || (Nr = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Mm, function() {
      return function(n, r) {
        var c = r.prototype, d = c.format;
        c.format = function(u) {
          var s = this, g = this.$locale();
          if (!this.isValid()) return d.bind(this)(u);
          var f = this.$utils(), b = (u || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(M) {
            switch (M) {
              case "Q":
                return Math.ceil((s.$M + 1) / 3);
              case "Do":
                return g.ordinal(s.$D);
              case "gggg":
                return s.weekYear();
              case "GGGG":
                return s.isoWeekYear();
              case "wo":
                return g.ordinal(s.week(), "W");
              case "w":
              case "ww":
                return f.s(s.week(), M === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return f.s(s.isoWeek(), M === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return f.s(String(s.$H === 0 ? 24 : s.$H), M === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(s.$d.getTime() / 1e3);
              case "x":
                return s.$d.getTime();
              case "z":
                return "[" + s.offsetName() + "]";
              case "zzz":
                return "[" + s.offsetName("long") + "]";
              default:
                return M;
            }
          });
          return d.bind(this)(b);
        };
      };
    });
  }(Fa)), Fa.exports;
}
var Nm = Pm();
const zm = /* @__PURE__ */ ae(Nm);
var _a = { exports: {} }, wm = _a.exports, zr;
function Rm() {
  return zr || (zr = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(wm, function() {
      return function(n, r, c) {
        r.prototype.isBetween = function(d, u, s, g) {
          var f = c(d), b = c(u), M = (g = g || "()")[0] === "(", C = g[1] === ")";
          return (M ? this.isAfter(f, s) : !this.isBefore(f, s)) && (C ? this.isBefore(b, s) : !this.isAfter(b, s)) || (M ? this.isBefore(f, s) : !this.isAfter(f, s)) && (C ? this.isAfter(b, s) : !this.isBefore(b, s));
        };
      };
    });
  }(_a)), _a.exports;
}
var Bm = Rm();
const Tm = /* @__PURE__ */ ae(Bm);
var Ia = { exports: {} }, Em = Ia.exports, wr;
function Lm() {
  return wr || (wr = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Em, function() {
      return function(n, r) {
        r.prototype.isSameOrAfter = function(c, d) {
          return this.isSame(c, d) || this.isAfter(c, d);
        };
      };
    });
  }(Ia)), Ia.exports;
}
var Om = Lm();
const Gm = /* @__PURE__ */ ae(Om);
var Ha = { exports: {} }, Km = Ha.exports, Rr;
function Um() {
  return Rr || (Rr = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Km, function() {
      return function(n, r) {
        r.prototype.isSameOrBefore = function(c, d) {
          return this.isSame(c, d) || this.isBefore(c, d);
        };
      };
    });
  }(Ha)), Ha.exports;
}
var Fm = Um();
const _m = /* @__PURE__ */ ae(Fm);
var Ya = { exports: {} }, Im = Ya.exports, Br;
function Hm() {
  return Br || (Br = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(Im, function() {
      var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
      return function(r, c, d) {
        var u = c.prototype, s = u.format;
        d.en.formats = n, u.format = function(g) {
          g === void 0 && (g = "YYYY-MM-DDTHH:mm:ssZ");
          var f = this.$locale().formats, b = function(M, C) {
            return M.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(S, v, m) {
              var P = m && m.toUpperCase();
              return v || C[m] || n[m] || C[P].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(L, T, R) {
                return T || R.slice(1);
              });
            });
          }(g, f === void 0 ? {} : f);
          return s.call(this, b);
        };
      };
    });
  }(Ya)), Ya.exports;
}
var Ym = Hm();
const $m = /* @__PURE__ */ ae(Ym);
var $a = { exports: {} }, km = $a.exports, Tr;
function jm() {
  return Tr || (Tr = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(km, function() {
      return function(n, r, c) {
        var d = function(u, s) {
          if (!s || !s.length || s.length === 1 && !s[0] || s.length === 1 && Array.isArray(s[0]) && !s[0].length) return null;
          var g;
          s.length === 1 && s[0].length > 0 && (s = s[0]), g = (s = s.filter(function(b) {
            return b;
          }))[0];
          for (var f = 1; f < s.length; f += 1) s[f].isValid() && !s[f][u](g) || (g = s[f]);
          return g;
        };
        c.max = function() {
          var u = [].slice.call(arguments, 0);
          return d("isAfter", u);
        }, c.min = function() {
          var u = [].slice.call(arguments, 0);
          return d("isBefore", u);
        };
      };
    });
  }($a)), $a.exports;
}
var Vm = jm();
const Zm = /* @__PURE__ */ ae(Vm);
var ka = { exports: {} }, xm = ka.exports, Er;
function Wm() {
  return Er || (Er = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(xm, function() {
      return function(n, r, c) {
        n = n || {};
        var d = r.prototype, u = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function s(f, b, M, C) {
          return d.fromToBase(f, b, M, C);
        }
        c.en.relativeTime = u, d.fromToBase = function(f, b, M, C, S) {
          for (var v, m, P, L = M.$locale().relativeTime || u, T = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], R = T.length, K = 0; K < R; K += 1) {
            var z = T[K];
            z.d && (v = C ? c(f).diff(M, z.d, !0) : M.diff(f, z.d, !0));
            var O = (n.rounding || Math.round)(Math.abs(v));
            if (P = v > 0, O <= z.r || !z.r) {
              O <= 1 && K > 0 && (z = T[K - 1]);
              var F = L[z.l];
              S && (O = S("" + O)), m = typeof F == "string" ? F.replace("%d", O) : F(O, b, z.l, P);
              break;
            }
          }
          if (b) return m;
          var I = P ? L.future : L.past;
          return typeof I == "function" ? I(m) : I.replace("%s", m);
        }, d.to = function(f, b) {
          return s(f, b, this, !0);
        }, d.from = function(f, b) {
          return s(f, b, this);
        };
        var g = function(f) {
          return f.$u ? c.utc() : c();
        };
        d.toNow = function(f) {
          return this.to(g(this), f);
        }, d.fromNow = function(f) {
          return this.from(g(this), f);
        };
      };
    });
  }(ka)), ka.exports;
}
var Jm = Wm();
const Xm = /* @__PURE__ */ ae(Jm);
var ja = { exports: {} }, qm = ja.exports, Lr;
function Qm() {
  return Lr || (Lr = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(qm, function() {
      var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, r = {};
      return function(c, d, u) {
        var s, g = function(C, S, v) {
          v === void 0 && (v = {});
          var m = new Date(C), P = function(L, T) {
            T === void 0 && (T = {});
            var R = T.timeZoneName || "short", K = L + "|" + R, z = r[K];
            return z || (z = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: L, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: R }), r[K] = z), z;
          }(S, v);
          return P.formatToParts(m);
        }, f = function(C, S) {
          for (var v = g(C, S), m = [], P = 0; P < v.length; P += 1) {
            var L = v[P], T = L.type, R = L.value, K = n[T];
            K >= 0 && (m[K] = parseInt(R, 10));
          }
          var z = m[3], O = z === 24 ? 0 : z, F = m[0] + "-" + m[1] + "-" + m[2] + " " + O + ":" + m[4] + ":" + m[5] + ":000", I = +C;
          return (u.utc(F).valueOf() - (I -= I % 1e3)) / 6e4;
        }, b = d.prototype;
        b.tz = function(C, S) {
          C === void 0 && (C = s);
          var v, m = this.utcOffset(), P = this.toDate(), L = P.toLocaleString("en-US", { timeZone: C }), T = Math.round((P - new Date(L)) / 1e3 / 60), R = 15 * -Math.round(P.getTimezoneOffset() / 15) - T;
          if (!Number(R)) v = this.utcOffset(0, S);
          else if (v = u(L, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(R, !0), S) {
            var K = v.utcOffset();
            v = v.add(m - K, "minute");
          }
          return v.$x.$timezone = C, v;
        }, b.offsetName = function(C) {
          var S = this.$x.$timezone || u.tz.guess(), v = g(this.valueOf(), S, { timeZoneName: C }).find(function(m) {
            return m.type.toLowerCase() === "timezonename";
          });
          return v && v.value;
        };
        var M = b.startOf;
        b.startOf = function(C, S) {
          if (!this.$x || !this.$x.$timezone) return M.call(this, C, S);
          var v = u(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return M.call(v, C, S).tz(this.$x.$timezone, !0);
        }, u.tz = function(C, S, v) {
          var m = v && S, P = v || S || s, L = f(+u(), P);
          if (typeof C != "string") return u(C).tz(P);
          var T = function(O, F, I) {
            var _ = O - 60 * F * 1e3, B = f(_, I);
            if (F === B) return [_, F];
            var N = f(_ -= 60 * (B - F) * 1e3, I);
            return B === N ? [_, B] : [O - 60 * Math.min(B, N) * 1e3, Math.max(B, N)];
          }(u.utc(C, m).valueOf(), L, P), R = T[0], K = T[1], z = u(R).utcOffset(K);
          return z.$x.$timezone = P, z;
        }, u.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, u.tz.setDefault = function(C) {
          s = C;
        };
      };
    });
  }(ja)), ja.exports;
}
var ep = Qm();
const ap = /* @__PURE__ */ ae(ep);
var Va = { exports: {} }, np = Va.exports, Or;
function rp() {
  return Or || (Or = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(np, function() {
      var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, c = /([+-]|\d\d)/g;
      return function(d, u, s) {
        var g = u.prototype;
        s.utc = function(m) {
          var P = { date: m, utc: !0, args: arguments };
          return new u(P);
        }, g.utc = function(m) {
          var P = s(this.toDate(), { locale: this.$L, utc: !0 });
          return m ? P.add(this.utcOffset(), n) : P;
        }, g.local = function() {
          return s(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var f = g.parse;
        g.parse = function(m) {
          m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), f.call(this, m);
        };
        var b = g.init;
        g.init = function() {
          if (this.$u) {
            var m = this.$d;
            this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
          } else b.call(this);
        };
        var M = g.utcOffset;
        g.utcOffset = function(m, P) {
          var L = this.$utils().u;
          if (L(m)) return this.$u ? 0 : L(this.$offset) ? M.call(this) : this.$offset;
          if (typeof m == "string" && (m = function(z) {
            z === void 0 && (z = "");
            var O = z.match(r);
            if (!O) return null;
            var F = ("" + O[0]).match(c) || ["-", 0, 0], I = F[0], _ = 60 * +F[1] + +F[2];
            return _ === 0 ? 0 : I === "+" ? _ : -_;
          }(m), m === null)) return this;
          var T = Math.abs(m) <= 16 ? 60 * m : m, R = this;
          if (P) return R.$offset = T, R.$u = m === 0, R;
          if (m !== 0) {
            var K = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (R = this.local().add(T + K, n)).$offset = T, R.$x.$localOffset = K;
          } else R = this.utc();
          return R;
        };
        var C = g.format;
        g.format = function(m) {
          var P = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return C.call(this, P);
        }, g.valueOf = function() {
          var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * m;
        }, g.isUTC = function() {
          return !!this.$u;
        }, g.toISOString = function() {
          return this.toDate().toISOString();
        }, g.toString = function() {
          return this.toDate().toUTCString();
        };
        var S = g.toDate;
        g.toDate = function(m) {
          return m === "s" && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : S.call(this);
        };
        var v = g.diff;
        g.diff = function(m, P, L) {
          if (m && this.$u === m.$u) return v.call(this, m, P, L);
          var T = this.local(), R = s(m).local();
          return v.call(T, R, P, L);
        };
      };
    });
  }(Va)), Va.exports;
}
var op = rp();
const ip = /* @__PURE__ */ ae(op);
var Za = { exports: {} }, tp = Za.exports, Gr;
function sp() {
  return Gr || (Gr = 1, function(e, a) {
    (function(n, r) {
      e.exports = r(ko());
    })(tp, function(n) {
      function r(u) {
        return u && typeof u == "object" && "default" in u ? u : { default: u };
      }
      var c = r(n), d = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(u) {
        return "" + u + (u === 1 ? "er" : "");
      } };
      return c.default.locale(d, null, !0), d;
    });
  }(Za)), Za.exports;
}
sp();
var xa = { exports: {} }, lp = xa.exports, Kr;
function up() {
  return Kr || (Kr = 1, function(e, a) {
    (function(n, r) {
      e.exports = r();
    })(lp, function() {
      return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(n) {
        var r = ["th", "st", "nd", "rd"], c = n % 100;
        return "[" + n + (r[(c - 20) % 10] || r[c] || r[0]) + "]";
      } };
    });
  }(xa)), xa.exports;
}
up();
W.extend(zm);
W.extend(Tm);
W.extend(Gm);
W.extend(_m);
W.extend($m);
W.extend(Zm);
W.extend(Xm);
W.extend(ap);
W.extend(ip);
function Ur(e, a) {
  return a === void 0 ? Array.from({ length: e }, (n, r) => r) : Array.from({ length: a - e }, (n, r) => e + r);
}
const ne = W();
ne.format("YYYY-MM-DD HH:mm:ss"), `${ne.subtract(-1, "day").format("YYYY-MM-DD")}`, `${ne.subtract(-1, "day").format("YYYY-MM-DD")}`, `${ne.subtract(-2, "day").format("YYYY-MM-DD")}`, `${ne.subtract(-2, "day").format("YYYY-MM-DD")}`, `${ne.subtract(-3, "day").format("YYYY-MM-DD")}`, `${ne.subtract(-3, "day").format("YYYY-MM-DD")}`, `${ne.subtract(-7, "day").format("YYYY-MM-DD")}`, ne.subtract(-9, "day").format("YYYY-MM-DD"), `${ne.format("YYYY-MM-DD")}`;
i.EUR;
i.EUR, i.USD;
i.EUR;
i.EUR, i.USD;
const fn = {
  BookingDetails: !0
};
JSON.stringify(fn, null, 2);
function jo(e) {
  const a = typeof window < "u" && window;
  return !!(a && (/Chromatic/.test(a.navigator.userAgent) || /chromatic=true/.test(a.location.href)));
}
const Fr = jo() ? W("2050-01-01") : W(), Vo = {
  address: "",
  adultCount: 1,
  checkInDate: Fr.subtract(-4, "days").format("YYYY-MM-DD"),
  checkOutDate: Fr.subtract(-5, "days").format("YYYY-MM-DD"),
  children: null,
  hotelOfferRequestId: "",
  latitude: 48.8508305,
  longitude: 2.2844643,
  roomCount: 1,
  sourceMarket: lo.Fr
}, Zo = {
  address: {
    control: {
      type: "text"
    },
    description: `Search address.

When provided and successfully geocoded, this address is used as the center location for **Hotel Offers** search.

**Requirements:** must be a valid address string, e.g. "Paris, France", minimum length: 3 characters.,
`,
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  adultCount: {
    control: {
      type: "select"
    },
    description: '<span style="color: red;">Required.</span> Number of adult(s) requested',
    name: "adult-count",
    options: Ur(1, 90),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  checkInDate: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Check-in date formatted as ```YYYY-MM-DD```',
    name: "check-in-date",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  checkOutDate: {
    control: {
      type: "text"
    },
    description: '<span style="color: red;">Required.</span> Check-out date formatted as ```YYYY-MM-DD```',
    name: "check-out-date",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  children: {
    control: {
      type: "text"
    },
    description: "Comma-separated list of ages (0 to 17)",
    name: "children",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  hotelOfferRequestId: {
    control: {
      type: "text"
    },
    description: "id of a previously created **Hotel Offer Request**.<br />When provided, the combination of **adult-count/check-in-date/check-out-date/latitude/longitude** props takes precedence over any provided **hotel-offer-request-id** and a new **hotel-offer-request-id** will be created.",
    name: "hotel-offer-request-id",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  latitude: {
    control: { type: "number" },
    description: '<span style="color: red;">Required.</span> Search location latitude.',
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  longitude: {
    control: { type: "number" },
    description: '<span style="color: red;">Required.</span> Search location longitude.',
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  roomCount: {
    control: {
      type: "select"
    },
    description: "Number of room(s) requested",
    name: "room-count",
    options: Ur(1, 30),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  sourceMarket: {
    control: {
      type: "select"
    },
    description: `Nationality of the customer.

For sourcing availability within certain markets, a source market option may be used to get more accurate prices and to reduce booking errors.

You may use any valid ISO Alpha-2 country code, e.g. JP`,
    name: "source-market",
    options: Object.values(lo),
    table: {
      defaultValue: { summary: "undefined" }
    }
  }
};
var le = /* @__PURE__ */ ((e) => (e.DialogFullscreen = "DialogFullscreen", e.HotelDescriptionViewDialog = "HotelDescriptionViewDialog", e.HotelRoomOfferList = "HotelRoomOfferList", e.HotelRoomOffersViewDialog = "HotelRoomOffersViewDialog", e.RoomsDetails = "RoomsDetails", e))(le || {});
const xe = {
  DialogFullscreen: !0,
  HotelDescriptionViewDialog: !1,
  HotelRoomOfferList: !1,
  HotelRoomOffersViewDialog: !1,
  RoomsDetails: !0
}, oa = {
  FiltersBar: !0,
  HotelOfferSearchMenu: !1,
  TermsAndConditionsFooter: !0,
  HotelOfferItem: xe
}, xo = `<p>**DialogFullscreen**: Display the dialog in fullscreen mode (HotelDescriptionViewDialog + HotelRoomOffersViewDialog),</p>
<p>**HotelDescriptionViewDialog**: Display the hotel description dialog when clicking on the hotel name,</p>
<p>**HotelRoomOfferList**: Display the room offer list when clicking on the item (not applicable in some cases, e.g.: HotelOffersMap),</p>
<p>**HotelRoomOffersViewDialog**: Display the room offers dialog when clicking on the hotel name or on the room offer item,</p>
<p>**RoomDetails**: Display the room details on each Hotel Offer item</p>`, cp = {
  ...Vo,
  features: oa,
  height: "600px",
  hotelOfferRequestId: "",
  isLoadingBarEnabled: !0,
  limit: Ne
}, dp = `<p>**FiltersBar**: Display the filters bar at the top of the component,</p>
<p>**HotelOfferSearchMenu**: Display the search menu at the top of the component,</p>
<p>**TermsAndConditionsFooter**: Display the terms and conditions footer at the bottom of the component,</p>
<p><ins>**HotelOfferItem**:</ins></p>
<div style="padding-left: 20px">${xo}</div>`, gp = {
  ...Zo,
  features: {
    control: {
      type: "object"
    },
    description: `<p>This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it.</p> <p>***Available features***:</p> <div>${dp}</div>`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(oa, null, 4)
      }
    }
  },
  height: {
    control: {
      type: "text"
    },
    description: "Height of the hotel offer list component expressed in any valid CSS unit (px, %, em, rem, vh, vw, etc.)",
    name: "height",
    table: {
      defaultValue: { summary: "600px" }
    }
  },
  hotelOfferRequestId: {
    control: {
      type: "text"
    },
    description: "id of a previously created **Hotel Offer Request**.<br />When provided, the combination of **adult-count/check-in-date/check-out-date/latitude/longitude** props takes precedence over any provided **hotel-offer-request-id** and a new **hotel-offer-request-id** will be created.",
    name: "hotel-offer-request-id",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  limit: {
    control: {
      type: "number"
    },
    description: "Limit the number of Hotel Offers returned. Limit can range between 1 and 100.",
    table: {
      defaultValue: { summary: Ne.toString() }
    }
  }
}, _e = {
  LocationInput: !0,
  SearchAreaButton: !0,
  HotelOfferItem: {
    ...xe,
    [le.HotelDescriptionViewDialog]: !1,
    [le.HotelRoomOffersViewDialog]: !1,
    [le.RoomsDetails]: !0
  }
}, mp = {
  ...Vo,
  features: _e,
  height: "500px",
  isLoadingBarEnabled: !0,
  limit: Ne,
  markers: [
    {
      icon: "tower-cell",
      latitude: 48.8584,
      longitude: 2.2945,
      pulse: !1,
      size: 80,
      tooltip: "La tour Eiffel"
    },
    {
      imgUrl: "https://via.placeholder.com/500",
      latitude: 48.8606,
      longitude: 2.3376
    },
    {
      latitude: 48.8421,
      longitude: 2.322
    }
  ],
  venue: {
    imgUrl: "https://via.placeholder.com/500",
    latitude: 48.8508305,
    longitude: 2.2844643,
    size: 70,
    tooltip: "Venue tooltip"
  }
}, pp = `<p>**FiltersMenu**: Display the filters bar at the top of the component,</p> <p>**LocationInput**: Display the location input at the top of the component,</p> <p>**SearchAreaButton**: Display the search area button at the top of the component,</p> <p><ins> **HotelOfferItem**:</ins></p> <div style="margin-left: 20px;">${xo}</div>`, hp = {
  ...Zo,
  features: {
    control: {
      type: "object"
    },
    description: `<p>This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it.</p> <p>***Available features***:</p> <div>${pp}</div>`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(_e, null, 2)
      }
    }
  },
  height: {
    control: {
      type: "text"
    },
    description: "Height of the map component. Can be any valid css size, e.g. `500px` or `100%`. If not specified, the map will take the full height of its container, if specified.",
    name: "height",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  limit: {
    control: {
      type: "number"
    },
    description: "Limit the number of Hotel Offers returned. Limit can range between 1 and 100.",
    table: {
      defaultValue: { summary: Ne.toString() }
    }
  },
  markers: {
    control: {
      type: "object"
    },
    description: "Array of markers if you want to highlight special places around the event. Required prop: <b>lat, lng</b>",
    table: {
      defaultValue: { summary: "[]" }
    }
  },
  venue: {
    control: {
      type: "object"
    },
    description: "Venue object to display a marker for the venue. Required prop: <b>lat, lng</b>",
    name: "venue",
    table: {
      defaultValue: { summary: "undefined" }
    }
  }
}, yn = {
  HotelSearchBar: !0,
  PreferencesMenu: !0,
  HotelOfferList: oa,
  HotelOffersMap: _e
};
({
  ...ce(cp, ["rounded"]),
  ...ce(mp, ["height"])
});
({
  ...ce(gp, ["limit", "rounded"]),
  ...ce(hp, ["height", "withFilters"]),
  features: JSON.stringify(yn, null, 2)
});
const Ie = {
  BookingDetails: !0
}, Wo = {
  adultCount: 2,
  bookingPolicyId: "df6f894b-201a-4dc2-b39e-5c8cc31068a0",
  checkInDate: W().subtract(-4, "days").format("YYYY-MM-DD"),
  checkOutDate: W().subtract(-5, "days").format("YYYY-MM-DD"),
  emailAddress: "john.doe@example.com",
  features: Ie,
  firstName: "John",
  hotelRoomOffer: void 0,
  lastName: "Doe",
  metadata: {},
  nationality: "FR",
  paymentMethods: je.CreditCard,
  phoneCountry: "FR",
  phoneNumber: "0102030405",
  roomCount: 1,
  salutation: so.Mr,
  specialRequests: ""
}, fp = "<p>**BookingDetails**: Display the booking details in the sidebar.</p>", Jo = {
  adultCount: {
    control: { type: "number" },
    description: '<span style="color: red;">Required.</span> Number of adults',
    name: "adult-count",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  bookingPolicyId: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Booking policy id',
    name: "booking-policy-id",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  emailAddress: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Email address',
    name: "email-address",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  features: {
    control: { type: "object" },
    description: `This object controls which features are enabled/disabled within the component. Set to true to enable a feature, false to disable it. <br /> ***Available features***: <br /> ${fp}`,
    name: "features",
    table: {
      defaultValue: {
        summary: JSON.stringify(Ie, null, 2)
      }
    }
  },
  firstName: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> First name',
    name: "first-name",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  lastName: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Last name',
    name: "last-name",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  metadata: {
    control: { type: "object" },
    description: 'If you want to attach some metadata of your choice to the booking (e.g.: a customer id or an order id from your system), you need to pass them as attributes of the component with the name starting with "metadata-". The component will build a "metadata" object based on those attributes that will be sent to the API.',
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  nationality: {
    control: { type: "select" },
    description: '<span style="color: red;">Required.</span> The status of being a legal citizen of a country',
    options: Object.keys(da),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  paymentMethods: {
    control: { type: "select" },
    description: `Specific payment methods used to setup the booking. If not provided, deposit account will be used. <br />**Available payment methods**:<pre>${Object.values(
      je
    ).map((e) => `<code><b>${e}</b></code>`).join(" ")}</pre>`,
    name: "payment-methods",
    options: Object.values(je),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  phoneCountry: {
    control: { type: "select" },
    description: '<span style="color: red;">Required.</span> Phone country',
    name: "phone-country",
    options: Object.keys(da),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  phoneNumber: {
    control: { type: "text" },
    description: '<span style="color: red;">Required.</span> Phone number',
    name: "phone-number",
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  salutation: {
    control: { type: "select" },
    description: "Salutation",
    options: Object.values(so),
    table: {
      defaultValue: { summary: "undefined" }
    }
  },
  specialRequests: {
    control: { type: "text" },
    description: "Special requests",
    name: "special-requests",
    table: {
      defaultValue: { summary: "undefined" }
    }
  }
}, Xo = {
  CreditCardPayment: fn,
  HotelOffersView: Mr(yn, {
    HotelOfferList: {
      HotelOfferItem: {
        ...xe,
        [le.HotelRoomOfferList]: !0,
        [le.HotelRoomOffersViewDialog]: !0,
        [le.RoomsDetails]: !0
      }
    },
    HotelOffersMap: Mr(_e, {
      HotelOfferItem: {
        ...xe,
        [le.HotelRoomOffersViewDialog]: !0,
        [le.RoomsDetails]: !0
      }
    })
  }),
  PrebookForm: Ie
};
({
  ...Wo
});
({
  ...Jo,
  features: JSON.stringify(Xo, null, 2)
});
const bn = {
  PreferencesMenu: !1
};
JSON.stringify(
  bn,
  null,
  2
);
const _r = jo() ? W("2050-01-01") : W();
_r.subtract(-4, "days").format("YYYY-MM-DD"), _r.subtract(-5, "days").format("YYYY-MM-DD");
Array.from({ length: 30 }, (e, a) => a + 1), Array.from({ length: 30 }, (e, a) => a + 1);
const Dn = {
  OnlyMatchingRoomCount: !1
};
JSON.stringify(
  Dn,
  null,
  2
);
const Cn = {
  HotelDescriptionView: bn,
  HotelRoomOfferList: Dn
};
JSON.stringify(
  Cn,
  null,
  2
);
const qo = {
  HotelRoomOffersView: Cn,
  PrebookForm: Ie
};
({
  ...ce(Wo, ["bookingId", "bookingPolicyId", "hotelRoomOffer"])
});
({
  ...ce(Jo, [
    "bookingId",
    "bookingPolicyId",
    "hotelRoomOffer"
  ]),
  features: JSON.stringify(
    qo,
    null,
    2
  )
});
var Qo = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e.Left = "left", e.Right = "right", e))(Qo || {});
const yp = {
  block: {
    default: !1,
    type: Boolean
  },
  color: {
    default: "secondary",
    type: String
  },
  compact: {
    default: !1,
    type: Boolean
  },
  direction: {
    default: "top",
    type: String
  }
};
Qo.Bottom;
const bp = {
  amount: { type: Number },
  currency: { type: String },
  loading: {
    default: !1,
    type: Boolean
  },
  token: { type: String },
  withTerms: {
    default: !1,
    type: Boolean
  }
}, Dp = {
  adultCount: {
    type: Number
  },
  checkInDate: {
    type: String
  },
  checkOutDate: {
    type: String
  },
  hotelRoomOffer: {
    type: [Object]
  }
}, Cp = {
  token: {
    type: String
  }
}, ei = {
  cancellationPolicies: {
    required: !0,
    type: [String, Array]
  },
  checkInDate: {
    required: !0,
    type: String
  },
  initialDate: {
    type: String
  },
  timezone: {
    required: !0,
    type: String
  }
}, vp = {
  ...ei,
  tagClasses: { type: String }
}, Ap = {
  amount: { type: Number },
  currency: { type: String },
  disabled: {
    default: !1,
    type: Boolean
  },
  loading: {
    default: !1,
    type: Boolean
  },
  token: { required: !0, type: String },
  withAction: {
    default: !1,
    type: Boolean
  },
  withTerms: {
    default: !1,
    type: Boolean
  }
}, Sp = {
  features: {
    default: () => fn,
    type: [Object, String]
  },
  token: { type: String }
}, Mp = {
  color: {
    default: "primary",
    type: String
  },
  dialog: {
    default: !1,
    type: Boolean
  },
  elevation: {
    default: 0,
    type: [String, Number]
  },
  size: {
    default: 0,
    type: [String, Number]
  }
}, vn = {
  adultCount: { required: !0, type: Number },
  bookingId: { type: String },
  bookingPolicyId: { required: !0, type: String },
  checkInDate: { required: !0, type: String },
  checkOutDate: { required: !0, type: String },
  emailAddress: {
    default: "",
    type: String
  },
  features: {
    default: () => Ie,
    type: [Object, String]
  },
  firstName: {
    default: "",
    type: String
  },
  hotelRoomOffer: { type: Object },
  lastName: {
    default: "",
    type: String
  },
  nationality: {
    default: "",
    type: String
  },
  organizationAddress: {
    default: "",
    type: String
  },
  organizationCity: {
    default: "",
    type: String
  },
  organizationCountry: {
    default: "",
    type: String
  },
  organizationName: {
    default: "",
    type: String
  },
  organizationState: {
    default: "",
    type: String
  },
  organizationVatNumber: {
    default: "",
    type: String
  },
  organizationZipCode: {
    default: "",
    type: String
  },
  paymentMethods: {
    default: je.CreditCard,
    type: String
  },
  phoneCountry: {
    default: "FR",
    type: String
  },
  phoneNumber: {
    default: "",
    type: String
  },
  roomCount: { required: !0, type: Number },
  salutation: {
    default: "",
    type: String
  },
  specialRequests: {
    default: "",
    type: String
  }
}, An = {
  address: {
    type: String
  },
  adultCount: {
    required: !0,
    type: Number
  },
  checkInDate: {
    required: !0,
    type: String
  },
  checkOutDate: {
    required: !0,
    type: String
  },
  children: {
    default: null,
    type: [String, null]
  },
  hotelOfferRequestId: {
    type: String
  },
  latitude: {
    required: !0,
    type: Number
  },
  longitude: {
    required: !0,
    type: Number
  },
  roomCount: {
    required: !0,
    type: Number
  },
  sourceMarket: {
    required: !0,
    type: String
  }
}, ai = {
  ...An,
  features: {
    default: () => oa,
    type: [Object, String]
  },
  height: {
    default: "600px",
    type: [Number, String]
  },
  hotelRoomOffersLimit: {
    type: Number
  },
  isLoadingBarEnabled: {
    default: !0,
    type: Boolean
  },
  limit: {
    default: Ne,
    type: Number
  },
  maxHeight: {
    default: "90vh",
    type: [Number, String]
  },
  rounded: {
    default: !0,
    type: Boolean
  }
}, ni = {
  ...An,
  features: {
    default: () => _e,
    type: [Object, String]
  },
  height: {
    default: "600px",
    type: [Number, String]
  },
  hoveredHotel: {
    default: "",
    type: String
  },
  isLoadingBarEnabled: {
    default: !0,
    type: Boolean
  },
  limit: {
    default: Ne,
    type: Number
  },
  markers: {
    default: () => [],
    type: [String, Array]
  },
  maxHeight: {
    default: "90vh",
    type: [Number, String]
  },
  venue: {
    type: [String, Object]
  }
}, ri = {
  ...ai,
  ...ni,
  features: {
    default: () => yn,
    type: [Object, String]
  },
  mapFirstOnMobile: {
    default: !0,
    type: Boolean
  }
}, Pp = {
  ...ri,
  ...ce(vn, ["bookingId"]),
  features: {
    default: () => Xo,
    type: [Object, String]
  }
}, Sn = {
  adultCount: {
    required: !0,
    type: Number
  },
  checkInDate: {
    required: !0,
    type: String
  },
  checkOutDate: {
    required: !0,
    type: String
  },
  children: {
    default: null,
    type: String
  },
  hotelId: {
    required: !0,
    type: String
  },
  hotelRoomOfferRequestId: {
    type: String
  },
  roomCount: {
    required: !0,
    type: Number
  },
  sourceMarket: {
    required: !0,
    type: String
  }
}, oi = {
  ...Sn,
  features: {
    default: () => Dn,
    type: [Object, String]
  },
  limit: {
    default: () => 0,
    type: Number
  }
}, Np = {
  features: {
    default: () => bn,
    type: [Object, String]
  },
  hotelId: { type: String }
}, ii = {
  ...Sn,
  ...ce(oi, "features"),
  features: {
    default: () => Cn,
    type: [Object, String]
  }
}, zp = {
  ...ii,
  ...ce(vn, ["bookingId", "bookingPolicyId", "hotelRoomOffer"]),
  features: {
    default: () => qo,
    type: [Object, String]
  }
}, wp = {
  elevation: {
    default: 0,
    type: [String, Number]
  }
}, Rp = {
  token: {
    required: !0,
    type: String
  }
}, Bp = {
  theme: {
    default: "light",
    type: String
  }
};
var Tp = /* @__PURE__ */ ((e) => (e.Idle = "IDLE", e.PaymentRequested = "PAYMENT_REQUESTED", e.PaymentSuccessful = "PAYMENT_SUCCESSFUL", e.Prebook = "PREBOOK", e))(Tp || {});
const Ep = {
  accent3: "#ff1744"
}, Lp = {
  lighten2: "#64b5f6"
}, Op = {
  base: "#4caf50"
}, Yp = {
  colors: {
    accent: "#f57f39",
    error: Ep.accent3,
    "on-primary": "#fff",
    "on-secondary": "#fff",
    primary: "#007fff",
    secondary: Lp.lighten2,
    success: Op.base
  }
};
var Ee = /* @__PURE__ */ ((e) => (e.Price = "price", e.Rating = "rating", e.ReviewRating = "review_rating", e.SortBy = "sort_by", e))(Ee || {});
Array.from({ length: 40 }).map(
  () => Math.floor(Math.random() * 11)
);
Ee.Rating + "", Ee.ReviewRating + "", Ee.Price + "", Ee.SortBy + "";
const Gp = (e) => {
  window.RevolugoElements = {
    ...window.RevolugoElements,
    ready: (r) => {
      const c = window.RevolugoElements?._ready;
      window.RevolugoElements._ready = () => {
        c && c(), r();
      };
    }
  };
  const a = document.createElement("script");
  a.src = e, a.type = "module", a.async = !1;
  const [n] = document.querySelectorAll("script");
  return n ? n?.parentNode?.insertBefore(a, n) : document.head.append(a), a;
}, Kp = (e) => {
  const a = (e ? process.env.ELEMENTS_NEXT_ENTRY_URL : "https://cdn.jsdelivr.net/npm/@revolugo/elements@%V/dist/revolugo.min.js").replace("%V", "6.9.5"), n = [...document.querySelectorAll("script")].find((r) => r.src.includes(a));
  return new Promise((r) => {
    if (n) {
      r(!0);
      return;
    }
    Gp(a).addEventListener("load", () => {
      r(!0);
    });
  });
}, Up = "revolugo-vue-", Fp = "revolugo-";
function V(e, a) {
  if (!e.includes(Fp))
    throw new Error(
      "Wrapped revolugo element tag name must start with 'revolugo-' prefix"
      /* WrongTagName */
    );
  return Ri({
    name: e.replace(/revolugo-/u, Up),
    props: a || {},
    setup(r, { emit: c }) {
      if (!window.RevolugoElements.ready)
        throw new Error(
          "Revolugo Elements is not loaded. Please make sure you are using Revolugo Elements plugin"
          /* NotLoaded */
        );
      window.RevolugoElements.ready(() => {
        if (!window.RevolugoElements.eventBus)
          throw new Error(
            "Revolugo Elements is not loaded. Please make sure you are using Revolugo Elements plugin"
            /* NotLoaded */
          );
        for (const u of Object.values($r))
          window.RevolugoElements.eventBus.$on(
            u,
            (s) => {
              c(u, s);
            }
          );
      });
      const d = Bi(() => {
        const u = Ba(r, ho.Param, {
          deep: !1
        });
        return Object.keys(u).reduce(
          (s, g) => (u[g] === null || u[g] === void 0 ? s[`^${g}`] = null : typeof u[g] == "object" ? s[`^${g}`] = JSON.stringify(u[g]) : s[`^${g}`] = u[g], s),
          {}
        );
      });
      return () => Ti(e, d.value);
    }
  });
}
const ti = V(
  "revolugo-bank-transfer-details",
  bp
), si = V(
  "revolugo-booking-details-sidebar",
  Dp
), li = V(
  "revolugo-booking-manager",
  Cp
), ui = V(
  "revolugo-cancellation-policies-badge",
  vp
), ci = V(
  "revolugo-cancellation-policies-list",
  ei
), di = V(
  "revolugo-credit-card-form",
  Ap
), gi = V(
  "revolugo-credit-card-payment",
  Sp
), mi = V(
  "revolugo-currency-picker-btn",
  Mp
), pi = V(
  "revolugo-full-booking-flow",
  Pp
), hi = V(
  "revolugo-hotel-description-view",
  Np
), fi = V(
  "revolugo-hotel-offers-map",
  ni
), yi = V(
  "revolugo-hotel-offers-view",
  ri
), bi = V(
  "revolugo-hotel-offer-list",
  ai
), Di = V(
  "revolugo-hotel-offer-search-menu",
  An
), Ci = V(
  "revolugo-hotel-room-offers-booking-flow",
  zp
), vi = V(
  "revolugo-hotel-room-offers-view",
  ii
), Ai = V(
  "revolugo-hotel-room-offer-list",
  oi
), Si = V(
  "revolugo-hotel-room-offer-search-menu",
  Sn
), Mi = V(
  "revolugo-lang-picker-btn",
  wp
), Pi = V(
  "revolugo-prebook-form",
  vn
), Ni = V(
  "revolugo-preferences-menu",
  yp
), zi = V(
  "revolugo-rooming-list-editor",
  Rp
), wi = V(
  "revolugo-terms-and-conditions",
  Bp
), _p = {
  RevolugoVueBankTransferDetails: ti,
  RevolugoVueBookingDetailsSidebar: si,
  RevolugoVueBookingManager: li,
  RevolugoVueCancellationPoliciesBadge: ui,
  RevolugoVueCancellationPoliciesList: ci,
  RevolugoVueCreditCardForm: di,
  RevolugoVueCreditCardPayment: gi,
  RevolugoVueCurrencyPickerBtn: mi,
  RevolugoVueFullBookingFlow: pi,
  RevolugoVueHotelDescriptionView: hi,
  RevolugoVueHotelOffersMap: fi,
  RevolugoVueHotelOffersView: yi,
  RevolugoVueHotelOfferList: bi,
  RevolugoVueHotelOfferSearchMenu: Di,
  RevolugoVueHotelRoomOffersBookingFlow: Ci,
  RevolugoVueHotelRoomOffersView: vi,
  RevolugoVueHotelRoomOfferList: Ai,
  RevolugoVueHotelRoomOfferSearchMenu: Si,
  RevolugoVueLangPickerBtn: Mi,
  RevolugoVuePrebookForm: Pi,
  RevolugoVuePreferencesMenu: Ni,
  RevolugoVueRoomingListEditor: zi,
  RevolugoVueTermsAndConditions: wi
}, ca = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RevolugoVueBankTransferDetails: ti,
  RevolugoVueBookingDetailsSidebar: si,
  RevolugoVueBookingManager: li,
  RevolugoVueCancellationPoliciesBadge: ui,
  RevolugoVueCancellationPoliciesList: ci,
  RevolugoVueCreditCardForm: di,
  RevolugoVueCreditCardPayment: gi,
  RevolugoVueCurrencyPickerBtn: mi,
  RevolugoVueFullBookingFlow: pi,
  RevolugoVueHotelDescriptionView: hi,
  RevolugoVueHotelOfferList: bi,
  RevolugoVueHotelOfferSearchMenu: Di,
  RevolugoVueHotelOffersMap: fi,
  RevolugoVueHotelOffersView: yi,
  RevolugoVueHotelRoomOfferList: Ai,
  RevolugoVueHotelRoomOfferSearchMenu: Si,
  RevolugoVueHotelRoomOffersBookingFlow: Ci,
  RevolugoVueHotelRoomOffersView: vi,
  RevolugoVueLangPickerBtn: Mi,
  RevolugoVuePrebookForm: Pi,
  RevolugoVuePreferencesMenu: Ni,
  RevolugoVueRoomingListEditor: zi,
  RevolugoVueTermsAndConditions: wi,
  default: _p
}, Symbol.toStringTag, { value: "Module" }));
async function Ip(e, a) {
  if (e.config.compilerOptions.isCustomElement = (n) => n.startsWith("revolugo-") && !n.startsWith("revolugo-vue"), window.RevolugoElements = window.RevolugoElements || {}, !a)
    throw new Error("Revolugo Vue3 Plugin: config is required");
  if (window.RevolugoElements.config = a, await Kp(a.next), a.installComponents)
    for (const n in ca)
      n !== "default" && e.component(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ca[n].name,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ca[n]
      );
}
const $p = { install: Ip };
export {
  Tp as BookingState,
  $r as Event,
  $p as RevolugoElementsPlugin,
  ti as RevolugoVueBankTransferDetails,
  si as RevolugoVueBookingDetailsSidebar,
  li as RevolugoVueBookingManager,
  ui as RevolugoVueCancellationPoliciesBadge,
  ci as RevolugoVueCancellationPoliciesList,
  di as RevolugoVueCreditCardForm,
  gi as RevolugoVueCreditCardPayment,
  mi as RevolugoVueCurrencyPickerBtn,
  pi as RevolugoVueFullBookingFlow,
  hi as RevolugoVueHotelDescriptionView,
  bi as RevolugoVueHotelOfferList,
  Di as RevolugoVueHotelOfferSearchMenu,
  fi as RevolugoVueHotelOffersMap,
  yi as RevolugoVueHotelOffersView,
  Ai as RevolugoVueHotelRoomOfferList,
  Si as RevolugoVueHotelRoomOfferSearchMenu,
  Ci as RevolugoVueHotelRoomOffersBookingFlow,
  vi as RevolugoVueHotelRoomOffersView,
  Mi as RevolugoVueLangPickerBtn,
  Pi as RevolugoVuePrebookForm,
  Ni as RevolugoVuePreferencesMenu,
  zi as RevolugoVueRoomingListEditor,
  wi as RevolugoVueTermsAndConditions,
  Yp as lightTheme
};
//# sourceMappingURL=elements-vue3.es.js.map
